<template>
  <v-card id="table-firebase">
    <v-card-title id="card-title" ref="card-title">
      <v-checkbox
        :value="selectedAll"
        color="#6ec39b"
        class="btn-choose"
        :label="`เลือก ${selectedList.length} ฉบับ `"
        @change="clickSelectedAll($event)"
      ></v-checkbox>

      <button
        v-if="selectedList?.length > 0"
        class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
        style="font-size: 0.875rem"
        @click="clearAllSelectList"
      >
        ยกเลิกการเลือก
      </button>

      <!-- Which toolbar belongs here — Thai e-Tax or Lao TaxRIS — is only known
           once ProductList/PSC has been read. Hold the row with skeletons until
           then, so a Lao page does not paint a full row of Thai buttons and
           then drop them. -->
      <div
        v-if="isProductListLoading"
        class="tw-flex tw-items-center"
        aria-hidden="true"
      >
        <v-skeleton-loader
          v-for="n in 5"
          :key="n"
          type="button"
          class="mr-4"
        ></v-skeleton-loader>
      </div>

      <v-btn
        v-if="showThaiEtaxTools"
        text
        :color="
          selectedList.filter((x) => !x.xmlUrl).length > 0
            ? '#c9242b'
            : '#6ec39b'
        "
        @click.prevent="downloadXML"
        :disabled="
          selectedList.length < 1 ||
          downloadingXml ||
          isCompanySuspended ||
          selectedList.filter((x) => x.xmlUrl).length < 1
        "
        :loading="downloadingXml"
      >
        <img
          :src="
            selectedList.filter((x) => !x.xmlUrl).length > 0 &&
            selectedList.filter((x) => x.xmlUrl).length >= 1
              ? '/images/icons/icon_download_xml_red.svg'
              : '/images/icons/icon_download_xml.svg'
          "
          style="max-height: 26px; max-width: 26px"
          class="mr-2"
        />
        <span
          >ดาวน์โหลด XML
          {{ `(${selectedList.filter((x) => x.xmlUrl).length})` }}</span
        >
        <template v-if="downloadStatus.xml.progress" v-slot:loader>
          <v-progress-circular
            class="mr-2"
            indeterminate
            size="24"
          ></v-progress-circular>
          <span>{{ downloadStatus.xml.progress }}</span>
        </template>
      </v-btn>
      <v-btn
        v-if="showThaiEtaxTools"
        text
        :color="
          selectedList.filter((x) => !x.pdfUrl).length > 0
            ? '#c9242b'
            : '#6ec39b'
        "
        @click.prevent="downloadPDF"
        :disabled="
          selectedList.length < 1 ||
          downloadingPdf ||
          isCompanySuspended ||
          selectedList.filter((x) => x.pdfUrl).length < 1
        "
        :loading="downloadingPdf"
      >
        <img
          :src="
            selectedList.filter((x) => !x.xmlUrl).length > 0 &&
            selectedList.filter((x) => x.xmlUrl).length >= 1
              ? '/images/icons/icon_download_pdf_red.svg'
              : '/images/icons/icon_download_pdf.svg'
          "
          style="max-height: 26px; max-width: 26px"
          class="mr-2"
        />
        <span
          >ดาวน์โหลด PDF
          {{ `(${selectedList.filter((x) => x.pdfUrl).length})` }}</span
        >
        <template v-if="downloadStatus.pdf.progress" v-slot:loader>
          <v-progress-circular
            class="mr-2"
            indeterminate
            size="24"
          ></v-progress-circular>
          <span>{{ downloadStatus.pdf.progress }}</span>
        </template>
      </v-btn>
      <v-btn
        v-if="showThaiEtaxTools"
        text
        color="#6ec39b"
        @click.prevent="monthlyDownloadDialog = true"
        :disabled="downloadStatus.monthly.downloading || isCompanySuspended"
        :loading="downloadStatus.monthly.downloading"
      >
        <img
          src="/images/icons/icon_download_pdf.svg"
          style="max-height: 26px; max-width: 26px"
          class="mr-2"
        />
        <span>ดาวน์โหลด รายเดือน </span>
        <template v-if="downloadStatus.monthly.progress" v-slot:loader>
          <v-progress-circular
            class="mr-2"
            indeterminate
            size="24"
          ></v-progress-circular>
          <span>{{ downloadStatus.monthly.progress }}</span>
        </template>
      </v-btn>
      <monthly-download-dialog
        v-if="showThaiEtaxTools"
        :companyID="companyID"
        :documentTypeKey="documentTypeKey"
        v-model="monthlyDownloadDialog"
        @confirm="downloadMonthly"
      />

      <v-dialog
        v-if="showThaiEtaxTools"
        v-model="emailDialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              :disabled="isBtnDisabled || selectedList.length <= 0 || isCompanySuspended"
              @click="getEmailList"
              text
              @mouseover="selectedList.length > 0 ? (sentEmailHover = true) : null"
              @mouseleave="selectedList.length > 0 ? (sentEmailHover = false) : null"
              v-bind="attrs"
              v-on="on"
              class="tw-px-4 tw-py-2 tw-rounded-md tw-relative"
              style="font-size: 0.875rem"
              v-bind:class="(!isBtnDisabled && selectedList.length > 0) ? 'tw-text-light-green hover:tw-bg-light-green hover:tw-text-white' : 'disabled-btn'"
            >
              <img
                src="/images/icons/icon _send_email.svg"
                class="tw-float-left tw-mr-2"
                v-if="!sentEmailHover"
              />
              <img
                src="/images/icons/icon _send_email_white.svg"
                class="tw-float-left tw-mr-2"
                v-if="sentEmailHover"
              />
              ส่งอีเมล
            </v-btn>


        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card>
              <v-card-title>
                <b>ส่งอีเมล</b>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row v-for="(v, k) in emailList" v-bind:key="k">
                    <v-col style="max-width: 25%">{{ k }}</v-col>
                    <v-col>
                      <v-autocomplete
                        :ref="'autocomplete' + k"
                        v-model="emailList[k]"
                        :items="emailList[k]"
                        :rules="emailRules"
                        outlined
                        dense
                        chips
                        deletable-chips
                        small-chips
                        label="กรุณากรอกอีเมล"
                        multiple
                        hide-selected
                        append-icon
                        hide-no-data
                        @keydown.tab.prevent="
                          autocompleteAddEmail(k, $event.target.value)
                        "
                        @keydown.enter.prevent="
                          autocompleteAddEmail(k, $event.target.value)
                        "
                        :search-input.sync="emailInput"
                        @blur="autocompleteAddEmail(k, $event.target.value)"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="max-width: 25%">อีเมล template</v-col>
                    <v-col>
                      <v-select
                        v-model="mEmailTemplateID"
                        :items="mEmailTemplatesIDList"
                        label="Email Template ID"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="clearEmailList"
                  :disabled="sendEmailLoading"
                >
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  :disabled="sendEmailLoading"
                  @click="validateEmail"
                >
                  <img
                    src="/images/icons/icon_send_email.svg"
                    style="max-height: 26px; max-width: 26px"
                    class="mr-2"
                  />
                  <b>ส่งอีเมล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>
      <!-- minToDate:: {{ minToDate }} -->
      <v-dialog
        v-if="showThaiEtaxTools"
        v-model="exportDialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <button
            v-bind="attrs"
            v-on="on"
            :disabled="isCompanySuspended"
            :class="[
              'tw-px-4 tw-py-2 tw-rounded-md tw-relative',
              isCompanySuspended ? 'disabled-btn' : 'tw-text-light-green hover:tw-bg-light-green hover:tw-text-white',
            ]"
            style="font-size: 0.875rem"
          >
            ส่งออกข้อมูล
          </button>
        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card>
              <v-card-title>
                <b>ส่งออกข้อมูล</b>
              </v-card-title>
              <v-card-text>
                <v-menu
                  v-model="menuDatePickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportStart"
                      label="วันที่เอกสารเริ่มต้น"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExportStart"
                    @input="menuDatePickerStart = false"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="menuDatePickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateExportEnd"
                      label="วันที่เอกสารสิ้นสุด"
                      append-icon="mdi-keyboard_arrow_down"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateExportEnd"
                    @input="menuDatePickerEnd = false"
                  ></v-date-picker>
                </v-menu>
                <v-radio-group v-model="exportEmailStatusRadios" row>
                  <template v-slot:label>
                    <div>สถานะการส่งอีเมล</div>
                  </template>
                  <v-radio value="All">
                    <template v-slot:label>
                      <div>ทั้งหมด</div>
                    </template>
                  </v-radio>
                  <v-radio value="Sent">
                    <template v-slot:label>
                      <div>ส่งแล้ว</div>
                    </template>
                  </v-radio>
                  <v-radio value="NotSent">
                    <template v-slot:label>
                      <div>ยังไม่ส่ง</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancelExportDialog">
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  :loading="exportLoading"
                  :disabled="!dateExportStart || !dateExportEnd || exportLoading"
                  @click="exportDocs"
                >
                  <b>ส่งออกข้อมูล</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

      <button
        v-if="enableCsvUploadHistory && showThaiEtaxTools"
        @click="goToUploadHistory"
        class="tw-px-4 tw-py-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
        style="font-size: 0.875rem"
      >
        <v-icon small class="mr-2">mdi-history</v-icon>
        ประวัติการอัปโหลด
      </button>

      <v-dialog
        v-if="showThaiEtaxTools"
        v-model="importDialog"
        persistent
        max-width="650px"
      >
        <template v-slot:activator="{ attrs }">
          <button
            v-bind="attrs"
            @click="onOpenImportDialog"
            :disabled="isCompanySuspended"
            :class="[
              'tw-px-4 tw-py-2 tw-rounded-md tw-relative',
              isCompanySuspended ? 'disabled-btn' : 'tw-text-light-green hover:tw-bg-light-green hover:tw-text-white',
            ]"
            style="font-size: 0.875rem"
          >
            นำเข้าข้อมูล
          </button>
        </template>
        <template>
          <v-form ref="form" v-model="emailValid">
            <v-card class="import-dialog-card" elevation="0" style="border-radius: 16px; overflow: hidden;">
              <v-card-title>
                <b>นำเข้าข้อมูล CSV</b>
              </v-card-title>
              <v-container v-if="alert.show && alert.showOnDialog == true">
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      v-model="alert.show"
                      :type="alert.type"
                      transition="scale-transition"
                      dismissible
                      >{{ alert.text }}</v-alert
                    >
                  </v-col>
                </v-row>
              </v-container>
              <v-card-text class="pa-8" style="background-color: #fafbfc;">
                <!-- Network Status -->
                <v-alert
                  dense
                  text
                  :color="networkStatus.status === 'connected' ? '#6ec39b' : (networkStatus.status ? '#c9242b' : '#9e9e9e')"
                  class="mb-6"
                  style="border-radius: 8px;"
                >
                  <div class="d-flex align-center">
                    <v-icon
                      :color="networkStatus.status === 'connected' ? '#6ec39b' : (networkStatus.status ? '#c9242b' : '#9e9e9e')"
                      size="20"
                      class="mr-2"
                    >
                      {{ networkStatus.status === 'connected' ? 'mdi-check-circle' : (networkStatus.status ? 'mdi-alert-circle' : 'mdi-wifi') }}
                    </v-icon>
                    <span class="text-body-2 flex-grow-1">
                      {{ networkStatus.status === 'connected' ? 'การเชื่อมต่อพร้อมใช้งาน' :
                         (networkStatus.status ? networkStatus.message || 'ไม่สามารถเชื่อมต่อได้' : 'ตรวจสอบการเชื่อมต่อ') }}
                    </span>
                    <v-btn
                      x-small
                      text
                      :color="networkStatus.status === 'connected' ? '#6ec39b' : '#9e9e9e'"
                      @click="performNetworkCheck"
                      :loading="checkingNetwork"
                      style="text-transform: none;"
                    >
                      <v-icon x-small class="mr-1">mdi-refresh</v-icon>
                      ตรวจสอบ
                    </v-btn>
                  </div>
                </v-alert>

                <!-- Template Selection -->
                <v-radio-group
                  v-if="companyDetail.uploadTemplate2File"
                  v-model="selectedTemp"
                  class="mb-6"
                >
                  <div class="text-subtitle-1 font-weight-bold mb-3" style="color: #2c3e50;"></div>
                  <v-row>
                    <v-col cols="6">
                      <v-card
                        @click="handleTemp('template-1')"
                        :style="{
                          cursor: 'pointer',
                          border: selectedTemp === 'template-1' ? '2px solid #6ec39b' : '2px solid #e0e0e0',
                          background: selectedTemp === 'template-1' ? '#e8f5f0' : 'white',
                          borderRadius: '8px',
                        }"
                        elevation="0"
                      >
                        <v-card-text class="pa-3">
                          <div class="d-flex align-center">
                            <v-icon :color="selectedTemp === 'template-1' ? '#6ec39b' : '#9e9e9e'" size="20" class="mr-2">
                              mdi-file-delimited
                            </v-icon>
                            <div class="flex-grow-1">
                              <v-radio
                                label="เทมเพลต 1"
                                value="template-1"
                                id="template-1"
                                color="#6ec39b"
                                hide-details
                              ></v-radio>
                            </div>
                          </div>
                          <!-- <div class="text-caption ml-7" style="color: #707070;">ไฟล์ CSV เดียว</div> -->
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card
                        @click="handleTemp('template-2')"
                        :style="{
                          cursor: 'pointer',
                          border: selectedTemp === 'template-2' ? '2px solid #6ec39b' : '2px solid #e0e0e0',
                          background: selectedTemp === 'template-2' ? '#e8f5f0' : 'white',
                          borderRadius: '8px',
                        }"
                        elevation="0"
                      >
                        <v-card-text class="pa-3">
                          <div class="d-flex align-center">
                            <v-icon :color="selectedTemp === 'template-2' ? '#6ec39b' : '#9e9e9e'" size="20" class="mr-2">
                              mdi-file-multiple
                            </v-icon>
                            <div class="flex-grow-1">
                              <v-radio
                                label="เทมเพลต 2"
                                value="template-2"
                                id="template-2"
                                color="#6ec39b"
                                hide-details
                              ></v-radio>
                            </div>
                          </div>
                          <!-- <div class="text-caption ml-7" style="color: #707070;">2 ไฟล์ (หัว + เนื้อหา)</div> -->
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-radio-group>
                <!-- Template 1: Single File -->
                <div
                  class="tmp-1"
                  :style="{ display: temp1Hiden ? 'none' : 'block' }"
                >
                  <div class="mt-4">
                    <!-- <div class="text-subtitle-1 font-weight-bold mb-3" style="color: #2c3e50;">ส่วนหัว</div> -->
                    <v-file-input
                      ref="importFileRef"
                      v-model="template1"
                      clearable
                      label="File Input"
                      hint=""
                      persistent-hint
                      color="#6ec39b"
                      outlined
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-delimited-outline"
                      placeholder="คลิกหรือลากไฟล์มาวาง"
                      @change="handleImportFile"
                      accept=".csv"
                    >
                      <template v-slot:append>
                        <v-chip v-if="template1" x-small color="#6ec39b" text-color="white">
                          {{ (template1.size / 1024).toFixed(2) }} KB
                        </v-chip>
                      </template>
                      <template v-slot:selection="{ text }">
                        <v-chip small color="#6ec39b" text-color="white">
                          <v-icon x-small left>mdi-check</v-icon>
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </div>
                </div>

                <!-- Template 2: Head + Line Files -->
                <div
                  class="tmp-2"
                  :style="{ display: temp2Hiden ? 'none' : 'block' }"
                >
                  <div class="mt-4">
                    <div class="text-subtitle-1 font-weight-bold mb-3" style="color: #2c3e50;">ส่วนหัว</div>

                    <!-- Header File -->
                    <v-file-input
                      ref="importFileRefH"
                      v-model="templateh"
                      label="File Input"
                      hint=""
                      persistent-hint
                      color="#6ec39b"
                      outlined
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-document-outline"
                      placeholder="คลิกหรือลากไฟล์มาวาง"
                      @change="handleImportFileTemp2('head', $event)"
                      accept=".csv"
                      class="mb-4"
                    >
                      <template v-slot:append>
                        <v-chip v-if="templateh" x-small color="#6ec39b" text-color="white">
                          {{ (templateh.size / 1024).toFixed(2) }} KB
                        </v-chip>
                      </template>
                      <template v-slot:selection="{ text }">
                        <v-chip small color="#6ec39b" text-color="white">
                          <v-icon x-small left>mdi-check</v-icon>
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>

                    <!-- Lines File -->
                    <div class="text-subtitle-1 font-weight-bold mb-3" style="color: #2c3e50;">ส่วนเนื้อใน</div>
                    <v-file-input
                      ref="importFileRefL"
                      v-model="templatel"
                      label="File input"
                      hint=""
                      persistent-hint
                      color="#6ec39b"
                      outlined
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-table-outline"
                      placeholder="คลิกหรือลากไฟล์มาวาง"
                      @change="handleImportFileTemp2('line', $event)"
                      accept=".csv"
                    >
                      <template v-slot:append>
                        <v-chip v-if="templatel" x-small color="#6ec39b" text-color="white">
                          {{ (templatel.size / 1024).toFixed(2) }} KB
                        </v-chip>
                      </template>
                      <template v-slot:selection="{ text }">
                        <v-chip small color="#6ec39b" text-color="white">
                          <v-icon x-small left>mdi-check</v-icon>
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </div>
                </div>
              </v-card-text>
              <!-- Import quota alert -->
              <v-container v-if="importQuotaStatus" class="px-8 pt-2 pb-0">
                <v-alert
                  dense
                  outlined
                  :color="importQuotaStatus === 'exceeded' ? '#c9242b' : '#e07b20'"
                  :icon="importQuotaStatus === 'exceeded' ? 'mdi-block-helper' : importQuotaStatus === 'full' ? 'mdi-check-circle-outline' : 'mdi-alert'"
                  class="mb-0"
                  style="border-radius: 8px; font-size: 13px;"
                >
                  <div v-if="importQuotaStatus === 'exceeded'">
                    <b>ไม่สามารถนำเข้าได้ — เกินขีดจำกัดของแพ็คเกจ</b><br />
                    โควต้าคงเหลือ {{ ((paymentDetail.docsPerMonth || 0) - (companyUsage.countsDocsAll || 0)).toLocaleString() }} ฉบับ
                    แต่ไฟล์นี้มี {{ importDocCount.toLocaleString() }} ฉบับ
                    (ใช้ไปแล้ว {{ (companyUsage.countsDocsAll || 0).toLocaleString() }} จาก {{ (paymentDetail.docsPerMonth || 0).toLocaleString() }} ฉบับ)
                    <br />กรุณาติดต่อฝ่ายขาย โทร <a href="tel:0661105989" style="color: inherit; font-weight: bold;">066-110-5989</a>
                  </div>
                  <div v-else-if="importQuotaStatus === 'full'">
                    <b>หลังจากนำเข้าครั้งนี้โควต้าของคุณจะหมดพอดี</b><br />
                    ใช้ครบ {{ (paymentDetail.docsPerMonth || 0).toLocaleString() }} ฉบับ — หากต้องการนำเข้าเพิ่มเติมในเดือนนี้
                    กรุณาติดต่อฝ่ายขาย โทร <a href="tel:0661105989" style="color: inherit; font-weight: bold;">066-110-5989</a>
                  </div>
                  <div v-else>
                    <b>ใกล้ถึงขีดจำกัดของแพ็คเกจ</b><br />
                    หลังนำเข้าครั้งนี้จะใช้ไป
                    {{ ((companyUsage.countsDocsAll || 0) + importDocCount).toLocaleString() }}
                    จาก {{ (paymentDetail.docsPerMonth || 0).toLocaleString() }} ฉบับ
                    ({{ Math.round(((companyUsage.countsDocsAll || 0) + importDocCount) / (paymentDetail.docsPerMonth || 1) * 100) }}%)
                    — เหลืออีก {{ ((paymentDetail.docsPerMonth || 0) - (companyUsage.countsDocsAll || 0) - importDocCount).toLocaleString() }} ฉบับ
                  </div>
                </v-alert>
              </v-container>

              <v-card-actions>
                <v-btn
                  v-if="enableCsvUploadHistory"
                  text
                  color="info"
                  @click="goToUploadHistory"
                  :disabled="uploadingCSV"
                >
                  <v-icon small class="mr-2">mdi-history</v-icon>
                  ดูประวัติ
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="cancelImportDialog"
                  :disabled="uploadingCSV"
                >
                  <v-icon large>mdi-close-circle-outline</v-icon>
                  <b>ยกเลิก</b>
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  type="button"
                  class="btn-submit"
                  @click="importDocs"
                  :loading="uploadingCSV"
                  :disabled="uploadingCSV || isQuotaExceeded || importQuotaStatus === 'exceeded'"
                >
                  <v-icon v-if="!uploadingCSV" class="mr-2">mdi-cloud-upload</v-icon>
                  <b v-if="!uploadingCSV">{{ (isQuotaExceeded || importQuotaStatus === 'exceeded') ? 'เกินโควต้า' : 'นำเข้าข้อมูล' }}</b>
                  <b v-if="uploadingCSV">กำลังอัปโหลด...</b>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>
      
      <!-- Dialog แสดง Upload Log ล่าสุด -->
      <v-dialog
        v-if="showThaiEtaxTools"
        v-model="showUploadLogDialog"
        max-width="900"
      >
        <upload-log-viewer
          :log="currentUploadLog"
          @close="showUploadLogDialog = false"
        />
      </v-dialog>
      
      <v-btn
        v-if="showThaiEtaxTools"
        text
        :color="
          selectedList.filter((x) => !x.downloadedXml).length > 0
            ? '#c9242b'
            : '#6ec39b'
        "
        @click.prevent="() => clearDownloadedXml()"
        :disabled="
          selectedList.length < 1 ||
          clearingDownloadedXml ||
          selectedList.filter((x) => x.downloadedXml).length < 1
        "
        :loading="clearingDownloadedXml"
      >
        <span
          >ยกเลิกค่าดาวน์โหลด
          {{ `(${selectedList.filter((x) => x.downloadedXml).length})` }}</span
        >
      </v-btn>

      <v-dialog v-model="confirmCancelDocDialog" persistent max-width="520px">
        <v-card>
          <v-card-title>
            <b>ยืนยันการยกเลิกเอกสาร</b>
          </v-card-title>
          <v-card-text>
            <p class="tw-mb-2">
              เอกสารที่เลือก ({{ selectedList.length }} รายการ)
              จะถูกย้ายไปที่ <b>ใบแจ้งยกเลิก</b>
              และจะหายไปจากแท็บปัจจุบัน
            </p>
            <p class="tw-text-gray-500 tw-mb-0" style="font-size: 13px">
              หากกดผิดใบ กู้คืนได้ที่แท็บ <b>ใบแจ้งยกเลิก</b>
              ด้วยปุ่ม "กู้คืนเอกสาร"
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="cancelDocLoading"
              @click="confirmCancelDocDialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="#c9242b"
              dark
              :loading="cancelDocLoading"
              @click="cancelDocs"
              >ยืนยันยกเลิกเอกสาร</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmRestoreDocDialog" persistent max-width="560px">
        <v-card>
          <v-card-title>
            <b>ยืนยันการกู้คืนเอกสาร</b>
          </v-card-title>
          <v-card-text>
            <p class="tw-mb-2">
              เอกสารที่เลือก ({{ selectedList.length }} รายการ)
              จะถูกคืนกลับไปเป็น<b>ประเภทเดิม</b>ก่อนถูกยกเลิก
              และจะหายไปจากแท็บนี้
            </p>
            <p class="tw-mb-2">
              ระบบใช้ค่า <b>@OriginalDocType</b>
              ที่บันทึกไว้ตอนกดยกเลิกเท่านั้น เอกสารที่ไม่มีค่านี้
              (ใบแจ้งยกเลิกที่นำเข้ามาเป็นใบแจ้งยกเลิกตั้งแต่ต้น)
              จะถูกข้ามโดยอัตโนมัติ
            </p>
            <p class="tw-text-gray-500 tw-mb-0" style="font-size: 13px">
              ไฟล์ XML/PDF ที่เซ็นแล้ว ยอดเงิน วันที่เอกสาร
              และเลขที่เอกสาร ไม่ถูกแตะต้อง
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="restoreDocLoading"
              @click="confirmRestoreDocDialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="#6ec39b"
              dark
              :loading="restoreDocLoading"
              @click="restoreDocs"
              >ยืนยันกู้คืนเอกสาร</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmClearSignedDialog" persistent max-width="520px">
        <v-card>
          <v-card-title>
            <b>ยืนยันการอัปเดทเอกสาร</b>
          </v-card-title>
          <v-card-text>
            <p class="tw-mb-2">
              จะลบค่าใน <b>@SignedPdfPath</b>, <b>@SignedPdfUrl</b>,
              <b>@SignedXmlPath</b>, <b>@SignedXmlUrl</b>
              ของเอกสารที่เลือก ({{ selectedList.length }} รายการ) ให้เป็นค่าว่าง
            </p>
            <p class="tw-text-light-red tw-mb-0">
              เอกสารจะกลับไปอยู่ในสถานะยังไม่ถูกเซ็น
              การกระทำนี้ไม่สามารถย้อนกลับได้
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="clearingSignedFiles"
              @click="confirmClearSignedDialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="orange"
              dark
              :loading="clearingSignedFiles"
              @click="clearSignedFiles"
              >ยืนยันอัปเดท</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- //TaxRIS -->
      <!--
        Legacy Lao TaxRIS send (sendDoc -> the old TaxRIS mediation host over
        plain HTTP). Hidden behind showLegacyLaoTaxRis rather than removed while
        the new pipeline goes live. It must not sit next to "นำส่งใบกำกับภาษี":
        it writes only @DocSent, never any @LaoEtax* field, so a document sent
        this way still reads "ยังไม่นำส่ง" everywhere — in the status column, in
        laoBackdateReport, and to the retry affordance. Same treatment as
        table.abb.vue. Remove once confirmed unneeded.
      -->
      <v-dialog
        v-if="showLegacyLaoTaxRis"
        v-model="taxRisDialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <button
            :disabled="selectedList.length <= 0"
            @mouseover="
              selectedList.length > 0 ? (sentTaxRisHover = true) : null
            "
            @mouseleave="
              selectedList.length > 0 ? (sentTaxRisHover = false) : null
            "
            @click="getTaxRisList"
            v-bind="attrs"
            v-on="on"
            class="tw-px-4 tw-py-2 tw-rounded-md tw-relative"
            style="font-size: 0.875rem"
            v-bind:class="
              selectedList.length > 0
                ? 'tw-text-light-green hover:tw-bg-light-green hover:tw-text-white'
                : 'disabled-btn'
            "
          >
            <img
              src="/images/icons/invoice_la.png"
              height="26px"
              width="26px"
              class="tw-float-left tw-mr-2"
              v-show="!sentTaxRisHover"
            />
            <img
              src="/images/icons/invoice_la_white.png"
              class="tw-float-left tw-mr-2"
              height="26px"
              width="26px"
              v-show="sentTaxRisHover"
            />
            <span>ส่งกรมสรรพากรลาว ({{ selectedList.length }})</span>
          </button>
        </template>
        <template v-slot:default>
          <v-form ref="form" v-model="taxRisValid">
            <v-card>
              <v-progress-linear
                v-if="sendTaxRisLoading"
                indeterminate
                color="#6ec39b"
                height="3"
              />
              <v-card-title class="tw-flex tw-items-center tw-gap-2">
                <img src="/images/icons/lao_tax.jpg" height="24px" width="24px" />
                ส่งกรมสรรพากรลาว
                <v-spacer />
                <span class="tw-text-sm tw-font-normal tw-text-gray-500">
                  {{ taxRisList.length }} เอกสาร
                </span>
              </v-card-title>
              <v-divider />
              <div class="tw-px-6 tw-pt-4 tw-pb-2">
                <div class="tw-flex tw-border tw-border-gray-300 tw-rounded-t tw-bg-gray-50 tw-py-2 tw-pl-2 tw-text-sm tw-font-medium tw-text-gray-600">
                  <div class="tw-w-12 tw-shrink-0">ลำดับ</div>
                  <div>เลขที่เอกสาร</div>
                </div>
                <div
                  style="max-height: 300px; overflow-y: auto"
                  class="tw-border tw-border-t-0 tw-border-gray-300 tw-rounded-b"
                >
                  <div
                    v-for="(item, index) in taxRisList"
                    :key="item.docID"
                    class="tw-flex tw-py-2 tw-pl-2 tw-text-sm tw-border-t tw-border-gray-200"
                  >
                    <div class="tw-w-12 tw-shrink-0 tw-text-gray-400">{{ index + 1 }}</div>
                    <div>{{ item["docID"] }}</div>
                  </div>
                </div>
              </div>
              <div v-if="taxRisAlert.show" class="tw-px-6 tw-pb-2 tw-space-y-2">
                <div v-if="taxRisAlert.errors.length > 0" class="tw-rounded tw-border tw-border-red-300 tw-bg-red-50">
                  <div class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-bg-red-100 tw-rounded-t">
                    <v-icon small color="error">mdi-close-circle</v-icon>
                    <span class="tw-text-sm tw-font-medium tw-text-red-700">
                      ข้อผิดพลาด {{ taxRisAlert.errors.length }} รายการ — ไม่สามารถส่งได้
                    </span>
                    <v-spacer />
                    <v-icon small class="tw-cursor-pointer tw-text-red-400" @click="taxRisAlert = { show: false, errors: [], warnings: [] }">mdi-close</v-icon>
                  </div>
                  <div style="max-height: 140px; overflow-y: auto">
                    <div
                      v-for="(msg, i) in taxRisAlert.errors"
                      :key="'e' + i"
                      class="tw-flex tw-gap-2 tw-px-3 tw-py-1 tw-text-xs tw-text-red-700 tw-border-t tw-border-red-200"
                    >
                      <v-icon x-small color="error" class="tw-mt-px tw-shrink-0">mdi-alert-circle-outline</v-icon>
                      <span>{{ msg }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="taxRisAlert.warnings.length > 0" class="tw-rounded tw-border tw-border-yellow-300 tw-bg-yellow-50">
                  <div class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-bg-yellow-100 tw-rounded-t">
                    <v-icon small color="warning">mdi-alert</v-icon>
                    <span class="tw-text-sm tw-font-medium tw-text-yellow-800">
                      คำเตือน {{ taxRisAlert.warnings.length }} รายการ
                      <span v-if="taxRisAlert.errors.length === 0"> — ยังสามารถส่งได้</span>
                    </span>
                  </div>
                  <div style="max-height: 120px; overflow-y: auto">
                    <div
                      v-for="(msg, i) in taxRisAlert.warnings"
                      :key="'w' + i"
                      class="tw-flex tw-gap-2 tw-px-3 tw-py-1 tw-text-xs tw-text-yellow-800 tw-border-t tw-border-yellow-200"
                    >
                      <v-icon x-small color="warning" class="tw-mt-px tw-shrink-0">mdi-alert-outline</v-icon>
                      <span>{{ msg }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="clearTaxRisList" :disabled="sendTaxRisLoading">
                  <v-icon left>mdi-close-circle-outline</v-icon>
                  ยกเลิก
                </v-btn>
                <v-btn
                  text
                  color="#6ec39b"
                  :disabled="sendTaxRisLoading"
                  @click="sendTaxRIS"
                >
                  <v-progress-circular
                    v-if="sendTaxRisLoading"
                    indeterminate
                    size="18"
                    width="2"
                    color="#6ec39b"
                    class="mr-2"
                  />
                  <img
                    v-else
                    src="/images/icons/invoice_la.png"
                    style="max-height: 20px; max-width: 20px"
                    class="mr-2"
                  />
                  {{ sendTaxRisLoading ? 'กำลังส่ง...' : 'ส่ง' }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </template>
      </v-dialog>

      <!-- Issue Lao eTax invoice (5.2 issueInvoice) -->
      <v-dialog
        v-if="isLaoRtActive"
        v-model="laoIssueDialog"
        persistent
        max-width="720px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            text
            color="#6ec39b"
            class="tw-ml-2"
          >
            <v-icon left>mdi-file-send-outline</v-icon>
            นำส่ง{{ laoDocNoun }} ({{ laoSendableCount }})
          </v-btn>
        </template>
        <v-card>
          <v-progress-linear
            v-if="laoIssueLoading"
            indeterminate
            color="#6ec39b"
            height="3"
          />
          <v-card-title class="tw-flex tw-items-center tw-gap-2">
            <img src="/images/icons/lao_tax.jpg" height="24px" width="24px" />
            นำส่ง{{ laoDocNoun }}
            <v-spacer />
            <span class="tw-text-xs tw-font-normal tw-text-gray-500">
              issueInvoice (5.2)
            </span>
          </v-card-title>
          <v-divider />
          <div class="tw-px-6 tw-py-4">
            <!-- Mock sends a canned payload with a fake TIN; the backend
                 restricts it to staff and forces dry-run on prod. -->
            <v-switch
              v-if="canUseDevTools"
              v-model="laoIssueUseMock"
              :disabled="laoIssueLoading"
              color="#6ec39b"
              hide-details
              class="tw-mt-0"
            >
              <template v-slot:label>
                <span class="tw-text-sm">
                  ใช้ข้อมูล mock (Postman sample)
                  <span class="tw-text-xs tw-text-gray-500 tw-ml-1">
                    — สำหรับทดสอบการเชื่อมต่อแบบ end-to-end
                  </span>
                </span>
              </template>
            </v-switch>

            <div v-if="laoIssueUseMock" class="tw-mt-4 tw-space-y-3">
              <div class="tw-grid tw-grid-cols-2 tw-gap-3">
                <v-text-field
                  v-model="laoIssueCode"
                  label="Issue Code (Supplier TIN)"
                  placeholder="1234567890"
                  outlined
                  dense
                  hide-details
                  :disabled="laoIssueLoading"
                />
                <v-text-field
                  v-model="laoBuyerCode"
                  label="Buyer Code"
                  placeholder="8765678987656"
                  outlined
                  dense
                  hide-details
                  :disabled="laoIssueLoading"
                />
              </div>
              <div class="tw-text-xs tw-text-gray-500">
                จะสร้าง <code>serialNum</code> ใหม่ทุกครั้งและส่งใบกำกับภาษีตัวอย่าง 1 ใบ
                (100.00 + VAT 10.00). issueType = 0
              </div>
              <details class="tw-border tw-rounded tw-bg-gray-50">
                <summary class="tw-px-3 tw-py-2 tw-text-xs tw-text-gray-600 tw-cursor-pointer">
                  ดูตัวอย่าง payload
                </summary>
                <pre
                  class="tw-px-3 tw-py-2 tw-text-xs tw-overflow-auto"
                  style="max-height: 200px; white-space: pre-wrap; word-break: break-word;"
                >{{ laoIssueMockPreview }}</pre>
              </details>
            </div>

            <div v-else class="tw-mt-4 tw-space-y-3">
              <div
                v-if="selectedList.length < 1"
                class="tw-px-3 tw-py-3 tw-rounded tw-border tw-border-gray-300 tw-bg-gray-50 tw-text-sm tw-text-gray-600 tw-flex tw-items-start tw-gap-2"
              >
                <v-icon small class="tw-mt-px tw-shrink-0" color="grey">mdi-information-outline</v-icon>
                <span>เลือกเอกสารจากตารางก่อน แล้วจึงนำส่ง{{ laoDocNoun }}</span>
              </div>
              <template v-else>
                <div class="tw-flex tw-items-center tw-text-sm tw-font-medium tw-text-gray-600">
                  เอกสารที่เลือก ({{ selectedList.length }} ฉบับ)
                  <span
                    v-if="laoSkippedCount > 0"
                    class="tw-ml-2 tw-text-xs tw-font-normal tw-text-gray-500"
                  >
                    — ส่ง {{ laoSendableCount }}, ข้าม {{ laoSkippedCount }}
                  </span>
                  <v-spacer />
                  <span
                    v-if="laoIssueLoading && laoIssueProgress.total"
                    class="tw-text-xs tw-font-normal tw-text-gray-500"
                  >
                    กำลังส่ง {{ laoIssueProgress.current }}/{{ laoIssueProgress.total }}
                  </span>
                </div>
                <div
                  style="max-height: 200px; overflow-y: auto"
                  class="tw-border tw-border-gray-300 tw-rounded"
                >
                  <!-- Skipped rows stay listed rather than disappearing: the
                       user picked them, so the dialog owes them a reason the
                       count is lower than the selection. -->
                  <div
                    v-for="(item, index) in selectedList"
                    :key="item.docID"
                    class="tw-flex tw-items-center tw-py-2 tw-pl-2 tw-pr-2 tw-text-sm tw-border-t tw-border-gray-200 first:tw-border-t-0"
                    :class="laoSkipReason(item.docID) ? 'tw-bg-gray-50' : ''"
                  >
                    <div class="tw-w-10 tw-shrink-0 tw-text-gray-400">{{ index + 1 }}</div>
                    <div :class="laoSkipReason(item.docID) ? 'tw-text-gray-400 tw-line-through' : ''">
                      {{ item.docID }}
                    </div>
                    <v-spacer />
                    <span
                      v-if="laoSkipReason(item.docID)"
                      class="tw-text-xs tw-text-gray-500 tw-shrink-0"
                    >
                      {{ laoSkipReason(item.docID) }}
                    </span>
                  </div>
                </div>
                <v-switch
                  v-model="laoIssueDryRun"
                  :disabled="laoIssueLoading"
                  color="#6ec39b"
                  hide-details
                  class="tw-mt-0"
                >
                  <template v-slot:label>
                    <span class="tw-text-sm">
                      Dry run (ดู payload โดยไม่ส่งเข้า gateway)
                      <span class="tw-text-xs tw-text-gray-500 tw-ml-1">
                        — แปลงข้อมูลจาก Firestore แล้วแสดงผลโดยไม่เรียก API
                      </span>
                    </span>
                  </template>
                </v-switch>
                <div class="tw-text-xs tw-text-gray-500">
                  ส่งทีละรายการแบบ queue (Lao eTax ไม่รองรับ bulk) — รอใบก่อนหน้าเสร็จแล้วจึงส่งใบถัดไป.
                  map แต่ละเอกสารเป็น payload Lao eTax (RT = ใบกำกับ, CR = ใบลดหนี้ issueType=1). <code>serialNum</code> มาจาก ED.ID ของเอกสาร
                </div>
              </template>
            </div>

            <div
              v-if="laoIssueResult"
              class="tw-mt-4 tw-border tw-rounded"
              :class="laoIssueResult.ok ? 'tw-border-green-300 tw-bg-green-50' : 'tw-border-red-300 tw-bg-red-50'"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded-t"
                :class="laoIssueResult.ok ? 'tw-bg-green-100' : 'tw-bg-red-100'"
              >
                <v-icon small :color="laoIssueResult.ok ? 'success' : 'error'">
                  {{ laoIssueResult.ok ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
                <span
                  class="tw-text-sm tw-font-medium"
                  :class="laoIssueResult.ok ? 'tw-text-green-800' : 'tw-text-red-700'"
                >
                  {{ laoIssueResult.ok ? (laoIssueResult.dryRun ? 'แสดง payload (dry run) สำเร็จ' : 'ส่งสำเร็จ') : laoIssueResultTitle }}
                </span>
                <v-spacer />
                <span
                  v-if="laoIssueResult.status"
                  class="tw-text-xs tw-mr-2"
                  :class="laoIssueResult.ok ? 'tw-text-green-700' : 'tw-text-red-600'"
                >
                  HTTP {{ laoIssueResult.status }}
                </span>
                <v-btn
                  v-if="laoIssueResult.sent"
                  x-small
                  text
                  color="primary"
                  @click="copyLaoPayload(laoIssueResult.sent)"
                >
                  <v-icon x-small left>mdi-content-copy</v-icon>
                  คัดลอก
                </v-btn>
              </div>
              <div
                v-if="laoIssueResult.serialNum"
                class="tw-px-3 tw-pt-2 tw-text-xs tw-text-gray-600"
              >
                serialNum: <code>{{ laoIssueResult.serialNum }}</code>
              </div>
              <pre
                class="tw-px-3 tw-py-2 tw-text-xs tw-overflow-auto"
                style="max-height: 260px; white-space: pre-wrap; word-break: break-word;"
              >{{ laoIssueResultPretty }}</pre>
            </div>

            <div v-if="laoIssueResults.length > 0" class="tw-mt-4 tw-space-y-2">
              <div class="tw-text-sm tw-font-medium tw-text-gray-600">
                ผลลัพธ์ {{ laoIssueResults.filter((r) => r.ok).length }}/{{ laoIssueResults.length }} สำเร็จ
              </div>
              <div
                v-for="r in laoIssueResults"
                :key="r.docID"
                class="tw-border tw-rounded"
                :class="r.ok ? 'tw-border-green-300 tw-bg-green-50' : 'tw-border-red-300 tw-bg-red-50'"
              >
                <div
                  class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded-t"
                  :class="r.ok ? 'tw-bg-green-100' : 'tw-bg-red-100'"
                >
                  <v-icon small :color="r.ok ? 'success' : 'error'">
                    {{ r.ok ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                  <span class="tw-text-sm tw-font-medium" :class="r.ok ? 'tw-text-green-800' : 'tw-text-red-700'">
                    {{ r.docID }}
                  </span>
                  <v-spacer />
                  <span class="tw-text-xs" :class="r.ok ? 'tw-text-green-700' : 'tw-text-red-600'">
                    {{ r.ok ? (r.dryRun ? 'dry run' : 'ส่งสำเร็จ') : (r.message || r.errorType || 'ผิดพลาด') }}
                  </span>
                </div>
                <!-- What a real send would decide about this document. In a dry
                     run the payload alone looks fine even when the send would be
                     refused, so show the verdict next to it. -->
                <div
                  v-if="laoResultIssues(r).length > 0"
                  class="tw-px-3 tw-py-2 tw-bg-white tw-border-t"
                >
                  <div
                    v-for="(v, vi) in laoResultIssues(r)"
                    :key="vi"
                    class="tw-flex tw-items-start tw-gap-2 tw-text-xs tw-mb-1"
                    :class="v.blocking ? 'tw-text-red-700' : 'tw-text-orange-700'"
                  >
                    <v-icon x-small :color="v.blocking ? 'error' : 'warning'">
                      {{ v.blocking ? 'mdi-close-octagon' : 'mdi-alert-outline' }}
                    </v-icon>
                    <span>{{ v.message }}</span>
                  </div>
                </div>
                <details v-if="r.sent" class="tw-bg-white tw-rounded-b">
                  <summary
                    class="tw-flex tw-items-center tw-px-3 tw-py-1 tw-text-xs tw-text-gray-600 tw-cursor-pointer"
                  >
                    <span>ดู payload</span>
                    <v-spacer />
                    <v-btn
                      x-small
                      text
                      color="primary"
                      @click.stop.prevent="copyLaoPayload(r.sent)"
                    >
                      <v-icon x-small left>mdi-content-copy</v-icon>
                      คัดลอก
                    </v-btn>
                  </summary>
                  <pre
                    class="tw-px-3 tw-py-2 tw-text-xs tw-overflow-auto"
                    style="max-height: 220px; white-space: pre-wrap; word-break: break-word;"
                  >{{ JSON.stringify(r.sent, null, 2) }}</pre>
                </details>
              </div>
            </div>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="closeLaoIssueDialog" :disabled="laoIssueLoading">
              <v-icon left>mdi-close-circle-outline</v-icon>
              ปิด
            </v-btn>
            <v-btn
              text
              color="#6ec39b"
              :disabled="laoIssueLoading || laoIssueSendDisabled"
              @click="callIssueLaoEtaxInvoice"
            >
              <v-progress-circular
                v-if="laoIssueLoading"
                indeterminate
                size="18"
                width="2"
                color="#6ec39b"
                class="mr-2"
              />
              <v-icon v-else left>{{ laoIssueSendIsDryRun ? 'mdi-eye-outline' : 'mdi-send' }}</v-icon>
              {{ laoIssueSendLabel }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Excel export by date + status; renders only for companies switched
           on in Settings/laoEtax.exportEnabled. -->
      <LaoEtaxExportDialog
        v-if="isLaoRtActive"
        :company-id="companyID || $route.params.companyId"
        :doc-type="documentTypeKey"
        :allowed-doc-types="laoAllowedDocTypes || []"
      />

      <!-- Lao eTax Gateway connectivity test (queryTaxList) -->
      <v-dialog
        v-if="isLaoRtActive"
        v-model="laoTestDialog"
        persistent
        max-width="640px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            text
            color="#6ec39b"
            class="tw-ml-2"
          >
            <v-icon left small>mdi-cloud-check-outline</v-icon>
            ตรวจสอบการเชื่อมต่อ
          </v-btn>
        </template>
        <v-card>
          <v-progress-linear
            v-if="laoTestLoading"
            indeterminate
            color="#6ec39b"
            height="3"
          />
          <v-card-title class="tw-flex tw-items-center tw-gap-2">
            <v-icon color="#6ec39b">mdi-cloud-check-outline</v-icon>
            ตรวจสอบการเชื่อมต่อ Gateway
            <v-spacer />
            <span class="tw-text-xs tw-font-normal tw-text-gray-500">
              queryTaxList (5.1)
            </span>
          </v-card-title>
          <v-divider />
          <div class="tw-px-6 tw-py-4">
            <v-text-field
              v-model="laoTestIssueCode"
              label="Issue Code"
              placeholder="เช่น 1234567890"
              outlined
              dense
              hide-details
              :disabled="laoTestLoading"
            />
            <div class="tw-mt-2 tw-text-xs tw-text-gray-500">
              เรียก queryTaxList แบบ read-only เพื่อยืนยันการเซ็น HMAC และการเชื่อมต่อ ไม่มีการสร้างเอกสารใด ๆ
            </div>

            <div
              v-if="laoTestResult"
              class="tw-mt-4 tw-border tw-rounded"
              :class="laoTestResult.ok ? 'tw-border-green-300 tw-bg-green-50' : 'tw-border-red-300 tw-bg-red-50'"
            >
              <div
                class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded-t"
                :class="laoTestResult.ok ? 'tw-bg-green-100' : 'tw-bg-red-100'"
              >
                <v-icon small :color="laoTestResult.ok ? 'success' : 'error'">
                  {{ laoTestResult.ok ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
                <span
                  class="tw-text-sm tw-font-medium"
                  :class="laoTestResult.ok ? 'tw-text-green-800' : 'tw-text-red-700'"
                >
                  {{ laoTestResult.ok ? 'เชื่อมต่อสำเร็จ' : laoTestResultTitle }}
                </span>
                <v-spacer />
                <!-- Which gateway answered. Always show it: on prod the reply
                     came from the live MoF system. -->
                <v-chip
                  v-if="laoTestResult.env"
                  x-small
                  label
                  :color="laoTestResult.env === 'prod' ? 'error' : 'grey lighten-1'"
                  :text-color="laoTestResult.env === 'prod' ? 'white' : 'grey darken-3'"
                >
                  {{ laoTestResult.env === 'prod' ? 'PROD (ระบบจริง)' : 'DEV (ทดสอบ)' }}
                </v-chip>
                <span
                  v-if="laoTestResult.status"
                  class="tw-text-xs"
                  :class="laoTestResult.ok ? 'tw-text-green-700' : 'tw-text-red-600'"
                >
                  HTTP {{ laoTestResult.status }}
                </span>
              </div>
              <pre
                class="tw-px-3 tw-py-2 tw-text-xs tw-overflow-auto"
                style="max-height: 240px; white-space: pre-wrap; word-break: break-word;"
              >{{ laoTestResultPretty }}</pre>
            </div>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="closeLaoTestDialog" :disabled="laoTestLoading">
              <v-icon left>mdi-close-circle-outline</v-icon>
              ปิด
            </v-btn>
            <v-btn
              text
              color="#6ec39b"
              :disabled="laoTestLoading || !laoTestIssueCode"
              @click="callTestLaoEtaxConnection"
            >
              <v-progress-circular
                v-if="laoTestLoading"
                indeterminate
                size="18"
                width="2"
                color="#6ec39b"
                class="mr-2"
              />
              <v-icon v-else left>mdi-send</v-icon>
              {{ laoTestLoading ? 'กำลังทดสอบ...' : 'ทดสอบ' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="tw-flex tw-items-center">
        <popover-menu
          style="padding-right: 20px"
          buttonText="กรอง"
          titleText="แสดงเอกสารเฉพาะ"
          :option-list="optionFilterList"
          :value-list="valueFilterList"
          @change-value-filter-list="onChangeValueFilterList"
          buttonIcon="/images/icons/icon_filter.svg"
          :defaultListItem="defaultValueFilterList"
        ></popover-menu>

        <popover-menu
          style="padding-right: 20px"
          buttonText="ซ่อน"
          titleText="เลือกคอลัมน์ที่ต้องการซ่อน"
          :option-list="optionHideList"
          :value-list="valueHideList"
          @change-value-filter-list="onChangeValueDropdownHideColumn"
          buttonIcon="/images/icons/icon_hidden.svg"
          :defaultListItem="defaultValueHideList"
        ></popover-menu>

        <popover-menu-radio
          style="padding-right: 20px"
          buttonText="ตั้งค่าการค้นหา"
          titleText="เลือกคอลัมน์ที่ต้องการค้นหา"
          :option-list="searchOptionList"
          @change-value-option="onChangeValueSearchOption"
          buttonIcon="/images/icons/icon_search_setting.svg"
          :defaultValue="defaultSearchOptionValue"
        ></popover-menu-radio>

        <v-btn
          v-if="
            showThaiEtaxTools &&
            canUseAdminTools &&
            selectedList.length > 0
          "
          depressed
          dark
          color="orange"
          class="tw-mr-2"
          @click.prevent="confirmClearSignedDialog = true"
          :disabled="clearingSignedFiles"
          :loading="clearingSignedFiles"
        >
          <v-icon left small>mdi-firebase</v-icon>
          <span>อัปเดทเอกสาร ({{ selectedList.length }})</span>
        </v-btn>

        <v-btn
          v-if="
            showThaiEtaxTools &&
            selectedList.length > 0 &&
            $route.name !== 'Company.Documents.CL'
          "
          depressed
          dark
          color="#c9242b"
          class="tw-mr-2"
          @click.prevent="confirmCancelDocDialog = true"
          :disabled="cancelDocLoading"
          :loading="cancelDocLoading"
        >
          <v-icon left small>mdi-cancel</v-icon>
          <span>ยกเลิกเอกสาร ({{ selectedList.length }})</span>
        </v-btn>

        <!-- กู้คืนใบที่กด "ยกเลิกเอกสาร" ผิด — โชว์เฉพาะแท็บใบแจ้งยกเลิก
             ลูกค้ากดเองได้ เป็นการแก้ที่ตัวเองกดผิด ไม่ใช่เครื่องมือของเจ้าหน้าที่ -->
        <v-btn
          v-if="
            selectedList.length > 0 &&
            $route.name === 'Company.Documents.CL'
          "
          depressed
          dark
          color="#6ec39b"
          class="tw-mr-2"
          @click.prevent="confirmRestoreDocDialog = true"
          :disabled="restoreDocLoading"
          :loading="restoreDocLoading"
        >
          <v-icon left small>mdi-restore</v-icon>
          <span>กู้คืนเอกสาร ({{ selectedList.length }})</span>
        </v-btn>

        <!-- Quota paywall — ปุ่มจัดการโควต้า (เจ้าหน้าที่เท่านั้น)
             โชว์ตลอด ไม่ผูกกับการมีใบที่ถูกซ่อนในหน้านั้น เพราะพอปลดล็อกแล้วธงหายหมด
             ปุ่มจะหายตามไปด้วย แล้วไม่มีทางเปิดกล่องมาล็อกกลับได้อีก -->
        <v-btn
          v-if="canUseAdminTools"
          depressed
          dark
          color="#6ec39b"
          class="tw-mr-2"
          @click.prevent="openUnlockQuotaDialog"
        >
          <v-icon left small>mdi-lock-open-variant</v-icon>
          <span>จัดการโควต้า</span>
        </v-btn>

        <v-dialog v-model="unlockQuotaDialog" persistent max-width="480px">
          <v-card>
            <v-card-title class="tw-flex tw-items-center tw-gap-2">
              <v-icon color="#6ec39b">mdi-lock-open-variant-outline</v-icon>
              <b>ปลดล็อกโควต้า</b>
              <v-spacer></v-spacer>
              <span class="tw-text-xs tw-font-normal tw-text-gray-500">เจ้าหน้าที่</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="tw-pt-5">
              <v-alert
                dense
                text
                color="#6ec39b"
                icon="mdi-information-outline"
                class="tw-mb-4"
                style="font-size: 13px; border-radius: 8px"
              >
                เอกสารที่ถูกซ่อนเพราะใช้เกินโควต้าของเดือนที่เลือก จะกลับมาแสดงในตาราง
              </v-alert>

              <v-menu
                v-model="unlockMonthMenu"
                :close-on-content-click="false"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="unlockQuotaMonth"
                    label="เดือนที่ปลดล็อก"
                    prepend-inner-icon="mdi-calendar-month-outline"
                    readonly
                    outlined
                    dense
                    hide-details
                    :disabled="unlockQuotaLoading"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="unlockQuotaMonth"
                  type="month"
                  no-title
                  color="#6ec39b"
                  @input="unlockMonthMenu = false"
                ></v-date-picker>
              </v-menu>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text :disabled="unlockQuotaLoading" @click="unlockQuotaDialog = false">
                ยกเลิก
              </v-btn>
              <v-btn
                outlined
                color="#c9242b"
                :loading="relockQuotaLoading"
                :disabled="!unlockQuotaMonth || unlockQuotaLoading"
                @click="confirmRelockQuota"
              >
                <v-icon left small>mdi-lock-outline</v-icon>
                ล็อกกลับ
              </v-btn>
              <v-btn
                color="#6ec39b"
                dark
                :loading="unlockQuotaLoading"
                :disabled="!unlockQuotaMonth || relockQuotaLoading"
                @click="confirmUnlockQuota"
              >
                <v-icon left small>mdi-lock-open-variant</v-icon>
                ปลดล็อก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div
          v-if="defaultSearchOptionValue != 'ED.IssueDateTime'"
          class="search-box"
        >
          <v-text-field
            :value="keyword"
            :label="`ค้นหา จาก ${
              searchOptionList?.find(
                (item) => item.key === defaultSearchOptionValue
              )?.label
            }`"
            append-icon="mdi-magnify"
            :placeholder="`ค้นหา จาก ${
              searchOptionList?.find(
                (item) => item.key === defaultSearchOptionValue
              )?.label
            }`"
            outlined
            @input="debounceInput"
          ></v-text-field>
        </div>

        <div
          v-if="defaultSearchOptionValue == 'ED.IssueDateTime'"
          class="tw-flex tw-gap-4"
        >
          <v-menu
            v-model="fromDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="292px"
            min-width="292px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="จากวันที่เอกสาร"
                append-icon="mdi-calendar-month-outline"
                readonly
                :value="fromDateDisp"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              locale="en-in"
              v-model="fromDateVal"
              no-title
              @input="fromDateMenu = false"
              :min="minDate"
            ></v-date-picker>
          </v-menu>

          <v-menu
            v-model="toDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="292px"
            min-width="292px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="ถึงวันที่"
                append-icon="mdi-calendar-month-outline"
                readonly
                :value="toDateDisp"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              locale="en-in"
              v-model="toDateVal"
              no-title
              @input="toDateMenu = false"
              :min="minToDate"
            ></v-date-picker>
          </v-menu>

          <v-btn
            text
            color="#f05d5d"
            type="button"
            outlined
            class="btn-submit tw-self-center"
            @click="resetDateSearch"
          >
            <v-icon small>mdi-restart</v-icon>
            <b>รีเซ็ตค่า</b>
          </v-btn>
        </div>
      </div>
    </v-card-title>

    <v-container v-if="alert.show">
      <v-row>
        <v-col cols="12">
          <v-alert
            v-model="alert.show"
            :type="alert.type"
            transition="scale-transition"
            dismissible
            >{{ alert.text }}</v-alert
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- docs::
    {{
    docs.length
     }} -->

    <v-dialog v-model="pdfDialog">
      <div>
        <iframe class="iframe" :src="pdfSrc"></iframe>
      </div>
    </v-dialog>

    <!-- Lao eTax verification QR code -->
    <v-dialog v-model="laoQrDialog" max-width="340">
      <v-card class="tw-text-center tw-px-4 tw-py-5">
        <div class="tw-text-base tw-font-medium tw-mb-1">QR ตรวจสอบใบกำกับ Lao eTax</div>
        <div class="tw-text-xs tw-text-gray-500 tw-mb-3">{{ laoQrCurrent.docID }}</div>
        <img
          v-if="laoQrCurrent.qrCodeUrl"
          :src="laoQrCurrent.qrCodeUrl"
          alt="QR ตรวจสอบใบกำกับ"
          style="width: 220px; height: 220px; margin: 0 auto; display: block"
        />
        <a
          v-if="laoQrCurrent.url"
          :href="laoQrCurrent.url"
          target="_blank"
          rel="noopener"
          class="tw-text-xs tw-text-light-green tw-break-all tw-block tw-mt-3"
        >
          {{ laoQrCurrent.url }}
        </a>
        <v-card-actions class="tw-justify-center tw-mt-2">
          <v-btn
            text
            small
            color="#6ec39b"
            :href="laoQrCurrent.qrCodeUrl"
            :download="laoQrCurrent.docID + '_qr.png'"
          >
            <v-icon left small>mdi-download</v-icon>
            ดาวน์โหลด QR
          </v-btn>
          <v-btn text small @click="laoQrDialog = false">
            <v-icon left small>mdi-close-circle-outline</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="laoCancelDialog" persistent max-width="520px">
      <v-card>
        <v-card-title class="tw-flex tw-items-center tw-gap-2">
          <img src="/images/icons/lao_tax.jpg" height="24px" width="24px" alt="" />
          <b>ยืนยันการยกเลิกใบกำกับ Lao eTax</b>
        </v-card-title>
        <v-divider />
        <v-card-text class="tw-pt-4">
          <p class="tw-mb-2">
            จะส่งคำสั่งยกเลิกใบกำกับ
            <b>{{ laoCancelTarget && laoCancelTarget.invoiceNumber }}</b>
            (เอกสาร {{ laoCancelTarget && laoCancelTarget.docID }}) ไปยังระบบ
            Lao eTax
          </p>
          <p class="tw-text-red-600 tw-mb-0">
            เป็นการเรียกไปยังระบบสรรพากรลาวโดยตรงและ<b>ย้อนกลับไม่ได้</b> —
            ยกเลิกได้เฉพาะใบที่สถานะ "ไม่ผ่าน" เท่านั้น
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :disabled="laoCancelLoading"
            @click="laoCancelDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="#c9242b"
            dark
            :loading="laoCancelLoading"
            @click="confirmLaoCancel"
          >
            <v-icon left small>mdi-cancel</v-icon>
            ยืนยันยกเลิกใบกำกับ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="laoSapErrorDialog" persistent max-width="560px">
      <v-card>
        <v-card-title class="tw-flex tw-items-center tw-gap-2">
          <v-icon color="error">mdi-alert-circle</v-icon>
          <b>ซิงค์เข้า SAP ไม่สำเร็จ</b>
        </v-card-title>
        <v-divider />
        <v-card-text class="tw-pt-4">
          <div class="tw-text-xs tw-text-gray-500 tw-mb-2">
            เอกสาร {{ laoSapErrorTarget && laoSapErrorTarget.docID }}
            <template v-if="laoSapErrorTarget && laoSapErrorTarget.invoiceNumber">
              · ใบกำกับ {{ laoSapErrorTarget.invoiceNumber }}
            </template>
          </div>
          <pre
            class="tw-text-xs tw-bg-red-50 tw-border tw-border-red-200 tw-rounded tw-p-3 tw-mb-4"
            style="white-space: pre-wrap; max-height: 220px; overflow: auto"
          >{{ laoSapErrorTarget && laoSapErrorTarget.error }}</pre>
          <p class="tw-mb-2">
            กด "ล้าง error แล้วซิงค์ใหม่" เพื่อลบข้อความนี้ออกจากเอกสาร —
            ตัวเชื่อม PSC Connector จะเห็นทันทีและลองเขียนเข้า SAP อีกครั้ง
          </p>
          <p class="tw-text-xs tw-text-gray-600 tw-mb-0">
            ไม่มีการส่งอะไรไปยังระบบสรรพากรลาว: เลขใบกำกับ สถานะ และ QR
            ของเอกสารไม่ถูกแตะต้อง<br />
            เครื่องที่รัน PSC Connector ต้องเปิดโปรแกรมค้างไว้
            ไม่อย่างนั้นจะยังไม่มีอะไรเกิดขึ้นจนกว่าจะเปิด
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="laoSapClearing" @click="laoSapErrorDialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="#6ec39b"
            dark
            :loading="laoSapClearing"
            @click="confirmLaoSapClear"
          >
            <v-icon left small>mdi-refresh</v-icon>
            ล้าง error แล้วซิงค์ใหม่
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- หมายเหตุของลูกค้า (@DocData.remark) — เก็บไว้ในระบบเท่านั้น.
         Gated like the column that opens it: nothing else can set
         laoRemarkDialog, so an ungated dialog was never visible to another
         product, but it still put Lao markup in every product's render tree and
         read differently from the two Lao dialogs above. -->
    <v-dialog
      v-if="isLaoTaxRisActive"
      v-model="laoRemarkDialog"
      persistent
      max-width="520px"
    >
      <v-card>
        <v-card-title class="tw-flex tw-items-center tw-gap-2">
          <img src="/images/icons/lao_tax.jpg" height="24px" width="24px" alt="" />
          <b>หมายเหตุ</b>
        </v-card-title>
        <v-divider />
        <v-card-text class="tw-pt-4">
          <p class="tw-mb-2">
            เอกสาร <b>{{ laoRemarkTarget && laoRemarkTarget.objectID }}</b>
          </p>
          <v-textarea
            v-model="laoRemarkText"
            auto-grow
            rows="3"
            counter
            :maxlength="laoRemarkMaxLength"
            :error-messages="laoRemarkErrorText"
            :disabled="laoRemarkSaving"
            label="หมายเหตุ"
          ></v-textarea>
          <!-- Says who sees it, who does not, and whether it can be changed —
               the three things a person actually wonders about before typing in
               a field on a tax document. Deliberately free of system words
               (ED.IN.Subject, PDF, นำส่ง, gateway): the reader is a billing
               clerk, not the person who will read laoRemark.js. -->
          <p class="tw-text-xs tw-text-gray-600 tw-mb-0">
            โน้ตภายในของคุณเท่านั้น —
            <b>ไม่ถูกส่งให้สรรพากร</b> ไม่แสดงบนใบกำกับที่ลูกค้าได้รับ
            และแก้ไขได้ทุกเมื่อ
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="laoRemarkSaving" @click="closeLaoRemark"
            >ยกเลิก</v-btn
          >
          <v-btn
            color="#6ec39b"
            dark
            :loading="laoRemarkSaving"
            :disabled="laoRemarkSaving || !!laoRemarkErrorText"
            @click="saveLaoRemark"
          >
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr id="header-table">
            <th />
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('ED.IssueDateTime')"
              v-if="showColumn('ED.IssueDateTime')"
            >
              วันที่เอกสาร
              <img
                v-if="orderBySelect['key'] === 'ED.IssueDateTime'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'ED.IssueDateTime'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('objectID')"
            >
              เลขที่เอกสาร
              <img
                v-if="orderBySelect['key'] === 'objectID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'objectID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <!--
              Optional per-company columns (Settings/laoEtax.extraColumns).
              Empty for every company that has none, so the table is unchanged
              for everyone else. See constants/laoEtaxColumns.js.

              NOT sortable, unlike every other column here, and deliberately so:
              Firestore orderBy skips documents that lack the field, and these
              columns are optional by definition — sorting by เลขที่สัญญา would
              silently drop every invoice that has none. On a page of tax
              documents that reads as data loss, not as a sort. Searching the
              column is unaffected: there, matching only documents that carry a
              value is the point.
            -->
            <template v-for="col in laoExtraColumns">
              <th v-if="showColumn(col.key)" :key="col.key" class="text-left">
                {{ col.label }}
              </th>
            </template>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('SCTT.AHTA.BTP.ID')"
              v-if="showColumn('SCTT.AHTA.BTP.ID')"
            >
              รหัสผู้ซื้อ
              <img
                v-if="orderBySelect['key'] === 'SCTT.AHTA.BTP.ID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'SCTT.AHTA.BTP.ID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('SCTT.AHTA.BTP.Name')"
              v-if="showColumn('SCTT.AHTA.BTP.Name')"
            >
              ชื่อผู้ซื้อ / ชื่อบริษัท
              <img
                v-if="orderBySelect['key'] === 'SCTT.AHTA.BTP.Name'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'SCTT.AHTA.BTP.Name'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('SCTT.AHTA.BTP.STR.ID')"
              v-if="showColumn('SCTT.AHTA.BTP.STR.ID')"
            >
              เลขผู้เสียภาษี
              <img
                v-if="orderBySelect['key'] === 'SCTT.AHTA.BTP.STR.ID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'SCTT.AHTA.BTP.STR.ID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('@BuyerBranchID')"
              v-if="showColumn('@BuyerBranchID')"
            >
              สาขาผู้ซื้อ
              <img
                v-if="orderBySelect['key'] === '@BuyerBranchID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== '@BuyerBranchID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('SCTT.AHTS.STSHMS.TaxBasisTotalAmount')"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxBasisTotalAmount')"
            >
              มูลค่าที่นำมาคิดภาษี
              <img
                v-if="
                  orderBySelect['key'] ===
                  'SCTT.AHTS.STSHMS.TaxBasisTotalAmount'
                "
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="
                  orderBySelect['key'] !==
                  'SCTT.AHTS.STSHMS.TaxBasisTotalAmount'
                "
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('SCTT.AHTS.STSHMS.TaxTotalAmount')"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxTotalAmount')"
            >
              ภาษีมูลค่าเพิ่ม
              <img
                v-if="
                  orderBySelect['key'] === 'SCTT.AHTS.STSHMS.TaxTotalAmount' &&
                  !keyword
                "
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="
                  orderBySelect['key'] !== 'SCTT.AHTS.STSHMS.TaxTotalAmount' &&
                  !keyword
                "
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('SCTT.AHTS.STSHMS.GrandTotalAmount')"
              v-if="showColumn('SCTT.AHTS.STSHMS.GrandTotalAmount')"
            >
              ยอดรวม
              <img
                v-if="
                  orderBySelect['key'] === 'SCTT.AHTS.STSHMS.GrandTotalAmount'
                "
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="
                  orderBySelect['key'] !== 'SCTT.AHTS.STSHMS.GrandTotalAmount'
                "
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('@TimeSignedXml')"
              v-if="showColumn('@TimeSignedXml')"
            >
              เวลาลงลายมือชื่อ
              <img
                v-if="orderBySelect['key'] === '@TimeSignedXml'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== '@TimeSignedXml'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-center"
              style="min-width: 110px"
              v-if="isLaoTaxRisActive"
            >
              สถานะการนำส่ง
            </th>
            <th
              class="text-center"
              style="min-width: 90px"
              v-if="isLaoTaxRisActive"
            >
              การซิงค์ SAP
            </th>
            <!--
              The customer's own note (@DocData.remark) — stored and shown, never
              filed. Deliberately NOT a LAO_EXTRA_COLUMNS entry: those are
              read-only, switched on per company, and wired into the Firestore
              search path, which for a free-text field would mean a hand-made
              composite index for something nobody searches by. This column is
              editable and offered to every Lao company, so it renders like the
              Lao status columns above rather than through that mechanism.
              Not sortable, for the same reason the optional columns are not:
              orderBy skips documents missing the field, and most documents will
              have no note.
            -->
            <th
              class="text-left"
              style="min-width: 150px"
              v-if="isLaoTaxRisActive"
            >
              หมายเหตุ
            </th>
            <th
              class="text-center"
              style="min-width: 80px"
              v-if="showColumn('xmlAndEmail')"
            >
              สถานะเอกสารและอีเมล
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in visibleDocs" :key="doc.id" class="tr-data">
            <td>
              <v-checkbox
                color="#6ec39b"
                :input-value="getCheckedSelect(doc.id)"
                class="remove-checkbox-padding"
                @change="clickSelected(doc)"
              ></v-checkbox>
            </td>
            <td
              v-if="showColumn('ED.IssueDateTime')"
              :disabled="downloadPdfLoading"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <div class="check-box-flex">
                <img
                  v-if="doc['@DownloadedXml']"
                  src="/images/icons/icon_downloaded.svg"
                  alt="downloaded"
                  class="icon-downloaded"
                />
                <img
                  v-if="doc['@DocSent']"
                  src="/images/icons/icon_taxris_send.png"
                  alt="doc sent icon"
                  class="icon-downloaded"
                />
                <span>{{ getDateWithFormat(doc["ED.IssueDateTime"]) }}</span>
              </div>
            </td>
            <td
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["objectID"] }}
            </td>
            <template v-for="col in laoExtraColumns">
              <td
                v-if="showColumn(col.key)"
                :key="col.key"
                @mousedown="startDrag"
                @mouseup="stopDrag(doc)"
                @mousemove="doDrag"
              >
                {{ docColumnValue(doc, col.key) || "-" }}
              </td>
            </template>
            <td
              v-if="showColumn('SCTT.AHTA.BTP.ID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["SCTT.AHTA.BTP.ID"] || "-" }}
            </td>
            <td
              v-if="showColumn('SCTT.AHTA.BTP.Name')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["SCTT.AHTA.BTP.Name"] }}
            </td>
            <td
              v-if="showColumn('SCTT.AHTA.BTP.STR.ID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ getTaxId(doc["SCTT.AHTA.BTP.STR.ID"], companyID) }}
            </td>
            <td
              v-if="showColumn('@BuyerBranchID')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["@BuyerBranchID"] || "-" }}
            </td>
            <td
              class="text-right"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxBasisTotalAmount')"
              v-html="
                getFormatAmount(doc['SCTT.AHTS.STSHMS.TaxBasisTotalAmount'])
              "
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-right"
              v-if="showColumn('SCTT.AHTS.STSHMS.TaxTotalAmount')"
              v-html="getFormatAmount(doc['SCTT.AHTS.STSHMS.TaxTotalAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-right"
              v-if="showColumn('SCTT.AHTS.STSHMS.GrandTotalAmount')"
              v-html="getFormatAmount(doc['SCTT.AHTS.STSHMS.GrandTotalAmount'])"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            ></td>
            <td
              class="text-left"
              v-if="showColumn('@TimeSignedXml')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ timeFormat(doc["@TimeSignedXml"]) || "-" }}
            </td>
            <td
              class="text-center"
              v-if="isLaoTaxRisActive"
            >
              <!-- open-on-focus is off on every tooltip in this column whose
                   activator opens a dialog, and the reason is the same for all
                   three. Vuetify binds a `focus` listener when openOnFocus is on
                   (VTooltip.js genActivatorListeners, default true): clicking
                   focuses the activator, so the tooltip opens behind the dialog,
                   and when the dialog closes v-dialog hands focus back to that
                   activator — `focus` fires again and the tooltip reappears with
                   no pointer on it, so no mouseleave ever closes it. Nothing is
                   lost for keyboard users: each activator carries an aria-label,
                   and the dialog it opens shows the same text in full. -->
              <v-tooltip
                v-if="laoStatusMeta(laoStatusValue(doc))"
                bottom
                max-width="360"
                :open-on-focus="false"
                :disabled="!laoStatusDetail(doc)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    small
                    label
                    :color="laoStatusMeta(laoStatusValue(doc)).color"
                    text-color="white"
                    :style="laoStatusAction(doc) ? 'cursor: pointer' : ''"
                    :aria-label="laoStatusActionLabel(doc)"
                    @click="onLaoStatusClick(doc)"
                  >
                    {{ laoStatusMeta(laoStatusValue(doc)).label }}
                    <v-icon
                      v-if="laoStatusAction(doc) === 'cancel'"
                      right
                      x-small
                    >mdi-cancel</v-icon>
                    <v-icon
                      v-else-if="laoStatusAction(doc) === 'error'"
                      right
                      x-small
                    >mdi-alert-circle-outline</v-icon>
                    <v-icon
                      v-else-if="laoStatusAction(doc) === 'qr'"
                      right
                      x-small
                    >mdi-qrcode</v-icon>
                  </v-chip>
                </template>
                <span style="white-space: pre-line; overflow-wrap: anywhere">{{ laoStatusDetail(doc) }}</span>
              </v-tooltip>
              <span v-else class="tw-text-gray-300">-</span>
              <v-tooltip v-if="laoCanRetry(doc) || laoCanRecheck(doc)" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    x-small
                    class="tw-ml-1"
                    color="#6ec39b"
                    :loading="laoRetryingId === doc.id"
                    :disabled="!!laoRetryingId"
                    :aria-label="laoRetryLabel(doc) + ' (' + doc.id + ')'"
                    @click="retryLao(doc)"
                  >
                    <v-icon x-small>{{
                      laoCanRecheck(doc) ? "mdi-file-search-outline" : "mdi-refresh"
                    }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ laoRetryLabel(doc) }}</span>
              </v-tooltip>
              <v-tooltip v-if="laoIsCredited(doc)" bottom max-width="360">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    label
                    color="#9e9e9e"
                    text-color="white"
                    class="tw-ml-1"
                  >
                    <v-icon x-small left>mdi-file-document-minus-outline</v-icon>
                    ลดหนี้แล้ว
                  </v-chip>
                </template>
                <span style="white-space: pre-line; overflow-wrap: anywhere">{{ laoCreditedTooltip(doc) }}</span>
              </v-tooltip>
            </td>
            <td
              class="text-center"
              v-if="isLaoTaxRisActive"
            >
              <!-- open-on-focus off: this icon opens the SAP error dialog. See
                   the สถานะการนำส่ง tooltip above for why. -->
              <v-tooltip
                v-if="laoSapState(doc)"
                bottom
                max-width="360"
                :open-on-focus="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    small
                    :color="laoSapState(doc).color"
                    :style="laoSapCanClear(doc) ? 'cursor: pointer' : ''"
                    :aria-label="laoSapIconLabel(doc)"
                    @click="onLaoSapClick(doc)"
                  >
                    {{ laoSapState(doc).icon }}
                  </v-icon>
                </template>
                <span style="white-space: pre-line; overflow-wrap: anywhere">{{ laoSapTooltip(doc) }}</span>
              </v-tooltip>
              <span v-else class="tw-text-gray-300">-</span>
            </td>
            <!-- No drag handlers here, unlike the plain data cells: this one is
                 interactive, and starting a row drag from it would fight the
                 edit it exists for. The Lao status chip above does the same. -->
            <td class="text-left" v-if="isLaoTaxRisActive">
              <!-- open-on-focus off: this button opens the หมายเหตุ dialog. See
                   the สถานะการนำส่ง tooltip above for why. -->
              <v-tooltip
                bottom
                max-width="360"
                :open-on-focus="false"
                :disabled="!laoRemarkOf(doc)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <button
                    v-bind="attrs"
                    v-on="on"
                    type="button"
                    class="tw-text-left"
                    :aria-label="
                      laoRemarkOf(doc)
                        ? 'แก้หมายเหตุของเอกสาร ' + doc['objectID']
                        : 'เพิ่มหมายเหตุให้เอกสาร ' + doc['objectID']
                    "
                    @click="openLaoRemark(doc)"
                  >
                    <span v-if="laoRemarkOf(doc)">{{
                      laoRemarkPreview(laoRemarkOf(doc))
                    }}</span>
                    <v-icon v-else small color="#bdbdbd">mdi-pencil-outline</v-icon>
                  </button>
                </template>
                <span style="white-space: pre-line; overflow-wrap: anywhere">{{
                  laoRemarkOf(doc)
                }}</span>
              </v-tooltip>
            </td>
            <td
              class="text-center"
              v-if="showColumn('xmlAndEmail')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <div
                style="
                  width: 40px;
                  display: flex;
                  justify-content: space-between;
                  margin: 0 auto;
                "
              >
                <v-icon
                  dark
                  small
                  color="#6ec39b"
                  v-if="doc['@SignedXmlUrl'] !== ''"
                  >mdi-check-circle-outline</v-icon
                >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      dark
                      small
                      color="#c9242b"
                      alt="cancel-status"
                      v-bind="attrs"
                      v-on="on"
                      v-if="doc['@DocData']?.['docStatus'] == 'C'"
                      >mdi-cancel</v-icon
                    >
                  </template>
                  <span>เอกสารใบนี้ถูกยกเลิก</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <img
                      width="16px"
                      height="14px"
                      src="/images/icons/icon_status_error.svg"
                      alt="error-status"
                      v-bind="attrs"
                      v-on="on"
                      v-if="doc['@Errors'] && doc['@Errors'].length > 0"
                      class="icon-button"
                    />
                  </template>
                  <span>{{
                    doc["@Errors"]
                      ? errorsMessage(doc["@Errors"]).split(",").join(", ")
                      : ""
                  }}</span>
                </v-tooltip>


                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      dark
                      small
                      color="#707070"
                      alt="cancel-status"
                      v-bind="attrs"
                      v-on="on"
                      v-if="doc['@MailSent']"
                      >mdi-email-outline</v-icon
                    >
                  </template>
                  <span>{{
                    timeFormat(doc["@TimeMailSent"])
                  }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      dark
                      small
                      color="#182424"
                      alt="no-line-items-warning"
                      v-bind="attrs"
                      v-on="on"
                      v-if="!doc['SCTT.ISCTLI'] || (Array.isArray(doc['SCTT.ISCTLI']) && doc['SCTT.ISCTLI'].length === 0)"
                      >mdi-alert-circle-outline</v-icon
                    >
                  </template>
                  <span>เอกสารนี้ไม่มีitemสินค้าหรือราคาสินค้าไม่ถูกต้อง</span>
                </v-tooltip>
                <v-btn v-if="userCompany?.isDeveloper || user?.isEngineer" color="orange" depressed icon outlined target="_blank" class="ml-1"
                       :href="getFirestoreDocUrl(doc.id)">
                  <v-icon small>mdi-firebase</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- หน้าว่างมีได้สองความหมาย ต้องแยกให้ผู้ใช้เห็น: ไม่มีเอกสารจริง ๆ กับ
         มีแต่ถูกกำแพงโควต้าซ่อนไว้ทั้งหน้า (เกิดได้ที่หน้าท้าย ๆ ของการเรียงลำดับ) -->
    <div
      v-if="visibleDocs.length == 0 && hiddenByQuota > 0 && !loading"
      class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
    >
      <h2>ข้ามเอกสารที่ถูกซ่อนไว้ {{ hiddenByQuota }} ฉบับ แล้วยังไม่พบเอกสารที่แสดงได้</h2>
      <p class="tw-mt-2">เอกสารเหล่านี้เกินโควต้าของเดือนนั้น — ชำระค่าส่วนเกินเพื่อปลดล็อก หรือเลือกหน้าอื่นเพื่อดูเอกสารที่เหลือ</p>
    </div>
    <div
      v-if="visibleDocs.length == 0 && hiddenByQuota == 0 && !loading"
      class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
    >
      <h2>ไม่พบเอกสารที่ต้องการ</h2>
    </div>
    <v-progress-linear
      indeterminate
      color="green"
      :active="loading || downloadPdfLoading"
    ></v-progress-linear>
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import isMobile from "../../../libs/detectMobile";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");
import PopoverMenu from "./popoverMenu";
import PopoverMenuRadio from "./popoverMenuRadio";
import formatTwoDecimal from "@/libs/formatTwoDecimal";
import getErrorMessage from "@/libs/getErrorMessage";
// import { docsQuery } from "../../../store/collection/docs";
import companyStatus from "@/libs/companyStatus";
import router from "@/router";
import getDocumentTypeKey from "@/libs/getDocumentTypeKey";
import libCSV from "@/libs/libCSV";
import {
  LAO_ETAX_STATUS_META,
  LAO_STALE_INFLIGHT_MS,
} from "@/constants/laoEtaxStatus";
import { resolveAllowedLaoDocTypes } from "@/constants/laoEtaxDocTypes";
import {
  LAO_REMARK_MAX_LENGTH,
  laoRemarkError,
  laoRemarkPreview as previewLaoRemark,
} from "@/libs/laoRemark";
import { applyLaoHiddenDefaults } from "@/libs/laoHiddenColumns";
import {
  LAO_EXTRA_COLUMN_KEYS,
  resolveLaoExtraColumns,
} from "@/constants/laoEtaxColumns";
import MonthlyDownloadDialog from "./monthly-download-dialog.vue";
import LaoEtaxExportDialog from "./lao-etax-export-dialog.vue";
import UploadLogViewer from "@/components/UploadLogViewer.vue";
import Papa from "papaparse";
import * as XLSX from 'xlsx';

const axios = require("axios");
const _ = require("lodash");

const MAX_DOC_PER_ZIP = {
  xml: 500,
  pdf: 100,
};


export default {
  components: {
    PopoverMenu,
    PopoverMenuRadio,
    MonthlyDownloadDialog,
    UploadLogViewer,
    LaoEtaxExportDialog,
  },
  data() {
    return {
      companyID: this.$route.params.companyId,
      fromDateMenu: false,
      fromDateVal: null,
      minDate: "1990-01-05",
      maxDate: new Date(),
      toDateMenu: false,
      toDateVal: null,
      minDateToDate: this.fromDateVal,
      //check file
      // template import data
      selectedTemp: "template-1",
      temp1Hiden: false,
      template1: null,
      templateh: null,
      templatel: null,
      temp2Hiden: true,
      //end template import data
      selectedAll: false,
      emailDialog: false,
      // Legacy TaxRIS send is off — the new enqueue/verify pipeline below is
      // the only way to send to Lao eTax. See the dialog for why.
      showLegacyLaoTaxRis: false,
      taxRisDialog: false,
      // Lao eTax Gateway connectivity test
      laoTestDialog: false,
      laoTestLoading: false,
      laoTestIssueCode: "",
      laoTestResult: null,
      // Lao eTax — issueInvoice (5.2)
      laoIssueDialog: false,
      laoIssueLoading: false,
      // Off by default: the dialog opens on the real-document flow. The mock
      // toggle is dev/staff-only (see canUseDevTools in the template) and is
      // enabled deliberately, never by landing on the dialog.
      laoIssueUseMock: false,
      laoIssueCode: "1234567890",
      laoBuyerCode: "8765678987656",
      laoIssueDryRun: true,
      laoIssueResult: null,
      laoIssueResults: [],
      laoIssueProgress: { current: 0, total: 0 },
      laoStatusMap: {},
      laoStatusUnsub: null,
      // Sorted doc IDs the status listeners cover — see syncLaoStatusListeners.
      laoStatusKey: "",
      // @DocType values this company is allowed to file (Settings/laoEtax).
      // null until resolved, and null is what an unreadable setting leaves —
      // both mean "offer nothing". See the isLaoTaxRisActive watcher.
      laoAllowedDocTypes: null,
      // Optional per-company columns (Settings/laoEtax.extraColumns), e.g. an
      // insurer's เลขที่สัญญา. Empty for every company that has none, which
      // is the normal case. See the isLaoTaxRisActive watcher.
      laoExtraColumns: [],
      laoQrDialog: false,
      laoQrCurrent: { docID: "", url: "", qrCodeUrl: "" },
      laoCancelDialog: false,
      laoCancelTarget: null,
      laoCancelLoading: false,
      // The SAP-sync failure detail + its "clear error and retry" action.
      laoSapErrorDialog: false,
      laoSapErrorTarget: null,
      laoSapClearing: false,
      // The customer's own note on one document (@DocData.remark). Never filed,
      // so unlike the send flow there is no status that locks it — see
      // src/libs/laoRemark.js.
      laoRemarkDialog: false,
      laoRemarkTarget: null,
      laoRemarkText: "",
      laoRemarkSaving: false,
      // docID currently being re-sent via the per-row retry button (null = none).
      laoRetryingId: null,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      emailValid: false,
      taxRisValid: false,      sendEmailLoading: false,
      sendTaxRisLoading: false,
      exportingToExcel: false,
      sendTaxRisSuccessCount: 0,
      mEmailTemplateID: "Default Template",
      mEmailTemplatesListUnsubscribeObject: null,
      mEmailTemplatesList: [],
      mEmailTemplatesIDList: [],
      alert: {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      },
      taxRisAlert: {
        show: false,
        errors: [],
        warnings: [],
      },
      // alert: {
      //   text: "",
      //   type: "success",
      //   show: false
      // },
      pdfDialog: false,
      pdfSrc: "",
      downloadPdfLoading: false,
      clearingDownloadedXml: false,
      clearingSignedFiles: false,
      confirmClearSignedDialog: false,
      cancelDocLoading: false,
      confirmCancelDocDialog: false,
      restoreDocLoading: false,
      confirmRestoreDocDialog: false,
      optionFilterList: [
        { label: "ดาวน์โหลดแล้ว", key: "@DownloadedXml" },
        { label: "ยังไม่ได้ดาวน์โหลด", key: "not-download" },
        { label: "เอกสารที่ยกเลิก", key: "cancelled" },
      ],
      defaultValueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
      optionHideList: [
        { label: "แสดงทั้งหมด", key: "all" },
        { label: "วันที่เอกสาร", key: "ED.IssueDateTime" },
        { label: "รหัสผู้ซื้อ", key: "SCTT.AHTA.BTP.ID" },
        { label: "ชื่อผู้ซื้อ / ชื่อบริษัท", key: "SCTT.AHTA.BTP.Name" },
        { label: "เลขผู้เสียภาษี", key: "SCTT.AHTA.BTP.STR.ID" },
        { label: "สาขาผู้ซื้อ", key: "@BuyerBranchID" },
        {
          label: "มูลค่าที่นำมาคิดภาษี",
          key: "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        },
        { label: "ภาษีมูลค่าเพิ่ม", key: "SCTT.AHTS.STSHMS.TaxTotalAmount" },
        { label: "ยอดรวม", key: "SCTT.AHTS.STSHMS.GrandTotalAmount" },
        { label: "เวลาลงลายมือชื่อ", key: "@TimeSignedXml" },
        { label: "สถานะเอกสารและอีเมล", key: "xmlAndEmail" },
      ],
      valueHideList: [
        "all",
        "ED.IssueDateTime",
        "SCTT.AHTA.BTP.ID",
        "SCTT.AHTA.BTP.Name",
        "SCTT.AHTA.BTP.STR.ID",
        "@BuyerBranchID",
        "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        "SCTT.AHTS.STSHMS.TaxTotalAmount",
        "SCTT.AHTS.STSHMS.GrandTotalAmount",
        "@TimeSignedXml",
        "xmlAndEmail",
      ],
      defaultValueHideList: [
        "all",
        "ED.IssueDateTime",
        "SCTT.AHTA.BTP.ID",
        "SCTT.AHTA.BTP.Name",
        "SCTT.AHTA.BTP.STR.ID",
        "@BuyerBranchID",
        "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        "SCTT.AHTS.STSHMS.TaxTotalAmount",
        "SCTT.AHTS.STSHMS.GrandTotalAmount",
        "@TimeSignedXml",
        "xmlAndEmail",
      ],
      searchOptionList: [
        { label: "วันที่เอกสาร", key: "ED.IssueDateTime" },
        { label: "เลขที่เอกสาร", key: "objectID" },
        { label: "รหัสผู้ซื้อ", key: "SCTT.AHTA.BTP.ID" },
        { label: "ชื่อผู้ซื้อ / ชื่อบริษัท", key: "SCTT.AHTA.BTP.Name" },
        { label: "เลขผู้เสียภาษี", key: "SCTT.AHTA.BTP.STR.ID" },
        { label: "สาขาผู้ซื้อ", key: "@BuyerBranchID" },
        {
          label: "มูลค่าที่นำมาคิดภาษี",
          key: "SCTT.AHTS.STSHMS.TaxBasisTotalAmount",
        },
        { label: "ภาษีมูลค่าเพิ่ม", key: "SCTT.AHTS.STSHMS.TaxTotalAmount" },
        { label: "ยอดรวม", key: "SCTT.AHTS.STSHMS.GrandTotalAmount" },
        //{ label: "เวลาลงลายมือชื่อ", key: "@TimeSignedXml" },
      ],
      defaultSearchOptionValue: "objectID",
      disablePopOver: false,
      mouse: false,
      dragging: false,
      height: 0,
      resize: false,
      //filter
      filter: {
        issueDateTimeRange: [],
        objectId: "",
        scttAhtaBtpId: "",
        buyerBranchId: "",

        typeLineTotal: "",
        lineTotal: [],

        typeTaxTotal: "",
        taxTotal: [],

        typeGrandTotal: "",
        grandTotal: [],

        timeSignedXmlRange: [],
        docType: "",
        status: {
          downloadedXml: null,
          signSuccess: null,
          missingInfo: null,
          mailSent: null,
          suspendedAccount: null,
          buyerEmail_Isnull: null,
        },
      },

      // pagination
      pageInfo: null,
      totalCount: 0,
      edgeCount: 0,
      page: 1,
      itemsPerPage:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"), // hardcode for auto case
      first:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"),
      after: null,
      last: null,
      before: null,
      hasNextPage: null,
      hasPreviousPage: null,
      startCursor: null,
      endCursor: null,
      showPagination: false,

      // gql
      skipQuery: true,

      // email
      emailList: {},
      taxRisList: [],
      emailInput: "",
      awaitingDrag: false,
      timer: false,
      sentEmailHover: false,
      sentTaxRisHover: false,
      // export
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      exportDialog: false,
      exportLoading: false,
      dateExportStart: "",
      dateExportEnd: "",

      // monthly pdf
      monthlyDownloadDialog: false,
      // Quota paywall — ปลดล็อกฝั่งเจ้าหน้าที่
      unlockQuotaDialog: false,
      unlockQuotaMonth: "",
      unlockMonthMenu: false,
      unlockQuotaLoading: false,
      relockQuotaLoading: false,
      exportEmailStatusRadios: "All",
      importDialog: false,
      importFile: [],
      importFileTemp2: [],
      importFileTemp2Head: [],
      importFileTemp2Line: [],
      documentTypeKey: "",
      currentXmlUrl: null,
      networkStatus: {
        status: null,
        message: ''
      },
      checkingNetwork: false,
      uploadingCSV: false,
      // Encoding information
      template1Encoding: null,
      template2HeadEncoding: null,
      template2LineEncoding: null,
      // Upload Log Dialog
      showUploadLogDialog: false,
    };
  },
  created() {
    this.query();
    // Single debounced resize handler, kept on the instance so the exact same
    // reference can be removed in destroyed() (an anonymous closure could not).
    this._onResize = () => {
      clearTimeout(this._resizeId);
      this._resizeId = setTimeout(this.handleResize, 100);
    };
    window.addEventListener("resize", this._onResize);
    this.handleResize();
    this.loadEmailTemplateList();
    //uploadtemplate
    this.$store.dispatch("companies/getCompany", {
      companyID: this.companyID,
    });
    // โหลดการตั้งค่า enableCsvUploadHistory
    this.$store.dispatch("companies/getCompanyDetailSetting", {
      id: this.companyID,
    });
    let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        this.documentTypeKey = getDocumentTypeKey(documentType[documentType.length - 1]);
      }
    // The Lao status listener is attached/detached reactively by the
    // isLaoRtActive watcher — only on the RT page for Lao TaxRIS products.
  },
  beforeDestroy() {
    this.$store.dispatch("docs/getDocListUnsubscribe");
    if (this.laoStatusUnsub) {
      this.laoStatusUnsub();
      this.laoStatusUnsub = null;
    }
  },
  destroyed() {
    if (this._onResize) {
      window.removeEventListener("resize", this._onResize);
    }
    clearTimeout(this._resizeId);
  },
  computed: {
    isLaoTaxRisActive() {
      return !!(this.selectedProductList && this.selectedProductList.isLaoTaxRis);
    },
    // Lao eTax UI shows on the document pages this COMPANY is configured to file
    // — a subset of what the mapper supports (TX/RT as issueType=0, CR as
    // issueType=1). It is per-company because TX and RT are often the same sale
    // recorded twice: a company that bills as RT must not be offered a TX page
    // whose documents would declare the same VAT a second time.
    //
    // The list only decides what is OFFERED. enqueueLaoEtaxIssue resolves it
    // again server-side and refuses anything outside it before writing a single
    // field, so this is convenience and clarity, not the enforcement point.
    laoRemarkMaxLength() {
      return LAO_REMARK_MAX_LENGTH;
    },
    laoRemarkErrorText() {
      return laoRemarkError(this.laoRemarkText);
    },
    isLaoRtActive() {
      if (!this.isLaoTaxRisActive) return false;
      if (!this.laoAllowedDocTypes) return false;
      return this.laoAllowedDocTypes.indexOf(this.documentTypeKey) !== -1;
    },
    // The toolbar above the table is the Thai e-Tax workflow: download the
    // signed XML/PDF, mail them to the buyer, clear the "downloaded" flag,
    // import documents from CSV. None of it applies to a Lao-only company —
    // Lao documents never get @SignedXmlUrl / @SignedPdfUrl (the mapper writes
    // "" and nothing fills them; the PDF is rendered on demand instead), and
    // documents arrive through the ERP API, not a CSV upload. Every one of
    // those buttons is therefore permanently greyed out at (0) there, which
    // reads as "broken" rather than "not for you". Hide them instead.
    // The same goes for the selection actions อัปเดทเอกสาร (clears the signed
    // files so Thai signing re-runs) and ยกเลิกเอกสาร (the Thai CL flow): a
    // Lao invoice is cancelled through TaxRIS, not by these.
    //
    // LAO-ONLY is the condition, not "is Lao": isEtax and isLaoTaxRis are
    // independent product flags and a company may hold both. For one that
    // does, the Thai documents on this same page are signed, mailed and
    // downloaded exactly as before — taking the toolbar away would break a
    // product it actually pays for. Only isLaoTaxRis without isEtax hides it.
    //
    // The selection checkbox and "ยกเลิกการเลือก" stay either way: the Lao send
    // flow is driven by exactly that selection.
    //
    // Gated on the ProductList read too, not just its result: selectedProductList
    // is {} until that read lands, which is indistinguishable from "not Lao".
    // Without the wait the whole Thai toolbar renders and then disappears on
    // every Lao page load. The skeleton in the template holds the space.
    showThaiEtaxTools() {
      if (this.isProductListLoading) return false;
      if (!this.isLaoTaxRisActive) return true;
      return !!(this.selectedProductList && this.selectedProductList.isEtax);
    },
    // The same product rule showThaiEtaxTools encodes, stated positively: this
    // company files to Lao and nowhere else. The two are kept separate because
    // showThaiEtaxTools also answers "not yet known" with false, which is right
    // for a toolbar whose space a skeleton is holding and wrong for anything that
    // takes something away — see applyLaoDefaultHiddenColumns.
    //
    // Use this, NOT isLaoTaxRisActive, whenever the change REMOVES something Thai:
    // isEtax and isLaoTaxRis are independent flags, a company may hold both, and
    // for that company the Thai documents on this page are signed, mailed and
    // downloaded as always. Offering something Lao is the other direction —
    // isLaoTaxRisActive — because a company that pays for Lao should get it.
    isLaoOnlyCompany() {
      if (!this.isLaoTaxRisActive) return false;
      return !(this.selectedProductList && this.selectedProductList.isEtax);
    },
    // Noun for the document being sent, so the Lao send button/dialog read
    // correctly on each page: CR (DocType 4) = ใบลดหนี้, RT (6) = ใบกำกับภาษี.
    laoDocNoun() {
      return this.documentTypeKey === 4 ? "ใบลดหนี้" : "ใบกำกับภาษี";
    },
    // What the send button counts. Selecting a page normally sweeps in
    // documents that are already approved or still in flight, and the send path
    // drops those (laoSendableObjectIDs, mirrored by the enqueue backend). A
    // raw selection count therefore promises a send that will not happen —
    // "นำส่ง (12)" followed by 4 actually queued. Counting the same partition
    // the send uses means the button cannot overstate.
    //
    // Recomputes whenever laoStatusMap changes, which is the case that matters.
    // The staleness cutoff inside it reads Date.now() and so does not re-evaluate
    // on its own — same as laoCanRetry on each row. Harmless: this is the
    // preview, and the send re-partitions at click time.
    laoSelectedPartition() {
      return this.laoSendableObjectIDs(this.selectedList.map((x) => x.docID));
    },
    laoSendableCount() {
      return this.laoSelectedPartition.sendable.length;
    },
    laoSkippedCount() {
      return (
        this.laoSelectedPartition.doneCount +
        this.laoSelectedPartition.inflightCount
      );
    },
    // เงื่อนไขเดิมที่ระบบใช้มาก่อน รวม isDeveloper ของผู้ใช้ในบริษัทลูกค้าด้วย
    // เหลือไว้ให้สวิตช์ Mock ของ Lao eTax ใช้ตามเดิม ไม่ใช้กับเครื่องมือที่แตะข้อมูลจริง
    canUseDevTools() {
      const email = this.user?.email || "";
      return (
        !!this.userCompany?.isDeveloper ||
        !!this.user?.isEngineer ||
        email.endsWith("@sala-daeng.com")
      );
    },
    // เครื่องมือฝั่งเจ้าหน้าที่ — ลูกค้าต้องไม่เห็น
    //
    // เดิมนับ userCompany.isDeveloper ด้วย แต่ธงนั้นตั้งที่ผู้ใช้รายคนในบริษัทลูกค้า
    // เปิดให้ลูกค้าเองได้ เครื่องมืออย่างปลดล็อกโควต้า/กู้คืนเอกสารจึงหลุดถึงมือลูกค้า
    // เหลือเฉพาะสองทางที่เป็นของทีมเราจริง ๆ
    canUseAdminTools() {
      const email = this.user?.email || "";
      return !!this.user?.isEngineer || email.endsWith("@sala-daeng.com");
    },
    laoTestResultTitle() {
      if (!this.laoTestResult || this.laoTestResult.ok) return "";
      const t = this.laoTestResult.errorType;
      if (t === "config") return "ตั้งค่า ETAX_LAO_* ไม่ครบ";
      if (t === "business") return "Gateway ปฏิเสธ (business)";
      if (t === "rate-limit") return "ถูก rate limit";
      if (t === "gateway") return "Gateway error";
      if (t === "network") return "เชื่อมต่อไม่สำเร็จ";
      if (t === "invalid-argument") return "ข้อมูลไม่ถูกต้อง";
      return "ทดสอบไม่สำเร็จ";
    },
    laoTestResultPretty() {
      if (!this.laoTestResult) return "";
      try {
        return JSON.stringify(this.laoTestResult, null, 2);
      } catch (e) {
        return String(this.laoTestResult);
      }
    },
    laoIssueResultTitle() {
      if (!this.laoIssueResult || this.laoIssueResult.ok) return "";
      const t = this.laoIssueResult.errorType;
      if (t === "config") return "ตั้งค่า ETAX_LAO_* ไม่ครบ";
      if (t === "not-implemented") return "โหมดข้อมูลจริงยังไม่พร้อม";
      if (t === "business") return "Gateway ปฏิเสธ (business)";
      if (t === "rate-limit") return "ถูก rate limit";
      if (t === "gateway") return "Gateway error";
      if (t === "network") return "เชื่อมต่อไม่สำเร็จ";
      if (t === "invalid-argument") return "ข้อมูลไม่ถูกต้อง";
      return "ส่งไม่สำเร็จ";
    },
    laoIssueResultPretty() {
      if (!this.laoIssueResult) return "";
      try {
        return JSON.stringify(this.laoIssueResult, null, 2);
      } catch (e) {
        return String(this.laoIssueResult);
      }
    },
    laoIssueMockPreview() {
      const issueCode = (this.laoIssueCode || "").trim() || "1234567890";
      const buyerCode = (this.laoBuyerCode || "").trim() || "8765678987656";
      const sample = {
        issueCode: issueCode,
        data: {
          serialNum: "<generated server-side>",
          issueType: 0,
          issueCode: issueCode,
          supplierCode: issueCode,
          buyerCode: buyerCode,
          totalNetAmount: "100.00",
          totalTaxAmount: "10.00",
          remarks: "test invoice",
          partyList: [
            { sn: 1, partyType: "001", code: issueCode, name: "ACME Co., Ltd." },
            { sn: 2, partyType: "003", code: buyerCode, name: "Beta Trading" },
          ],
          taxList: [{ sn: 1, taxType: "001", taxAmount: "10.00" }],
          lineList: [
            {
              sn: 1,
              description: "Apple",
              unitPrice: "100",
              quantity: "1",
              unit: "individual",
              taxExcludingAmount: "100.00",
              taxAmount: "10.00",
              taxIncludingAmount: "110.00",
              taxList: [{ sn: 1, taxType: "001", taxRate: "0.1", taxAmount: "10.00" }],
            },
          ],
        },
      };
      try {
        return JSON.stringify(sample, null, 2);
      } catch (e) {
        return "";
      }
    },
    laoIssueSendIsDryRun() {
      return !this.laoIssueUseMock && this.laoIssueDryRun;
    },
    // Mock needs no selection. A dry run previews whatever is selected —
    // including already-issued documents, since seeing their payload is
    // legitimate. A real send needs at least one document that would actually
    // go to the queue, so an all-approved selection disables the button instead
    // of accepting the click and answering with "ไม่มีรายการที่ส่งได้".
    laoIssueSendDisabled() {
      if (this.laoIssueUseMock) return false;
      if (this.selectedList.length < 1) return true;
      return !this.laoIssueDryRun && this.laoSendableCount < 1;
    },
    laoIssueSendLabel() {
      if (this.laoIssueLoading) return "กำลังประมวลผล...";
      if (this.laoIssueSendIsDryRun) return "ดู payload";
      // Say the number about to be queued, so the confirmation matches the
      // button that opened the dialog rather than the raw selection.
      if (!this.laoIssueUseMock) return "ส่งเข้าคิว (" + this.laoSendableCount + ")";
      return "ส่ง";
    },
    ...mapState({
      docs: (state) => state.docs.list,
      loading: (state) => state.docs.loading,
      hiddenByQuota: (state) => state.docs.hiddenByQuota,
      // page: state => state.docs.page,
      keyword: (state) => state.docs.keyword,
      downloaded: (state) => state.docsDownloaded.downloaded,
      downloadingXml: (state) => state.docsDownloaded.downloadingXml,
      downloadingPdf: (state) => state.docsDownloaded.downloadingPdf,
      downloadStatus: (state) => state.docsDownloaded.downloadStatus,
      selectedBranch: (state) => state.companies.selectedBranch,
      currentUploadLog: (state) => state.uploadLog.currentUploadLog,
      orderBySelect: (state) => state.docs.orderBySelect,
      valueFilterList: (state) => state.docs.valueFilterList,
      selectedList: (state) => state.docs.selectedList,
      showPaginationTemplate: (state) => state.docs.showPaginationTemplate,
      companyStatus: (state) => state.statusesByCompany.companyStatus,
      globalLoading: (state) => state.loading.globalLoading,
      summaryAll: (state) => state.docs.summaryAll,
      companyDetail: (state) => state.companies.companyDetail,
      enableCsvUploadHistory: (state) => state.companies.enableCsvUploadHistory,
      userCompany: (state) => state.user.userCompany,
      user: (state) => state.user.userData,
      selectedProductList: (state) => state.companies.selectedCompanyProductList,
      // Starts true and flips once ProductList/PSC has been read. Until then
      // "is this a Lao company" has no answer yet — see showThaiEtaxTools.
      isProductListLoading: (state) => state.companies.isProductListLoading,
      companyUsage: (state) => state.companies.companyUsage,
      paymentDetail: (state) => state.paymentPlans.paymentDetail,
    }),
    // Quota paywall — กันชนชั้นสอง: store คัดใบที่ติดธง @OverQuota ออกตั้งแต่ตอนดึง
    // และเติมหน้าให้เต็มแล้ว ตรงนี้เหลือไว้กันเส้นทางที่ยังส่งใบที่ซ่อนมา (เช่นโหมดค้นหา)
    visibleDocs() {
      return (this.docs || []).filter((d) => d["@OverQuota"] !== true);
    },
    fromDateDisp() {
      return this.fromDateVal;
      // format/do something with date
    },
    toDateDisp() {
      return this.toDateVal;
      // format/do something with date
    },
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.fromDateDisp);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().substr(0, 10); // Format as "YYYY-MM-DD"
    },
    isBtnDisabled() {
      return !this.selectedList.some(item => item.xmlUrl && item.xmlUrl.trim() !== '');
    },
    isCompanySuspended() {
      return this.companyDetail?.isSuspended === true;
    },
    // บริษัทที่ใช้ "นำเข้าข้อมูล CSV" (isEtaxType 4) ห้ามดาวน์โหลด XML/PDF ของเอกสารที่ถูกยกเลิก
    isCsvImportCompany() {
      return !!(
        this.selectedProductList?.isEtax &&
        this.selectedProductList?.isEtaxType === 4
      );
    },
    isQuotaExceeded() {
      const planId = this.paymentDetail?.id;
      if (!planId || planId === 'free_month') return false;
      const used = Number(this.companyUsage?.countsDocsAll) || 0;
      const limit = Number(this.paymentDetail?.docsPerMonth) || 0;
      if (!limit) return false;
      return used >= limit;
    },
    importDocCount() {
      if (this.selectedTemp === 'template-1') {
        const data = this.importFile?.data;
        if (!data || data.length <= 1) return 0;
        // นับเฉพาะ row ที่มี sellerName (col[1]) — เป็น header ของเอกสาร
        // row ที่ sellerName ว่างคือ line item ของเอกสารนั้น ไม่นับ
        return data.slice(1).filter(row => row[1] && String(row[1]).trim() !== '').length;
      }
      // template-2: ไฟล์ head แต่ละ row = 1 เอกสาร
      const data = this.importFileTemp2Head?.data;
      if (!data || data.length <= 1) return 0;
      return data.length - 1;
    },
    importQuotaStatus() {
      const planId = this.paymentDetail?.id;
      if (!planId || planId === 'free_month') return null;
      const used = Number(this.companyUsage?.countsDocsAll) || 0;
      const limit = Number(this.paymentDetail?.docsPerMonth) || 0;
      if (!limit || !this.importDocCount) return null;
      const afterImport = used + this.importDocCount;
      if (afterImport > limit) return 'exceeded';
      if (afterImport === limit) return 'full';
      if (afterImport / limit >= 0.7) return 'warning';
      return null;
    },
  },

  watch: {
    // Clear the previous run's results whenever the send dialog OPENS. Closing
    // cannot be the only place this happens: the dialog is opened by a v-dialog
    // activator (no handler of ours runs), and a fully clean send closes it from
    // inside callIssueLaoEtaxInvoice without going through closeLaoIssueDialog.
    // So after a send with no invalid rows and no warnings, picking new rows
    // reopened the dialog still showing the previous result panel — which reads
    // as "these rows were already sent". Resetting on open covers every path in.
    laoIssueDialog(open) {
      if (!open) return;
      this.resetLaoIssueOutcome();
      // Mock mode is reset because it changes WHAT gets sent, not just how: the
      // send button then ignores the selection and files a canned invoice
      // (callIssueLaoEtaxInvoice takes no companyID in mock mode, and on a prod
      // company the backend forces it to dry-run — so the visible outcome is a
      // success panel with nothing queued at all, while the user believes the
      // rows they picked went out). It is staff-only and used once in a while,
      // so carrying it across opens buys nothing and can swallow a real send.
      this.laoIssueUseMock = false;
      // laoIssueDryRun is deliberately NOT reset, and the difference is the
      // audience. It is visible to every customer and sits in the middle of the
      // daily workflow: the dialog opens in preview mode and you switch it off
      // to send for real. Resetting it would add that switch to every real send
      // a customer ever makes, to guard against a far milder mistake — with
      // dry-run off you still send exactly the documents you selected, and the
      // button reads "ส่งเข้าคิว (N)" the whole time it is armed. Remembering
      // "I am past previewing" is the useful behaviour here.
    },
    // Resolve which document types this company may file, once the product flag
    // is known. Only Lao TaxRIS companies pay the Settings read; everyone else
    // never touches it. Left null on failure, which hides the send UI — for a
    // button that files real tax invoices, "we could not check" has to mean no.
    isLaoTaxRisActive: {
      immediate: true,
      handler: async function (active) {
        if (!active) {
          this.laoAllowedDocTypes = null;
          this.applyLaoExtraColumns([]);
          return;
        }
        const companyID = this.companyID || this.$route.params.companyId;
        this.laoAllowedDocTypes = await resolveAllowedLaoDocTypes(fc.db, companyID);
        // Same Settings doc, read separately so the doc-type resolution — which
        // gates a button that files real tax invoices — keeps its own failure
        // handling. One extra document read, on Lao companies only.
        this.applyLaoExtraColumns(
          await resolveLaoExtraColumns(fc.db, companyID)
        );
      },
    },
    // Columns that can only ever be empty for a Lao filing start hidden — but on
    // LAO-ONLY companies, which is why this watches isLaoOnlyCompany and not
    // isLaoTaxRisActive. For a company holding Thai eTax as well, those two
    // columns carry real signed XML/PDF for its Thai documents, so it keeps them;
    // that company flips isLaoTaxRisActive true while this stays false, which is
    // exactly the distinction a single watcher could not make.
    //
    // Needs no Firestore read of its own, so it lands before the Settings reads
    // in the watcher above rather than after them.
    isLaoOnlyCompany: {
      immediate: true,
      handler: function (laoOnly) {
        this.applyLaoDefaultHiddenColumns(laoOnly);
      },
    },
    // Attach the live Lao status listener only on the RT documents page for
    // Lao TaxRIS products, and tear it down when leaving the page or the
    // product is not (or no longer) Lao.
    isLaoRtActive: {
      immediate: true,
      handler: function (active) {
        if (active) {
          this.startLaoStatusListener();
        } else if (this.laoStatusUnsub) {
          this.laoStatusUnsub();
          this.laoStatusUnsub = null;
          this.laoStatusKey = "";
          this.laoStatusMap = {};
        }
      },
    },
    // Prefill the connectivity-test Issue Code with the company's tax ID
    // when the dialog opens. Only fills when empty so it never overwrites
    // what the user is typing; it resets to "" on close so it refills next time.
    laoTestDialog: {
      handler: function (open) {
        if (open && !this.laoTestIssueCode) {
          this.laoTestIssueCode = ((this.companyDetail && this.companyDetail.taxID) || "").trim();
        }
      },
    },
    defaultSearchOptionValue: {
      handler: function () {
        this.$store.dispatch("docs/setFromDate", "");
        this.$store.dispatch("docs/setToDate", "");
        this.$store.dispatch("docs/updateKeyword", "");
        this.clearValue();
        this.clearSelectList();
        this.fromDateVal = null;
        this.toDateVal = null;
        this.query();
      },
    },
    selectedBranch: {
      handler: function () {
        this.query();
      },
    },
    fromDateVal: {
      handler: function () {
        this.$store.dispatch("docs/setFromDate", this.fromDateVal);
        if (this.fromDateVal !== "") {
          this.query();
        }
      },
    },
    toDateVal: {
      handler: function () {
        this.$store.dispatch("docs/setToDate", this.toDateVal);
        if (this.toDateVal !== "") {
          this.query();
        }
      },
    },
    $route() {
      this.clearValue();
      this.query();
      let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        this.documentTypeKey = getDocumentTypeKey(documentType[documentType.length - 1]);
      }
      if(documentType.length === 2) {
        this.documentTypeKey = ""
      }
    },
    valueFilterList: {
      handler: function () {
        this.query();
      },
    },
    selectedList: {
      handler: function () {
        this.checkSelectedAll();
      },
    },
    docs: {
      handler: function () {
        this.checkSelectedAll();
        // New page / search result → follow the rows now on screen.
        if (this.isLaoRtActive) this.syncLaoStatusListeners();
      },
    },
    height: {
      handler: function () {
        this.matchHeight();
      },
    },
  },
  // methods: {
  //   loadMore() {},
  //     }
  //   },

  // },
  methods: {
    async callTestLaoEtaxConnection() {
      const issueCode = (this.laoTestIssueCode || "").trim();
      if (!issueCode) return;
      this.laoTestLoading = true;
      this.laoTestResult = null;
      try {
        const callable = firebase
          .functions()
          .httpsCallable("callQueryLaoEtaxTaxList");
        // companyID selects WHICH gateway to probe — env is per company
        // (Settings/laoEtax), so the test must target the same one the send
        // button would use.
        const companyID = this.companyID || this.$route.params.companyId;
        const res = await callable({ issueCode, companyID });
        this.laoTestResult = res && res.data ? res.data : { ok: false, errorType: "unknown", message: "empty response" };
      } catch (err) {
        this.laoTestResult = {
          ok: false,
          errorType: "callable",
          message: (err && err.message) || String(err),
          code: err && err.code,
        };
      } finally {
        this.laoTestLoading = false;
      }
    },
    closeLaoTestDialog() {
      this.laoTestDialog = false;
      this.laoTestResult = null;
      this.laoTestIssueCode = "";
    },
    async callIssueLaoEtaxInvoice() {
      this.laoIssueLoading = true;
      this.resetLaoIssueOutcome();
      try {
        const callable = firebase
          .functions()
          .httpsCallable("callIssueLaoEtaxInvoice");

        if (this.laoIssueUseMock) {
          const res = await callable({
            useMock: true,
            issueCode: (this.laoIssueCode || "").trim(),
            buyerCode: (this.laoBuyerCode || "").trim(),
          });
          this.laoIssueResult = res && res.data
            ? res.data
            : { ok: false, errorType: "unknown", message: "empty response" };
          return;
        }

        const companyID = this.$route.params.companyId;
        const objectIDs = this.selectedList.map((x) => x.docID);

        // Dry-run stays a synchronous preview (no gateway, no queue): map each
        // selected doc one by one and show the resulting payload.
        if (this.laoIssueDryRun) {
          this.laoIssueProgress = { current: 0, total: objectIDs.length };
          for (let i = 0; i < objectIDs.length; i++) {
            const objectID = objectIDs[i];
            this.laoIssueProgress.current = i + 1;
            let entry;
            try {
              const res = await callable({ useMock: false, companyID, objectID, dryRun: true });
              const data = res && res.data
                ? res.data
                : { ok: false, errorType: "unknown", message: "empty response" };
              entry = Object.assign({ docID: objectID }, data);
            } catch (err) {
              entry = {
                docID: objectID,
                ok: false,
                errorType: "callable",
                message: (err && err.message) || String(err),
              };
            }
            this.laoIssueResults = this.laoIssueResults.concat(entry);
          }
          return;
        }

        // Real send: drop docs already issued/approved or in flight BEFORE the
        // round-trip — re-issuing an approved doc is pointless (the backend skips
        // it and serialNum dedups anyway), so prevent it up front and tell the
        // user clearly. Only never-sent / retryable (failed/invalid/timeout) docs
        // go to the queue.
        const partition = this.laoSendableObjectIDs(objectIDs);
        if (partition.sendable.length === 0) {
          this.alert = {
            text:
              "ไม่มีรายการที่ส่งได้ — ที่เลือกออกใบแล้วหรือกำลังดำเนินการ (" +
              objectIDs.length +
              " รายการ)",
            type: "info",
            show: true,
          };
          return;
        }

        // Hand off to the backend queue (Cloud Tasks, one-at-a-time). The
        // function marks each doc @LaoEtaxStatus=queued and returns at once;
        // per-document status then updates live in the table.
        const enqueue = firebase.functions().httpsCallable("enqueueLaoEtaxIssue");
        const res = await enqueue({ companyID, objectIDs: partition.sendable });
        this.laoIssueResult = res && res.data
          ? res.data
          : { ok: false, errorType: "unknown", message: "empty response" };
        if (this.laoIssueResult.ok) {
          const queued = this.laoIssueResult.queued || 0;
          let text = "ส่งเข้าคิว Lao eTax แล้ว " + queued + " รายการ";
          if (partition.doneCount > 0) {
            text += " · ข้ามไปแล้ว " + partition.doneCount + " รายการ (ออกใบแล้ว)";
          }
          if (partition.inflightCount > 0) {
            text += " · ข้าม " + partition.inflightCount + " รายการ (กำลังดำเนินการ)";
          }
          // Only reachable from a tab opened before the company's doc-type
          // allow-list changed — the page itself no longer offers the action.
          // Without this the send reads as "queued 0" with no reason given.
          const blocked = (this.laoIssueResult.skipped || []).filter(
            (s) => s && s.reason === "doctype-not-allowed"
          ).length;
          if (blocked > 0) {
            text +=
              " · ข้าม " + blocked +
              " รายการ (บริษัทนี้ไม่ได้เปิดให้นำส่งเอกสารประเภทนี้ — โหลดหน้าใหม่)";
          }
          // Already issued at the gateway: not sent again, just polled again.
          const rechecked = (this.laoIssueResult.rechecked || []).length;
          if (rechecked > 0) {
            text += " · ตรวจสถานะใหม่ " + rechecked + " รายการ (ออกใบแล้ว รอผลอนุมัติ)";
          }
          // Documents the backend refused because their own contents don't hold
          // together (wrong currency, missing buyer TIN, header totals that
          // disagree with the lines). Unlike the other skip reasons this one is
          // not going to resolve itself with time or a reload — the document has
          // to be corrected — so keep the dialog open and name each one instead
          // of collapsing them into a count in a snackbar that scrolls away.
          const invalid = (this.laoIssueResult.skipped || []).filter(
            (s) => s && s.reason === "invalid-data"
          );
          // Documents that WERE sent but carry a non-blocking finding (no buyer
          // address, zero VAT on a document with value, ...). Shown for the same
          // reason the blocked ones are: a warning that only reaches Cloud
          // Logging is a warning nobody reads, and nobody runs a dry run first
          // every time. They are already queued — this is "look at this", not
          // "something went wrong".
          const warned = this.laoIssueResult.warned || [];
          if (invalid.length > 0 || warned.length > 0) {
            this.laoIssueResults = invalid
              .map((s) => ({
                docID: s.objectID,
                ok: false,
                errorType: "invalid-data",
                message: s.detail || "ข้อมูลในเอกสารไม่ถูกต้อง",
              }))
              .concat(
                warned.map((w) => ({
                  docID: w.objectID,
                  ok: true,
                  message: "ส่งเข้าคิวแล้ว — มีข้อควรตรวจสอบ",
                  validation: {
                    errors: [],
                    warnings: (w.messages || []).map((m) => ({ message: m })),
                  },
                }))
              );
          }
          if (invalid.length > 0) {
            text += " · ข้อมูลไม่ถูกต้อง " + invalid.length + " รายการ (ดูรายละเอียดด้านล่าง)";
          }
          if (warned.length > 0) {
            text += " · มีข้อควรตรวจสอบ " + warned.length + " รายการ (ดูรายละเอียดด้านล่าง)";
          }
          this.alert = {
            text: text,
            type: queued > 0 ? "success" : "info",
            show: true,
          };
          // Nothing for the user to read in the dialog, so get out of the way —
          // the snackbar already carries the outcome. The result state is left
          // as it is on purpose; the laoIssueDialog watcher clears it on the
          // next open, which is the only place that covers the activator path.
          if (invalid.length === 0 && warned.length === 0) {
            this.laoIssueDialog = false;
          }
        }
      } catch (err) {
        this.laoIssueResult = {
          ok: false,
          errorType: "callable",
          message: (err && err.message) || String(err),
          code: err && err.code,
        };
      } finally {
        this.laoIssueLoading = false;
      }
    },
    // Everything the dialog shows ABOUT A RUN — not the form state (mock
    // toggle, codes, dry-run), which is the user's choice and survives on
    // purpose. Cleared from three places: the close button, the start of a
    // send, and the dialog's own open watcher. The watcher is the one that
    // matters: this dialog is opened by a v-dialog activator, so we get no
    // open handler, and a clean send closes it from inside
    // callIssueLaoEtaxInvoice without coming through closeLaoIssueDialog.
    resetLaoIssueOutcome() {
      this.laoIssueResult = null;
      this.laoIssueResults = [];
      this.laoIssueProgress = { current: 0, total: 0 };
    },
    closeLaoIssueDialog() {
      this.laoIssueDialog = false;
      this.resetLaoIssueOutcome();
    },
    // Live Lao eTax status for the documents ON THIS PAGE, by document ID.
    //
    // It used to be one company-wide `@LaoEtaxStatus in [...]` listener. That
    // kept every sent document of every date in the Firestore cache, and the
    // page list (store/collection/docs.js) is answered from that cache before
    // the server: on next/prev the table flashed "whatever sent documents fall
    // after the cursor" until the real page arrived — seconds later, because
    // production forces long-polling (firebaseConfig). Scoping to the rows on
    // screen caches nothing the page list has not already loaded.
    //
    // `in` takes at most 10 values, so one listener per 10 rows. Entries of
    // rows that leave the page are kept (just no longer live): the selection
    // survives paging, and the send button's count (laoSelectedPartition) must
    // still know those documents were already approved.
    startLaoStatusListener() {
      this.syncLaoStatusListeners();
    },
    syncLaoStatusListeners() {
      const companyID = this.companyID || this.$route.params.companyId;
      if (!companyID || !this.isLaoRtActive) return;
      const ids = Array.from(
        new Set((this.docs || []).map((d) => d.id).filter(Boolean))
      );
      const key = ids.slice().sort().join(",");
      if (this.laoStatusUnsub && key === this.laoStatusKey) return;
      if (this.laoStatusUnsub) this.laoStatusUnsub();
      this.laoStatusKey = key;
      const unsubs = [];
      try {
        for (let i = 0; i < ids.length; i += 10) {
          unsubs.push(
            fc.db
              .collection(`Companies/${companyID}/Docs`)
              .where(firebase.firestore.FieldPath.documentId(), "in", ids.slice(i, i + 10))
              .onSnapshot(
                (snap) => {
                  const map = { ...this.laoStatusMap };
                  snap.forEach((d) => {
                    const entry = this.laoStatusEntry(d.data() || {});
                    if (entry.status) map[d.id] = entry;
                    else delete map[d.id];
                  });
                  this.laoStatusMap = map;
                },
                (err) => {
                  console.error("lao status listener error:", err);
                }
              )
          );
        }
      } catch (e) {
        console.error("syncLaoStatusListeners error:", e);
      }
      this.laoStatusUnsub = () => unsubs.forEach((u) => u());
    },
    laoStatusEntry(data) {
      return {
        status: data["@LaoEtaxStatus"] || "",
        serialNum: data["@LaoEtaxSerialNum"] || "",
        invoiceNumber: data["@LaoEtaxInvoiceNumber"] || "",
        checkCode: data["@LaoEtaxCheckCode"] || "",
        url: data["@LaoEtaxUrl"] || "",
        qrCodeUrl: data["@LaoEtaxQRCodeURL"] || "",
        errorType: data["@LaoEtaxErrorType"] || "",
        errorCode: data["@LaoEtaxErrorCode"] || "",
        errorMessage: data["@LaoEtaxErrorMessage"] || "",
        creditNotes: Array.isArray(data["@LaoEtaxCreditNotes"])
          ? data["@LaoEtaxCreditNotes"]
          : [],
        creditedNet: data["@LaoEtaxCreditedNet"] || "",
        // Epoch ms, for the stale-in-flight check below.
        updatedAtMs:
          data["@LaoEtaxUpdatedAt"] &&
          typeof data["@LaoEtaxUpdatedAt"].toMillis === "function"
            ? data["@LaoEtaxUpdatedAt"].toMillis()
            : null,
        // The SAP writeback state, so that column is live too. The
        // connector runs on someone else's machine, and after a
        // manual "clear error and retry" the whole point is watching
        // the icon change without reloading the page.
        sap: {
          "@LaoEtaxSapSynced": data["@LaoEtaxSapSynced"],
          "@LaoEtaxSapSyncError": data["@LaoEtaxSapSyncError"],
          "@DB": data["@DB"],
        },
      };
    },
    laoStatusValue(doc) {
      // Live map wins; fall back to whatever was on the fetched document.
      const entry = this.laoStatusMap[doc.id];
      if (entry && entry.status) return entry.status;
      return doc["@LaoEtaxStatus"] || "";
    },
    laoStatusMeta(status) {
      return LAO_ETAX_STATUS_META[status] || null;
    },
    laoStatusDetail(doc) {
      const entry = this.laoStatusMap[doc.id];
      if (!entry) return "";
      if (
        entry.status === "failed" ||
        entry.status === "invalid" ||
        entry.status === "verify-timeout"
      ) {
        return this.laoErrorHint(entry);
      }
      if (entry.invoiceNumber) {
        return "เลขใบกำกับ: " + entry.invoiceNumber;
      }
      return "";
    },
    // Turn a raw Lao eTax error (type + "HTTP 4xx"/message) into a clear,
    // actionable Thai hint. Falls back to the raw message when unrecognised.
    laoErrorHint(entry) {
      const type = (entry && entry.errorType) || "";
      const msg = (entry && entry.errorMessage) || "";
      const has = (code) => msg.indexOf(code) !== -1;

      // A recognised gateway TS code is the most precise hint — it covers the
      // credit-note rejections (TS0114 already credited, TS20461/TS20331 outside
      // the allowed window, TS20212 original already cancelled, …). Prefer it
      // over the coarse error-type fallbacks below.
      const tsHint = this.laoTsHint((entry && entry.errorCode) || "");
      if (tsHint) return tsHint;

      // Credit-note preconditions raised locally before the gateway round-trip
      // (e.g. original not yet approved, missing ARD reference).
      if (type === "precondition") {
        return msg || "ใบกำกับต้นฉบับยังไม่พร้อมออกใบลดหนี้";
      }

      // Gateway/Kong-level rejections (auth/ACL/IP) — the request never reached
      // the tax-server's business logic. These need account/permission fixes,
      // not a retry.
      if (type === "gateway") {
        if (has("403")) {
          return "ถูกปฏิเสธจาก Lao eTax (403) — บัญชี/สิทธิ์ หรือเลขผู้เสียภาษียังไม่ได้รับอนุญาตให้ออกใบกำกับ ติดต่อผู้ดูแลระบบ eTax";
        }
        if (has("401")) {
          return "ยืนยันตัวตนกับ Lao eTax ไม่สำเร็จ (401) — ตรวจสอบ username/secret ของเกตเวย์";
        }
        return "เกตเวย์ Lao eTax ตอบกลับผิดพลาด" + (msg ? " (" + msg + ")" : "");
      }
      if (type === "rate-limit") {
        return "ระบบ Lao eTax กำลังใช้งานหนา (rate limit) — ระบบจะลองใหม่ให้ หรือส่งใหม่ภายหลัง";
      }
      if (type === "network") {
        return "เชื่อมต่อ Lao eTax ไม่สำเร็จ (network) — ลองส่งใหม่อีกครั้ง";
      }
      if (type === "config") {
        return "ตั้งค่า Lao eTax ไม่ครบ — ติดต่อผู้ดูแลระบบ";
      }
      if (type === "product-disabled") {
        return "บริษัทนี้ไม่ได้เปิดใช้งาน Lao TaxRIS";
      }
      if (type === "credit-exceeded") {
        return msg || "ยอดลดหนี้เกินยอดคงเหลือที่ลดได้ของใบกำกับต้นฉบับ";
      }
      if (type === "credit-partial") {
        return (
          msg ||
          "ใบลดหนี้ต้องลดเต็มจำนวนของใบกำกับต้นฉบับ — ระบบ Lao eTax ไม่รับใบลดหนี้บางส่วน ให้ลดเต็มใบ แล้วออกใบกำกับใหม่ตามยอดที่ถูกต้อง"
        );
      }
      if (type === "mapping" || type === "unsupported-doctype") {
        return "ข้อมูลเอกสารไม่พร้อมส่ง Lao eTax" + (msg ? " — " + msg : "");
      }
      // business = the tax server returned a real validation message; show it.
      return msg;
    },
    laoIsError(doc) {
      const s = this.laoStatusValue(doc);
      return s === "failed" || s === "invalid" || s === "verify-timeout";
    },
    // Credit notes recorded against this (original) invoice, written by the
    // verify cron when an approved CR references it. Live map wins, then the doc.
    laoCreditNotes(doc) {
      const entry = this.laoStatusMap[doc.id];
      const fromMap = entry && entry.creditNotes;
      const list = fromMap && fromMap.length ? fromMap : doc["@LaoEtaxCreditNotes"];
      return Array.isArray(list) ? list : [];
    },
    laoIsCredited(doc) {
      return this.isLaoTaxRisActive && this.laoCreditNotes(doc).length > 0;
    },
    // The SAP sync column. The writer is the PSC connector (etax-db repo): on
    // @LaoEtaxStatus='approved' it posts the invoice into SAP B1 and writes
    // @LaoEtaxSapSynced, @LaoEtaxSapSyncError ('' on success, a message on
    // failure), @LaoEtaxSapSyncedDocNum and @LaoEtaxSapSyncedQRCodeHash.
    //
    // This column used to read the boolean alone, which collapsed three real
    // states into two: a doc that FAILED to sync drew the same grey empty
    // circle as one simply not picked up yet, and the reason — already sitting
    // in Firestore — was discarded. So the row said "wait" about a document
    // that would never sync until someone filled in @DB by hand.
    //
    // Read through the live listener when it has this row, so the icon follows
    // the connector in real time; fall back to the fetched document otherwise.
    laoSapSource(doc) {
      const entry = this.laoStatusMap[doc.id];
      return entry && entry.sap ? entry.sap : doc;
    },
    laoSapErrorText(doc) {
      const raw = this.laoSapSource(doc)["@LaoEtaxSapSyncError"];
      return typeof raw === "string" ? raw.trim() : "";
    },
    // null = no opinion (the connector has not touched this doc), which is the
    // '-' case. Anything else is one of the three states.
    laoSapState(doc) {
      const synced = this.laoSapSource(doc)["@LaoEtaxSapSynced"];
      if (synced !== true && synced !== false) return null;
      if (synced === true) return { icon: "mdi-check-circle", color: "#6ec39b" };
      // false WITH a message is a failure; false alone is still pending.
      if (this.laoSapErrorText(doc)) {
        return { icon: "mdi-alert-circle", color: "error", action: "clear" };
      }
      return { icon: "mdi-circle-outline", color: "#9e9e9e" };
    },
    laoSapTooltip(doc) {
      const synced = this.laoSapSource(doc)["@LaoEtaxSapSynced"];
      if (synced === true) {
        // The journal entry in SAP B1, not @LaoEtaxSapSyncedDocNum: that field
        // echoes back @LaoEtaxInvoiceNumber (the eTax number the connector
        // PUSHED), so it says nothing about where the entry landed. transId is
        // the handle someone reconciling against B1 actually looks up, and this
        // tooltip is the only place the UI exposes it.
        const sap = this.laoSapSource(doc)["@DB"] || {};
        const transId = sap.SBO_OJDT_transId;
        if (!transId) return "ซิงค์เข้า SAP แล้ว";
        return (
          "ซิงค์เข้า SAP แล้ว\n" +
          this.sapSourceDocLabel(sap.SBO_OJDT_transType) +
          " — " +
          transId
        );
      }
      const err = this.laoSapErrorText(doc);
      if (err) {
        return (
          "ซิงค์เข้า SAP ไม่สำเร็จ:\n" +
          err +
          "\n\nคลิกเพื่อล้าง error แล้วซิงค์ใหม่"
        );
      }
      return "ยังไม่ซิงค์เข้า SAP";
    },
    // OJDT.TransType is the SAP document that POSTED the journal entry, and
    // the Lao document pages each produce a different one: 13 = A/R Invoice
    // (TX), 14 = A/R Credit Memo (CR), 24 = Incoming Payment (RT). Calling
    // all three "SAP JE" told a user on the credit-memo page nothing, and the
    // raw code beside it ("transType 24") is not something anyone reads off by
    // heart, so the tooltip names the document instead. The number after the
    // dash is OJDT.TransId — the journal entry id, not the document's DocNum,
    // which the connector never sends. It prints bare, without a "JE" label.
    sapSourceDocLabel(transType) {
      const labels = {
        13: "ใบกำกับ (A/R Invoice)",
        14: "ใบลดหนี้ (A/R Credit Memo)",
        24: "ใบรับชำระ (Incoming Payment)",
      };
      const known = labels[Number(transType)];
      if (known) return known;
      // Unknown or absent: say so rather than implying a type we never saw.
      return transType ? "SAP transType " + transType : "SAP";
    },
    laoSapCanClear(doc) {
      const state = this.laoSapState(doc);
      return !!state && state.action === "clear";
    },
    laoSapIconLabel(doc) {
      if (this.laoSapCanClear(doc)) {
        return "ซิงค์ SAP ไม่สำเร็จ — คลิกเพื่อดูสาเหตุและสั่งซิงค์ใหม่ (" + doc.id + ")";
      }
      return this.laoSapTooltip(doc);
    },
    onLaoSapClick(doc) {
      if (!this.laoSapCanClear(doc)) return;
      const entry = this.laoStatusMap[doc.id] || {};
      this.laoSapErrorTarget = {
        docID: doc.id,
        invoiceNumber: entry.invoiceNumber || doc["@LaoEtaxInvoiceNumber"] || "",
        error: this.laoSapErrorText(doc),
      };
      this.laoSapErrorDialog = true;
    },
    // Clearing @LaoEtaxSapSyncError IS the retry — it is not a cosmetic reset.
    // The connector (etax-db selection.js hasUnchangedFailedAttempt) skips any
    // doc whose sync already failed with the same doc number and QR hash, and
    // the only thing that re-arms it is an empty error string. Its listener is
    // an onSnapshot over approved docs, so this write is itself the trigger:
    // there is nothing else to call, and nothing to poll.
    //
    // Deliberately a one-field merge write. The eTax result (@LaoEtaxStatus,
    // @LaoEtaxInvoiceNumber, the QR) is left alone, so this can never re-submit
    // anything to the Lao tax authority — it only re-arms the SAP writeback.
    async confirmLaoSapClear() {
      if (!this.laoSapErrorTarget || this.laoSapClearing) return;
      const companyID = this.companyID || this.$route.params.companyId;
      const objectID = this.laoSapErrorTarget.docID;
      this.laoSapClearing = true;
      try {
        await fc.db
          .doc(`Companies/${companyID}/Docs/${objectID}`)
          .set({ "@LaoEtaxSapSyncError": "" }, { merge: true });
        this.laoSapErrorDialog = false;
        this.laoSapErrorTarget = null;
        // The icon flips on its own — the status listener carries the SAP fields.
        this.alert = {
          text:
            objectID +
            ": ล้าง error แล้ว — จะซิงค์เข้า SAP ใหม่เมื่อเครื่องที่รัน PSC Connector เปิดอยู่",
          type: "success",
          show: true,
        };
      } catch (err) {
        this.alert = {
          text:
            objectID +
            ": ล้าง error ไม่สำเร็จ — " +
            ((err && err.message) || String(err)),
          type: "error",
          show: true,
        };
      } finally {
        this.laoSapClearing = false;
      }
    },
    laoCreditedTooltip(doc) {
      const list = this.laoCreditNotes(doc);
      const lines = list.map((c) => {
        const ref = c.invoiceNumber || c.objectID || "-";
        return "• " + ref + (c.netAmount ? " (" + c.netAmount + ")" : "");
      });
      return "ถูกลดหนี้แล้ว " + list.length + " ใบ:\n" + lines.join("\n");
    },
    // A queued/issuing doc whose attempt is presumed lost (createTask failed,
    // the task was dropped, or the handler died mid-issue). Mirrors
    // libLaoQueue.isStaleInflight on the backend, which is authoritative — this
    // only decides whether to OFFER the retry. Unknown timestamp counts as
    // stale so nothing can be stranded with no way out.
    laoIsStaleInflight(doc) {
      const s = this.laoStatusValue(doc);
      if (s !== "queued" && s !== "issuing") return false;
      const entry = this.laoStatusMap[doc.id];
      const ms = entry ? entry.updatedAtMs : null;
      if (!ms) return true;
      return Date.now() - ms >= LAO_STALE_INFLIGHT_MS;
    },
    // Per-row retry affordance: re-send a doc stuck in a retryable error state,
    // or one stranded in flight. Matches the backend (enqueueLaoEtaxIssue
    // re-queues failed/verify-timeout/invalid plus stale queued/issuing).
    // Sending isn't admin-gated, so neither is retry — same as the main
    // "นำส่ง" button. A doc the gateway already issued is laoCanRecheck instead.
    laoCanRetry(doc) {
      const s = this.laoStatusValue(doc);
      return (
        this.isLaoTaxRisActive &&
        !this.laoCanRecheck(doc) &&
        (s === "failed" ||
          s === "verify-timeout" ||
          s === "invalid" ||
          this.laoIsStaleInflight(doc))
      );
    },
    // verify-timeout / failed on a doc the gateway already gave an invoice
    // number: the invoice exists at MoF, so the button asks for its status
    // again instead of re-sending it (a re-send can only be refused as a
    // duplicate serial). Mirrors libLaoQueue.enqueueDecision's 'recheck' on the
    // backend, which is authoritative — the same callable does the right thing
    // whichever label the row shows.
    laoCanRecheck(doc) {
      const s = this.laoStatusValue(doc);
      if (!this.isLaoTaxRisActive) return false;
      if (s !== "verify-timeout" && s !== "failed") return false;
      const entry = this.laoStatusMap[doc.id];
      const serialNum = (entry && entry.serialNum) || doc["@LaoEtaxSerialNum"];
      const invoiceNumber =
        (entry && entry.invoiceNumber) || doc["@LaoEtaxInvoiceNumber"];
      return Boolean(serialNum && invoiceNumber);
    },
    laoRetryLabel(doc) {
      if (this.laoCanRecheck(doc)) return "ตรวจสถานะกับ Lao eTax อีกครั้ง";
      if (this.laoIsStaleInflight(doc)) return "ค้างอยู่นานผิดปกติ — ส่ง Lao eTax ใหม่";
      return "ส่ง Lao eTax ใหม่";
    },
    async retryLao(doc) {
      if (this.laoRetryingId) return; // one retry at a time
      const companyID = this.companyID || this.$route.params.companyId;
      const objectID = doc.id;
      this.laoRetryingId = objectID;
      try {
        const enqueue = firebase.functions().httpsCallable("enqueueLaoEtaxIssue");
        const res = await enqueue({ companyID, objectIDs: [objectID] });
        const result = res && res.data ? res.data : { ok: false };
        if (result.ok && (result.rechecked || []).indexOf(objectID) !== -1) {
          // Chip flips to 'issued' live; the verify cron settles it within minutes.
          this.alert = {
            text: "กำลังตรวจสถานะกับ Lao eTax (" + objectID + ") — ผลจะขึ้นภายในไม่กี่นาที",
            type: "success",
            show: true,
          };
        } else if (result.ok && (result.queued || 0) > 0) {
          // Chip flips to 'queued' live via the status listener.
          this.alert = {
            text: "ส่ง Lao eTax ใหม่แล้ว (" + objectID + ")",
            type: "success",
            show: true,
          };
        } else if (result.ok) {
          // Backend accepted but skipped it (already done / in flight).
          this.alert = {
            text: objectID + ": ส่งซ้ำไม่ได้ — รายการนี้ออกใบแล้วหรือกำลังดำเนินการ",
            type: "info",
            show: true,
          };
        } else {
          const hint =
            this.laoErrorHint({
              errorType: result.errorType,
              errorMessage: result.message,
            }) || "ส่ง Lao eTax ใหม่ไม่สำเร็จ";
          this.alert = { text: objectID + ": " + hint, type: "error", show: true };
        }
      } catch (err) {
        this.alert = {
          text: objectID + ": " + ((err && err.message) || String(err)),
          type: "error",
          show: true,
        };
      } finally {
        this.laoRetryingId = null;
      }
    },
    // What clicking the status chip does — at most one action per row, shown as
    // an inline icon inside the chip (no separate buttons). 'invalid' rows are
    // cancellable, so cancel wins there; the failure reason stays on hover.
    laoStatusAction(doc) {
      if (this.laoCanCancel(doc)) return "cancel";
      if (this.laoIsError(doc)) return "error";
      if (this.laoQrOf(doc)) return "qr";
      return "";
    },
    laoStatusActionLabel(doc) {
      const action = this.laoStatusAction(doc);
      if (action === "cancel") return "คลิกเพื่อยกเลิกใบกำกับ Lao eTax";
      if (action === "error") return "คลิกเพื่อดูสาเหตุข้อผิดพลาด Lao eTax";
      if (action === "qr") return "คลิกเพื่อดู QR ตรวจสอบใบกำกับ";
      return null;
    },
    onLaoStatusClick(doc) {
      const action = this.laoStatusAction(doc);
      if (action === "cancel") this.askLaoCancel(doc);
      else if (action === "error") this.showLaoError(doc);
      else if (action === "qr") this.openLaoQr(doc);
    },
    // cancelInvoice (5.4) is only valid on invoiceStatus=3 (Invalid). An
    // approved invoice must be corrected with a credit note, so the cancel
    // affordance shows ONLY on 'invalid' rows. Mirrors the backend guard.
    laoCanCancel(doc) {
      // Product + admin + invalid-only. The product gate is also enforced by the
      // enclosing column (v-if="isLaoTaxRisActive") and the backend, but keep it
      // explicit here so the affordance is self-gated like laoCanRetry. A
      // non-admin still sees the error affordance on invalid rows, just no cancel.
      return (
        this.isLaoTaxRisActive &&
        this.canUseAdminTools &&
        this.laoStatusValue(doc) === "invalid"
      );
    },
    askLaoCancel(doc) {
      const entry = this.laoStatusMap[doc.id] || {};
      this.laoCancelTarget = {
        docID: doc.id,
        invoiceNumber: entry.invoiceNumber || doc["@LaoEtaxInvoiceNumber"] || "-",
      };
      this.laoCancelDialog = true;
    },
    async confirmLaoCancel() {
      if (!this.laoCancelTarget) return;
      const companyID = this.companyID || this.$route.params.companyId;
      const objectID = this.laoCancelTarget.docID;
      this.laoCancelLoading = true;
      try {
        const callable = firebase
          .functions()
          .httpsCallable("cancelLaoEtaxInvoice");
        const res = await callable({ companyID, objectID });
        const result = res && res.data
          ? res.data
          : { ok: false, errorType: "unknown", message: "empty response" };
        if (result.ok) {
          this.alert = {
            text: "ยกเลิกใบกำกับ Lao eTax สำเร็จ (" + objectID + ")",
            type: "success",
            show: true,
          };
          this.laoCancelDialog = false;
          // @LaoEtaxStatus -> 'cancelled' updates the chip live via the listener.
        } else {
          this.alert = {
            text:
              objectID +
              ": " +
              this.laoCancelErrorHint(result),
            type: "error",
            show: true,
          };
        }
      } catch (err) {
        this.alert = {
          text: objectID + ": " + ((err && err.message) || String(err)),
          type: "error",
          show: true,
        };
      } finally {
        this.laoCancelLoading = false;
      }
    },
    // Turn a cancel failure into a clear Thai hint. Gateway TS codes (Appendix A)
    // are the most useful — map the ones a user can act on; otherwise fall back
    // to the generic error-type hint then the raw message.
    laoCancelErrorHint(result) {
      const hint = this.laoTsHint((result && result.errorCode) || "");
      if (hint) return hint;
      // result mirrors a laoStatusMap entry shape enough for laoErrorHint.
      // Pass errorCode too so the shared TS lookup there can also fire.
      const generic = this.laoErrorHint({
        errorType: result && result.errorType,
        errorCode: result && result.errorCode,
        errorMessage: result && result.message,
      });
      return generic || "ยกเลิกใบกำกับไม่สำเร็จ";
    },
    // Shared gateway TS-code -> Thai hint, used by both the cancel (5.4) and the
    // issue/credit-note (issueType=0/1) flows. Appendix A codes a user can act on;
    // returns "" for unknown/empty so callers fall back to the generic hint.
    laoTsHint(code) {
      if (!code) return "";
      const tsMap = {
        TS20367: "ใบนี้ออกที่ Lao eTax แล้ว — กดตรวจสถานะแทนการส่งใหม่",
        TS0110: "ใบนี้ยกเลิกไม่ได้ — สถานะไม่ตรงเงื่อนไขการยกเลิก",
        TS0113: "ใบกำกับไม่ถูกต้อง กรุณาตรวจสอบ",
        TS0114: "ใบนี้มีใบลดหนี้แล้ว จึงทำรายการซ้ำไม่ได้",
        TS20206: "เลขผู้ขาย (issueCode) ไม่ตรงกับใบเดิม",
        TS20207: "เลขผู้ซื้อไม่ตรงกับใบเดิม",
        TS20212: "ใบเดิมถูกยกเลิกหรือแทนที่ไปแล้ว",
        TS20215: "ใบเดิมกำลังอยู่ระหว่างการยกเลิก",
        TS20320: "ไม่มีเลขใบกำกับ (invoiceNumber) ที่จะอ้างอิง",
        TS20321: "ไม่พบข้อมูลใบกำกับนี้ในระบบ Lao eTax",
        TS20331: "ออกใบลดหนี้ได้เฉพาะใบเดิมตั้งแต่วันที่ 1 ของเดือนที่แล้วเป็นต้นมา",
        TS20363: "เลขผู้เสียภาษีไม่ตรงกับผู้ออกใบเดิม",
        TS20461: "ออกใบลดหนี้ไม่ได้ — เกินกำหนด (หลังวันที่ 20 ของเดือนถัดจากใบเดิม)",
        TS20462:
          "ลดหนี้บางส่วนไม่ได้ — ยอดใบลดหนี้ต้องเท่ายอดใบกำกับต้นฉบับ ให้ลดเต็มใบ แล้วออกใบกำกับใหม่ตามยอดที่ถูกต้อง",
        TS20467: "ไม่พบเลขใบกำกับต้นฉบับในระบบ",
      };
      return tsMap[code] ? tsMap[code] + " (" + code + ")" : "";
    },
    // Split selected objectIDs into ones that may be (re)sent vs already done /
    // in flight. issued/approved => already has an invoice; queued/issuing =>
    // currently processing. failed/invalid/verify-timeout/cancelled and never-
    // sent docs remain sendable (retry). Mirrors the enqueue backend guard,
    // which also turns an already-issued failed/verify-timeout doc into a
    // status recheck rather than a send.
    laoSendableObjectIDs(objectIDs) {
      const done = ["issued", "approved"];
      const inflight = ["queued", "issuing"];
      const sendable = [];
      let doneCount = 0;
      let inflightCount = 0;
      objectIDs.forEach((id) => {
        // Resolve through the fetched row, not the bare ID, so this uses the
        // same precedence as the status chip: live map first, then the
        // document's own @LaoEtaxStatus. Reading laoStatusMap alone would call
        // an approved document sendable during the moment before the snapshot
        // attaches — the row would show "ออกใบแล้ว" while the count included it.
        const doc = this.laoDocById(id);
        const status = this.laoStatusValue(doc);
        if (done.indexOf(status) !== -1) doneCount += 1;
        // A stale in-flight doc is sendable — its attempt is presumed lost.
        else if (
          inflight.indexOf(status) !== -1 &&
          !this.laoIsStaleInflight(doc)
        )
          inflightCount += 1;
        else sendable.push(id);
      });
      return { sendable: sendable, doneCount: doneCount, inflightCount: inflightCount };
    },
    // The fetched row for an ID, or a stand-in carrying just the ID when the
    // selection outlives the page it was made on (selectedList persists in the
    // store across paging). laoStatusValue and laoIsStaleInflight both accept
    // the stand-in and fall back to the live map.
    laoDocById(docID) {
      const found = (this.docs || []).find((d) => d.id === docID);
      return found || { id: docID };
    },
    // Label for a selected document the send will skip; "" means it will be
    // sent. The partition above decides membership — this only names the
    // reason, so the list and the count cannot disagree.
    // ── the customer's own note (@DocData.remark) ──────────────────────────
    // Never filed and never printed, so there is no status that locks it: see
    // src/libs/laoRemark.js for why that is the right default here and the wrong
    // one for anything that reaches the gateway.
    laoRemarkOf(doc) {
      const dd = (doc || {})["@DocData"] || {};
      return (dd.remark || "").toString();
    },
    laoRemarkPreview(value) {
      return previewLaoRemark(value);
    },
    openLaoRemark(doc) {
      this.laoRemarkTarget = doc;
      this.laoRemarkText = this.laoRemarkOf(doc);
      this.laoRemarkDialog = true;
    },
    closeLaoRemark() {
      this.laoRemarkDialog = false;
      this.laoRemarkTarget = null;
      this.laoRemarkText = "";
    },
    async saveLaoRemark() {
      const doc = this.laoRemarkTarget;
      if (!doc || this.laoRemarkErrorText) return;
      const companyID = this.companyID || this.$route.params.companyId;
      const objectID = doc.id || doc["objectID"];
      const value = (this.laoRemarkText || "").trim();
      this.laoRemarkSaving = true;
      try {
        await this.$store.dispatch("docs/setLaoRemark", {
          companyID: companyID,
          objectID: objectID,
          remark: value,
        });
        // The document listener carries this back on its own, but only while the
        // page is not showing search results — getList subscribes with
        // onSnapshot just in that case. So patch the row in hand as well, with
        // $set because @DocData may not exist on this document yet.
        const next = Object.assign({}, doc["@DocData"] || {});
        if (value) next.remark = value;
        else delete next.remark;
        this.$set(doc, "@DocData", next);
        this.alert = { text: "บันทึกหมายเหตุแล้ว", type: "success", show: true };
        this.closeLaoRemark();
      } catch (err) {
        this.alert = {
          text:
            "บันทึกหมายเหตุไม่สำเร็จ — " + ((err && err.message) || String(err)),
          type: "error",
          show: true,
        };
      } finally {
        this.laoRemarkSaving = false;
      }
    },
    laoSkipReason(docID) {
      if (this.laoSelectedPartition.sendable.indexOf(docID) !== -1) return "";
      const status = this.laoStatusValue(this.laoDocById(docID));
      return status === "issued" || status === "approved"
        ? "ออกใบแล้ว"
        : "กำลังดำเนินการ";
    },
    // Flatten a per-document send/dry-run result into the list of things a real
    // send would object to. Blocking entries refuse the document; the rest are
    // worth a look but do not stop it. Server-side validation is the only
    // source — deliberately NOT re-implemented here, because a second copy of
    // the rules would start disagreeing with the one that decides.
    laoResultIssues(r) {
      const out = [];
      if (!r) return out;
      if (r.docTypeAllowed === false) {
        out.push({
          blocking: true,
          message: "บริษัทนี้ไม่ได้เปิดให้นำส่งเอกสารประเภทนี้ — จะส่งจริงไม่ได้",
        });
      }
      const v = r.validation;
      if (!v) return out;
      (v.errors || []).forEach((e) => out.push({ blocking: true, message: e.message }));
      (v.warnings || []).forEach((w) => out.push({ blocking: false, message: w.message }));
      return out;
    },
    // Surface the failure reason prominently (snackbar) instead of hover-only.
    showLaoError(doc) {
      const entry = this.laoStatusMap[doc.id] || {};
      const hint = this.laoErrorHint(entry) || "เกิดข้อผิดพลาดในการส่ง Lao eTax";
      this.alert = { text: doc.id + ": " + hint, type: "error", show: true };
    },
    laoQrOf(doc) {
      const entry = this.laoStatusMap[doc.id];
      return entry && entry.qrCodeUrl ? entry.qrCodeUrl : "";
    },
    openLaoQr(doc) {
      const entry = this.laoStatusMap[doc.id] || {};
      this.laoQrCurrent = {
        docID: doc.id,
        url: entry.url || "",
        qrCodeUrl: entry.qrCodeUrl || "",
      };
      this.laoQrDialog = true;
    },
    // Copy a Lao eTax payload (dry-run preview or sent body) to the clipboard.
    async copyLaoPayload(payload) {
      let text;
      try {
        text = JSON.stringify(payload, null, 2);
      } catch (e) {
        text = String(payload);
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          // Fallback for non-secure contexts / older browsers.
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.alert = { text: "คัดลอก payload แล้ว", type: "success", show: true };
      } catch (e) {
        this.alert = { text: "คัดลอกไม่สำเร็จ", type: "error", show: true };
      }
    },
    getFirestoreDocUrl(docId) {
      const companyId = this.$route.params.companyId;
      return `https://console.firebase.google.com/project/sld-etax/firestore/databases/-default-/data/~2FCompanies~2F${companyId}~2FDocs~2F${docId}`;
    },
    // Helper function to format file size
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    
    // ฟังก์ชันตรวจสอบการเชื่อมต่อและ Security Software
    async checkNetworkAndSecurityStatus() {
      try {
        // ตรวจสอบ online status
        if (!navigator.onLine) {
          console.warn("Device is offline");
          return {
            status: 'offline',
            message: 'ไม่มีการเชื่อมต่ออินเทอร์เน็ต'
          };
        }

        // ตรวจสอบการเชื่อมต่อกับ Firebase โดยใช้ Firebase Auth
        // แทนที่จะเรียก endpoint ที่อาจไม่มีอยู่
        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 seconds timeout
          
          // ตรวจสอบว่าสามารถเข้าถึง Firebase ได้หรือไม่
          const user = firebase.auth().currentUser;
          
          if (user) {
            // ลองดึง token เพื่อทดสอบการเชื่อมต่อ
            await user.getIdToken(false);
            clearTimeout(timeoutId);
            
            console.log("✅ Firebase connection successful");
            return {
              status: 'connected',
              message: 'การเชื่อมต่อปกติ'
            };
          } else {
            clearTimeout(timeoutId);
            console.warn("User not authenticated");
            return {
              status: 'warning',
              message: 'กรุณา Login ใหม่อีกครั้ง'
            };
          }
          
        } catch (fetchError) {
          console.error("Firebase connection error:", fetchError);
          
          if (fetchError.name === 'AbortError') {
            console.error("Connection timeout");
            return {
              status: 'timeout',
              message: 'การเชื่อมต่อหมดเวลา อาจมี Firewall หรือ Security Software บล็อคการเชื่อมต่อ'
            };
          }
          
          if (fetchError.code === 'auth/network-request-failed' || 
              fetchError.message?.includes('network') ||
              fetchError.message?.includes('Network')) {
            return {
              status: 'blocked',
              message: 'ไม่สามารถเชื่อมต่อได้ อาจมี Firewall, Antivirus หรือ VPN บล็อคการเชื่อมต่อ'
            };
          }
          
          if (fetchError.message?.includes('CORS') || 
              fetchError.message?.includes('blocked')) {
            return {
              status: 'blocked',
              message: 'การเชื่อมต่อถูกบล็อค กรุณาตรวจสอบ Browser extension, Antivirus หรือ Firewall'
            };
          }
          
          throw fetchError;
        }
      } catch (error) {
        console.error("Network check error:", error);
        return {
          status: 'error',
          message: 'ไม่สามารถตรวจสอบสถานะการเชื่อมต่อได้: ' + error.message
        };
      }
    },
    
    // ฟังก์ชันแสดง diagnostic information
    showDiagnosticInfo() {
      const info = {
        userAgent: navigator.userAgent,
        online: navigator.onLine,
        cookieEnabled: navigator.cookieEnabled,
        language: navigator.language,
        platform: navigator.platform,
        vendor: navigator.vendor,
        doNotTrack: navigator.doNotTrack,
        connectionType: navigator.connection?.effectiveType || 'unknown',
        downlink: navigator.connection?.downlink || 'unknown',
        timestamp: new Date().toISOString()
      };
      
      console.log("=== Diagnostic Information ===");
      console.table(info);
      console.log("============================");
      
      return info;
    },
    
    formatedDateTaxRIS(inputDate) {
      try {
        // Parse the input date-time string using Moment.js
        const dt = moment(inputDate);

        // Format the date using Moment.js
        const outputDate = dt.format("YYYYMMDD");

        return outputDate;
      } catch (error) {
        console.error("Error:", error);
        return null;
      }
    },
    toTaxRisAmt(val) {
      // getFormatAmount returns a display string e.g. "1,143.30" (val ÷ 100)
      // strip commas and parse back to float for the API
      return parseFloat(this.getFormatAmount(val).replace(/,/g, ""));
    },
    buildTaxRisItem(doc) {
      return {
        companyID: this.companyID,
        docID: doc.id,
        pdfUrl: doc["@SignedPdfUrl"],
        xmlUrl: doc["@SignedXmlUrl"],
        downloadedXml: doc["@DownloadedXml"],
        docStatus: doc?.["@DocData"]?.docStatus,
        buyerEmail: doc["@BuyerEmail"],
        taxRisPayload: {
          HASH_KEY: "4Z79Dkk13fGwfrxNhc2GgPHec6giw96VLrY9evrNHfo=",
          CrsPfms: {
            TIN: doc["TIN"] || '',
            INV_NO: String(doc["ED.ID"] || ''),
            INV_DD: this.formatedDateTaxRIS(doc["ED.IssueDateTime"]) || '',
            BY_TIN: doc["SCTT.AHTA.BTP.STR.ID"] ? doc["SCTT.AHTA.BTP.STR.ID"].slice(0, 12) : null,
            BY_FULL_NM: doc["SCTT.AHTA.BTP.Name"] || '',
            SALE_CNT: doc["SCTT.ISCTLI"] ? doc["SCTT.ISCTLI"].length : 0,
            SUPL_AMT: this.toTaxRisAmt(doc["SCTT.AHTS.ATT.BasisAmount"]),
            SVC_FEE: String(this.toTaxRisAmt(doc["SCTT.AHTS.STSHMS.TaxTotalAmount"]) || "0"),
            EXCISE_AMT: 0,
            VAT_AMT: this.toTaxRisAmt(doc["SCTT.AHTS.STSHMS.TaxTotalAmount"]),
            SALE_AMT: this.toTaxRisAmt(doc["SCTT.AHTS.STSHMS.GrandTotalAmount"]),
            DISC_AMT: this.toTaxRisAmt(doc["SCTT.AHTS.STSHMS.AllowanceTotalAmount"]),
            SALE_CNCL_CNT: 0,
            SALE_CNCL_AMT: 0,
            list: doc["SCTT.ISCTLI"]
              ? doc["SCTT.ISCTLI"].map((item) => ({
                  HS_CD: item["STP.ID"] || '',
                  HS_NM: item["STP.Name"] || '',
                  SALE_CNT: item["SLTD.BilledQuantity"] || 0,
                  UNIT_SALE: item["SLTD.BilledQuantity.unitCode"] || '',
                  UNIT_SALE_AMT: this.toTaxRisAmt(item["SLTA.GPPTP.ChargeAmount"]),
                  SUPL_AMT: this.toTaxRisAmt(item["SLTS.STSLMS.NetLineTotalAmount"]),
                  EXCISE_AMT: 0,
                  VAT_AMT: this.toTaxRisAmt(item["SLTS.STSLMS.TaxTotalAmount"]),
                  SALE_AMT: this.toTaxRisAmt(item["SLTS.STSLMS.NetIncludingTaxesLineTotalAmount"]),
                }))
              : [],
          },
        },
      };
    },
    validateTaxRisPayload(item) {
      const errors = [];
      const warnings = [];
      const pfm = item.taxRisPayload.CrsPfms;
      const id = `INV_NO=${pfm.INV_NO || item.docID}`;

      // ── Required fields ──
      if (!pfm.TIN) {
        errors.push(`[${id}] TIN ว่าง (TaxRIS error 302)`);
      } else if (!/^\d{8,12}$/.test(pfm.TIN)) {
        errors.push(`[${id}] TIN "${pfm.TIN}" ต้องเป็นตัวเลข 8–12 หลัก (TaxRIS error 302)`);
      }

      if (!pfm.INV_NO) {
        errors.push(`[${id}] INV_NO ว่าง (TaxRIS error 504)`);
      } else if (pfm.INV_NO.length > 20) {
        errors.push(`[${id}] INV_NO ยาวเกิน 20 ตัวอักษร (TaxRIS error 505)`);
      }

      if (!pfm.INV_DD || !/^\d{8}$/.test(pfm.INV_DD)) {
        errors.push(`[${id}] INV_DD "${pfm.INV_DD}" ต้องเป็น YYYYMMDD (TaxRIS error 301)`);
      }

      if (!pfm.BY_FULL_NM) {
        errors.push(`[${id}] BY_FULL_NM ว่าง (TaxRIS error 504)`);
      }

      if (!pfm.SVC_FEE && pfm.SVC_FEE !== "0") {
        errors.push(`[${id}] SVC_FEE ว่าง ใส่ "0" หากไม่มีค่าธรรมเนียม`);
      } else if (pfm.SVC_FEE && String(pfm.SVC_FEE).length > 8) {
        errors.push(`[${id}] SVC_FEE ต้องไม่เกิน 8 ตัวอักษร`);
      }

      if (pfm.SALE_AMT <= 0) {
        errors.push(`[${id}] SALE_AMT = ${pfm.SALE_AMT} ต้องมากกว่า 0 (TaxRIS error 504)`);
      }

      // ── Warnings ──
      if (!pfm.BY_TIN) {
        warnings.push(`[${id}] BY_TIN ว่าง — ถ้า TaxRIS บังคับ จะตอบ error 302`);
      } else if (!/^\d{8,12}$/.test(pfm.BY_TIN)) {
        warnings.push(`[${id}] BY_TIN "${pfm.BY_TIN}" ควรเป็นตัวเลข 8–12 หลัก`);
      }

      if (pfm.VAT_AMT === 0) {
        warnings.push(`[${id}] VAT_AMT = 0 — ตรวจสอบว่าถูกต้องหรือ config VAT`);
      }

      // ── Line items ──
      if (!pfm.list || pfm.list.length === 0) {
        errors.push(`[${id}] ไม่มี line items (TaxRIS error 504)`);
      } else {
        pfm.list.forEach((ln, i) => {
          const lid = `${id} line[${i + 1}]`;

          if (!ln.HS_NM) {
            errors.push(`[${lid}] HS_NM ว่าง (TaxRIS error 504)`);
          }

          if (!ln.UNIT_SALE) {
            errors.push(`[${lid}] UNIT_SALE ว่าง (TaxRIS error 504)`);
          }

          if (ln.SALE_AMT <= 0) {
            errors.push(`[${lid}] SALE_AMT = ${ln.SALE_AMT} ต้องมากกว่า 0`);
          }

          if (ln.SALE_CNT === 0) {
            warnings.push(`[${lid}] SALE_CNT = 0 — Invoice แบบ Service ตรวจสอบว่า TaxRIS ยอมรับ`);
          }

          if (!ln.HS_CD && !ln.OTH_CD) {
            warnings.push(`[${lid}] HS_CD และ OTH_CD ว่างทั้งคู่ — ควรมีอย่างน้อยหนึ่งอย่าง`);
          }
        });
      }

      return { valid: errors.length === 0, errors, warnings };
    },
    sendTaxRIS: async function () {
      this.sendTaxRisLoading = true;
      this.taxRisAlert = { show: false, errors: [], warnings: [] };

      // validate all items before sending
      // const allErrors = [];
      // const allWarnings = [];
      // this.taxRisList.forEach((item) => {
      //   const result = this.validateTaxRisPayload(item);
      //   allErrors.push(...result.errors);
      //   allWarnings.push(...result.warnings);
      // });

      // if (allErrors.length > 0) {
      //   this.taxRisAlert = { show: true, errors: allErrors, warnings: allWarnings };
      //   this.sendTaxRisLoading = false;
      //   return;
      // }

      // if (allWarnings.length > 0) {
      //   this.taxRisAlert = { show: true, errors: [], warnings: allWarnings };
      // }

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };

      //dev
      //const APIendPoint = "http://127.0.0.1:5001/sld-etax/us-central1/sendDoc";

      //production
      const APIendPoint = "https://us-central1-sld-etax.cloudfunctions.net/sendDoc";

      const failedDocs = [];

      const promises = this.taxRisList.map(async (item) => {
        try {
          const response = await axios.post(APIendPoint, item, { headers });
          if (response.status === 200) {
            this.sendTaxRisSuccessCount += 1;
          } else {
            failedDocs.push(item.docID);
          }
        } catch (error) {
          failedDocs.push(item.docID);
        }
      });

      await Promise.all(promises);

      const successCount = this.sendTaxRisSuccessCount;
      this.sendTaxRisSuccessCount = 0;
      this.sendTaxRisLoading = false;

      if (failedDocs.length > 0) {
        this.taxRisAlert = {
          show: true,
          errors: failedDocs.map((d) => `${d}: ส่งข้อมูลไปยัง TaxRIS ไม่สำเร็จ`),
          warnings: [],
        };
      } else {
        this.alert = {
          text: "ส่งเอกสารสำเร็จ " + successCount + " รายการ",
          type: "success",
          show: true,
        };
        this.taxRisDialog = false;
        this.taxRisList = [];
        this.query();
      }
    },
    // ฟังก์ชันเรียกใช้เมื่อเปิด Import Dialog
    async onOpenImportDialog() {
      // ⛔ บริษัทถูกระงับ — ห้ามนำเข้าข้อมูล
      if (this.isCompanySuspended) {
        this.alert = {
          text: "บริษัทถูกระงับการใช้งานชั่วคราว ไม่สามารถนำเข้าเอกสารได้ — กรุณาติดต่อฝ่ายบริการลูกค้า โทร. 066-110-5989",
          type: "error",
          show: true,
        };
        return;
      }
      this.importDialog = true;

      // Log diagnostic info for debugging
      this.showDiagnosticInfo();
      
      // ตรวจสอบสถานะการเชื่อมต่ออัตโนมัติ
      await this.performNetworkCheck();
    },
    
    // ฟังก์ชันตรวจสอบ network
    async performNetworkCheck() {
      this.checkingNetwork = true;
      this.networkStatus = await this.checkNetworkAndSecurityStatus();
      this.checkingNetwork = false;
      
      // ถ้าพบปัญหา แสดง warning
      if (this.networkStatus.status !== 'connected') {
        console.warn("Network issue detected:", this.networkStatus);
      }
    },
    
    handleTemp(option) {
      this.selectedTemp = option;
      switch (option) {
        case "template-1":
          this.temp2Hiden = true;
          this.temp1Hiden = false;

          break;
        case "template-2":
          this.temp1Hiden = true;
          this.temp2Hiden = false;
          break;
        default:
          this.temp2Hiden = false;
          break;
      }
      // console.log(`Clicked on ${option} and ${this.selectedTemp}`);
    },
    loadEmailTemplateList() {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        if (this.mEmailTemplatesListUnsubscribeObject) {
          this.mEmailTemplatesListUnsubscribeObject();
        }
        this.mEmailTemplatesListUnsubscribeObject = fc.db
          .collection(`Companies/${companyId}/EmailTemplates`)
          .onSnapshot((docs) => {
            this.mEmailTemplatesList = [];
            this.mEmailTemplatesIDList = ["Default Template"];

            docs.forEach((doc) => {
              const data = doc.data();
              data.id = doc.id;
              this.mEmailTemplatesList.push(data);
              this.mEmailTemplatesIDList.push(data.id);
            });
            // console.log(this.mEmailTemplatesList)
          });
      }
    },
    startDrag() {
      this.timer = false;
      this.dragging = false;
      this.mouse = true;
    },
    stopDrag(doc) {
      if (!this.dragging && this.mouse) {
        // this.onClickDocId(doc['@SignedPdfUrl'])
        this.onClickDocId(doc);
      }
      this.dragging = false;
      this.mouse = false;
    },
    doDrag() {
      if (this.mouse && !this.awaitingDrag) {
        this.timer = setTimeout(() => {
          this.dragging = true;
          this.awaitingDrag = false;
        }, 200);
        this.awaitingDrag = true;
      }
    },
    matchHeight() {
      if (localStorage.getItem("pageLimit") !== "auto") return;
      let cardTitle = document.getElementById("card-title").clientHeight || 0;
      let headerTable =
        document.getElementById("header-table").clientHeight || 0;
      let rowDetailRow = Math.floor(
        (this.height - (150 + cardTitle + headerTable)) / 67
      );
      let pageLimit = 10;
      pageLimit =
        rowDetailRow > 1
          ? rowDetailRow - 1
          : rowDetailRow >= 0
          ? rowDetailRow
          : 1;

      localStorage.setItem("pageLimitAuto", pageLimit.toString());
      this.$store.dispatch("user/setPageLimitAutoChange");
      this.clearValue();
      this.query();
    },
    handleResize() {
      this.height = window.innerHeight;
    },
    getTaxId: function (taxID, companyID) {
      if (!taxID || taxID == "N/A")
        return companyID == "XMigdx2tCoT0CD4JDkGN" ||
          companyID == "0m2cwidBErAKMf2I9vkT"
          ? ""
          : "N/A";
      let taxIDShow = "-";
      if (taxID.length > 13) {
        taxIDShow = taxID.substring(0, 13);
      } else if (taxID.length <= 13) {
        taxIDShow = taxID;
      }
      return taxIDShow;
    },
    getCheckedSelect: function (docID) {
      return this.selectedList.some((x) => x["docID"] === docID);
    },
    getFormatAmount(amount) {
      return formatTwoDecimal(amount);
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate())
          .add(543, "years")
          .format("Do MMM YY, LTS");
      }
      return "-";
    },
    query: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("docs/getList", {
          id: companyId,
          selectedBranch: this.selectedBranch,
        });
      }
    },
    getEmailList: function () {
      // ⛔ บริษัทถูกระงับ — ห้ามส่งอีเมล
      if (this.isCompanySuspended) {
        this.alert = {
          text: "บริษัทถูกระงับการใช้งานชั่วคราว ไม่สามารถส่งอีเมลได้ — กรุณาติดต่อฝ่ายบริการลูกค้า โทร. 066-110-5989",
          type: "error",
          show: true,
        };
        return;
      }
      for (let e of this.selectedList) {
        console.log('e ::: ', e)
        if(!e.xmlUrl){

          continue;
        }
        if (e.docID) {
          if (!this.emailList[e.docID]) {
            this.emailList[e.docID] = [];
          }
          if (e.buyerEmail) {
            this.emailList[e.docID] = Vue.observable(
              e.buyerEmail.replaceAll(";", ",").split(",")
            );
          } else {
            this.emailList[e.docID] = Vue.observable([]);
          }
        }

        console.log(this.emailList);
      }
    },
    getTaxRisList: function () {
      this.taxRisList = this.selectedList;
      this.taxRisAlert = { show: false, errors: [], warnings: [] };
    },
    clearEmailList: function () {
      this.emailDialog = false;
      this.emailList = {};
    },    clearTaxRisList: function () {
      this.taxRisDialog = false;
      this.taxRisList = [];
      this.taxRisAlert = { show: false, errors: [], warnings: [] };
    },
    exportToExcel: async function () {
      this.exportingToExcel = true;
      
      try {
        // Create JSON data from taxRisList
        const excelData = this.taxRisList.map(item => ({
          TIN: item["SCTT.AHTA.BTP.STR.ID"] || "123456",
          Name: item["SCTT.AHTA.BTP.Name"] || "SLD Company",
          No: item["objectID"] || "",
          Dated: this.formatedDateTaxRIS(item["ED.IssueDateTime"]) || "",
          Description: "ขายสินค้า", // Default description, you can modify as needed
          ExemptedDomestic: 0,
          ExemptedAbroad: 0,
          NoneVATCollection: 0,
          VAT0Domestic: 0,
          VAT0Abroad: 0,
          VAT10Domestic: parseFloat(item["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"]) || 0,
          VAT10Abroad: 0,
          Total: parseFloat(item["SCTT.AHTS.STSHMS.GrandTotalAmount"]) || 0,
          VATCollected: parseFloat(item["SCTT.AHTS.STSHMS.TaxTotalAmount"]) || 0
        }));
        console.log("excelData:: ", excelData);
        // Get user token
        let token =  'Nx5QBXe7pSGan5nF=sh2/FrPPnUsJHJb6U/112H8JUyY1tLYRg5PpTQfJ=a!o-Gb5X-!hHzF1ByVCH?4FJ!i1RTz=4djq9kexNAZI8Ej-cELSjGNuhrvT=GFosLykS0jcs!!ENzSmFhPhnpDy-z1ZhgVduxCZaW/xizqPJ32vrpS7BJlHK8?Xxs33eMAw!n!Src=rbRPD3y3K!3xS5XFJVmQwNTabrQzzMGvQ5h8qE1mxx46IhMS=s6BoZMkskcz';

        const headers = {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        };

        // Call API to generate Excel
        const response = await axios.post(
          "https://us-central1-sld-etax.cloudfunctions.net/apiGenerateVATOutputExcel",
          excelData,
          { headers }
        );
        console.log("response:: ", response);
        if (response.data && response.data.file) {
          // Convert base64 to blob and download
          const base64Data = response.data.file;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { 
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
          });

          // Create download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `VAT_Output_Report_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.alert = {
            text: "ส่งออกรายงาน Excel สำเร็จ",
            type: "success",
            show: true,
          };
        }
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.alert = {
          text: "เกิดข้อผิดพลาดในการส่งออกรายงาน Excel",
          type: "error",
          show: true,
        };
      } finally {
        this.exportingToExcel = false;
      }
    },
    getDocumentType() {
      let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        return documentType[documentType.length - 1];
      }
      return "";
    },
    getDocsByRange(timeStart, timeEnd) {
      const companyID = this.$route.params.companyId;
      let documentType = this.getDocumentType();
      // console.log("documentType:: ", documentType);
      let documentTypeNumber = getDocumentTypeKey(documentType);
      console.log(documentType, documentTypeNumber);

      let q = fc.db.collection(`Companies/${companyID}/Docs`);
      if (documentTypeNumber) {
        q = q.where("@DocType", "==", documentTypeNumber);
      }
      q = q.where(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
        ">=",
        timeStart.toDate()
      );
      q = q.where(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
        "<",
        timeEnd.toDate()
      );
      q = q.orderBy(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp")
      );
      // Quota paywall — ตัดเอกสารที่เกินโควต้า (@OverQuota) ออกจากทั้ง
      // "ดาวน์โหลดรายเดือน" และ "ส่งออกข้อมูล" ที่ใช้ฟังก์ชันนี้ร่วมกัน
      return q.get().then((snap) =>
        snap.docs.filter((doc) => doc.data()["@OverQuota"] !== true)
      );
    },
    async exportDocs() {
      // ⛔ บริษัทถูกระงับ — ห้ามส่งออกข้อมูล
      if (this.isCompanySuspended) {
        this.exportDialog = false;
        this.alert = {
          text: "บริษัทถูกระงับการใช้งานชั่วคราว ไม่สามารถส่งออกข้อมูลได้ — กรุณาติดต่อฝ่ายบริการลูกค้า โทร. 066-110-5989",
          type: "error",
          show: true,
        };
        return;
      }
      if (!this.dateExportStart || !this.dateExportEnd) {
        alert("กรุณาเลือกวันที่เริ่มต้นและสิ้นสุด");
        return;
      }
      this.exportLoading = true;
      const filterEmailStatus = this.exportEmailStatusRadios;

      try {
        // ดึงทีละเดือนเพื่อไม่ให้ timeout
        const timeStart = moment(this.dateExportStart + "T00:00:00.000+07:00");
        const timeEnd   = moment(this.dateExportEnd   + "T00:00:00.000+07:00").add(1, "days");
        const allDocs = [];
        const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        let cursor = timeStart.clone();
        while (cursor.isBefore(timeEnd)) {
          const chunkStart = cursor.clone();
          const chunkEnd   = moment.min(
            cursor.clone().add(1, "month").startOf("month").utcOffset("+07:00", true),
            timeEnd
          );
          const snap = await this.getDocsByRange(chunkStart, chunkEnd);
          snap.forEach((doc) => allDocs.push(doc));
          cursor = chunkEnd.clone();
          await delay(500); // รอ 0.5 วิ ระหว่าง chunk ป้องกัน rate limit
        }

        // Sheet 1: รายการเอกสาร
        const docTypeCodeMap = { 1:"TX", 2:"AB", 3:"DR", 4:"CR", 5:"RE", 6:"RT", 7:"CL" };
        const rows = [[
          "วันที่เอกสาร", "เลขที่เอกสาร", "ประเภท", "รหัสผู้ซื้อ", "ชื่อผู้ซื้อ/ชื่อบริษัท",
          "เลขผู้เสียภาษี", "สาขาผู้ซื้อ", "มูลค่าที่นำมาคิดภาษี",
          "ภาษีมูลค่าเพิ่ม", "ยอดรวม", "สถานะการส่งอีเมล", "เวลาการส่งอีเมล",
        ]];
        const monthlyMap = {};

        allDocs.forEach((doc) => {
          const data = doc.data();
          if (filterEmailStatus === "Sent" && !data["@MailSent"]) return;
          if (filterEmailStatus === "NotSent" && data["@MailSent"]) return;

          const dateStr = data["ED.IssueDateTime"] ? data["ED.IssueDateTime"].split("T")[0] : "";
          const monthKey = dateStr ? dateStr.substring(0, 7) : "ไม่ระบุ";
          const docId = data["objectID"] || "";
          const docTypeCode = docTypeCodeMap[data["@DocType"]] || "";

          rows.push([
            dateStr,
            docId,
            docTypeCode,
            data["SCTT.AHTA.BTP.ID"],
            data["SCTT.AHTA.BTP.Name"],
            this.getTaxId(data["SCTT.AHTA.BTP.STR.ID"]),
            data["@BuyerBranchID"],
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"]),
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxTotalAmount"]),
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.GrandTotalAmount"]),
            data["@MailSent"] ? "Yes" : "No",
            data["@TimeMailSent"] ? moment(data["@TimeMailSent"].toDate()).format("YYYY-MM-DDTHH:mm:ss") : "",
          ]);

          if (!monthlyMap[monthKey]) monthlyMap[monthKey] = { total: 0, ids: [] };
          monthlyMap[monthKey].total++;
          monthlyMap[monthKey].ids.push({ id: docId, type: docTypeCode });
        });

        // Sheet 2: สรุปรายเดือน (1 แถว = 1 เอกสาร)
        const summaryRows = [["เดือน", "จำนวนเอกสาร", "ประเภท", "เลขที่เอกสาร"]];
        let grandTotal = 0;
        Object.entries(monthlyMap)
          .sort(([a], [b]) => a.localeCompare(b))
          .forEach(([month, val]) => {
            grandTotal += val.total;
            val.ids.forEach((item, i) => {
              summaryRows.push([i === 0 ? month : "", i === 0 ? val.total : "", item.type, item.id]);
            });
          });
        summaryRows.push(["รวมทั้งหมด", grandTotal, "", ""]);

        const wb = XLSX.utils.book_new();
        const ws1 = XLSX.utils.aoa_to_sheet(rows);
        const ws2 = XLSX.utils.aoa_to_sheet(summaryRows);
        ws2["!cols"] = [{ wch: 12 }, { wch: 15 }, { wch: 8 }, { wch: 40 }];
        XLSX.utils.book_append_sheet(wb, ws1, "รายการเอกสาร");
        XLSX.utils.book_append_sheet(wb, ws2, "สรุปรายเดือน");
        XLSX.writeFile(wb, `Docs_${this.dateExportStart}_${this.dateExportEnd}.xlsx`);

        this.exportDialog = false;
      } catch (err) {
        console.error("Export error:", err);
        alert("เกิดข้อผิดพลาด: " + err.message);
      } finally {
        this.exportLoading = false;
      }
    },
    cancelExportDialog() {
      this.exportDialog = false;
    },
    // Quota paywall — เปิด dialog ปลดล็อก (ค่าเริ่มต้น = เดือนปัจจุบัน)
    openUnlockQuotaDialog() {
      this.unlockQuotaMonth = moment().format("YYYY-MM");
      this.unlockQuotaDialog = true;
    },
    // ปลดล็อกฝั่ง client ตรง ๆ (ใช้สิทธิ์เขียน Docs ที่ staff มีอยู่แล้ว เหมือนปุ่ม "อัปเดทเอกสาร")
    // 1) เคลียร์ @OverQuota ของเอกสารที่ซ่อนในเดือนนั้น → กลับมาแสดง (ส่วนหลัก)
    // 2) ตั้ง QuotaMonths.unlocked=true กันใบใหม่ของเดือนนี้ถูกซ่อนซ้ำ (best-effort —
    //    ต้อง deploy firestore rule ของ QuotaMonths ก่อนถึงจะเขียนผ่าน ไม่ผ่านก็ไม่ล้มทั้งงาน)
    async confirmUnlockQuota() {
      const companyID = this.$route.params.companyId;
      const yearMonth = (this.unlockQuotaMonth || "").trim();
      if (!/^\d{4}-\d{2}$/.test(yearMonth)) {
        this.alert = {
          text: "เดือนต้องเป็นรูปแบบ YYYY-MM เช่น 2026-06",
          type: "error",
          show: true,
        };
        return;
      }
      this.unlockQuotaLoading = true;
      try {
        const snap = await fc.db
          .collection(`Companies/${companyID}/Docs`)
          .where("@QuotaMonth", "==", yearMonth)
          .get();
        const hidden = snap.docs.filter((d) => d.data()["@OverQuota"] === true);

        let cleared = 0;
        for (let i = 0; i < hidden.length; i += 450) {
          const chunk = hidden.slice(i, i + 450);
          const batch = fc.db.batch();
          chunk.forEach((d) => {
            batch.update(d.ref, {
              "@OverQuota": false,
              "@QuotaUnlockedAt": firebase.firestore.FieldValue.serverTimestamp(),
            });
          });
          await batch.commit();
          cleared += chunk.length;
        }

        // best-effort: ตั้ง unlocked=true (ถ้า rule ยังไม่ deploy จะ throw — ข้ามได้)
        try {
          await fc.db.doc(`Companies/${companyID}/QuotaMonths/${yearMonth}`).set(
            {
              unlocked: true,
              unlockedAt: firebase.firestore.FieldValue.serverTimestamp(),
              unlockReason: "manual_ui:" + (this.user?.email || ""),
            },
            { merge: true }
          );
        } catch (e) {
          console.warn("set QuotaMonths.unlocked failed (rule not deployed?)", e);
        }

        this.unlockQuotaDialog = false;
        this.alert = {
          text: `ปลดล็อกเดือน ${yearMonth} แล้ว — แสดงเอกสาร ${cleared} ฉบับ`,
          type: "success",
          show: true,
        };
      } catch (err) {
        this.alert = {
          text: "ปลดล็อกไม่สำเร็จ: " + (err && err.message ? err.message : err),
          type: "error",
          show: true,
        };
      } finally {
        this.unlockQuotaLoading = false;
      }
    },

    // ล็อกกลับ — ย้อนการปลดล็อกของเดือนนั้น
    //
    // แตะเฉพาะใบที่เคยถูกปลดล็อกจริง ดูจาก @QuotaUnlockedAt ที่ confirmUnlockQuota
    // แปะไว้ตอนปลด ใบที่ไม่เคยเกินโควต้าไม่มีฟิลด์นี้ จึงไม่ถูกซ่อนไปด้วยโดยไม่ตั้งใจ
    async confirmRelockQuota() {
      const companyID = this.$route.params.companyId;
      const yearMonth = (this.unlockQuotaMonth || "").trim();
      if (!/^\d{4}-\d{2}$/.test(yearMonth)) {
        this.alert = {
          text: "เดือนต้องเป็นรูปแบบ YYYY-MM เช่น 2026-06",
          type: "error",
          show: true,
        };
        return;
      }
      this.relockQuotaLoading = true;
      try {
        const snap = await fc.db
          .collection(`Companies/${companyID}/Docs`)
          .where("@QuotaMonth", "==", yearMonth)
          .get();
        const unlocked = snap.docs.filter((d) => !!d.data()["@QuotaUnlockedAt"]);

        let locked = 0;
        for (let i = 0; i < unlocked.length; i += 450) {
          const chunk = unlocked.slice(i, i + 450);
          const batch = fc.db.batch();
          chunk.forEach((d) => {
            batch.update(d.ref, {
              "@OverQuota": true,
              "@QuotaRelockedAt": firebase.firestore.FieldValue.serverTimestamp(),
              // ลบร่องรอยการปลดทิ้ง ไม่งั้นกดล็อกกลับรอบหน้าจะยังเห็นใบเดิมว่า "เคยปลด"
              "@QuotaUnlockedAt": firebase.firestore.FieldValue.delete(),
            });
          });
          await batch.commit();
          locked += chunk.length;
        }

        try {
          await fc.db.doc(`Companies/${companyID}/QuotaMonths/${yearMonth}`).set(
            {
              unlocked: false,
              relockedAt: firebase.firestore.FieldValue.serverTimestamp(),
              relockReason: "manual_ui:" + (this.user?.email || ""),
            },
            { merge: true }
          );
        } catch (e) {
          console.warn("set QuotaMonths.unlocked=false failed (rule not deployed?)", e);
        }

        this.unlockQuotaDialog = false;
        this.alert = {
          text: locked > 0
            ? `ล็อกกลับเดือน ${yearMonth} แล้ว — ซ่อนเอกสาร ${locked} ฉบับ`
            : `เดือน ${yearMonth} ไม่มีเอกสารที่เคยถูกปลดล็อกไว้`,
          type: locked > 0 ? "success" : "warning",
          show: true,
        };
      } catch (err) {
        this.alert = {
          text: "ล็อกกลับไม่สำเร็จ: " + (err && err.message ? err.message : err),
          type: "error",
          show: true,
        };
      } finally {
        this.relockQuotaLoading = false;
      }
    },

    handleImportFile(file) {
  if (file.type !== "text/csv") {
    this.alert = {
      text: "ไม่สามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
      type: "error",
      show: true,
      showOnDialog: true,
    };
    this.$refs.importFileRef.reset();
    return;
  }
  
  // ตรวจสอบขนาดไฟล์ (จำกัดที่ 10 MB)
  const maxFileSize = 10 * 1024 * 1024; // 10 MB
  const fileSizeFormatted = this.formatFileSize(file.size);
  
  console.log(`📁 File: ${file.name}`);
  console.log(`📦 Size: ${fileSizeFormatted} (${file.size} bytes)`);
  
  if (file.size > maxFileSize) {
    this.alert = {
      text: `ขนาดไฟล์ ${fileSizeFormatted} ใหญ่เกินไป (จำกัด 10 MB)\nกรุณาแบ่งไฟล์ออกเป็นหลายส่วน`,
      type: "error",
      show: true,
      showOnDialog: true,
    };
    this.$refs.importFileRef.reset();
    return;
  }
  
  if (file.size === 0) {
    this.alert = {
      text: "⚠️ ไฟล์ว่างเปล่า (0 Bytes)\n\nกรุณาตรวจสอบ:\n1. ไฟล์ CSV มีข้อมูลภายใน\n2. ไม่ได้บันทึกไฟล์เป็นไฟล์เปล่า\n3. ไฟล์ไม่เสียหาย",
      type: "error",
      show: true,
      showOnDialog: true,
    };
    this.$refs.importFileRef.reset();
    return;
  }

  const reader = new FileReader();

  reader.onload = (event) => {
    const buffer = event.target.result;
    let csvText = "";
    let encoding = "unknown";

    // Auto-detect and convert encoding: UTF-8 → Windows-1252 → TIS-620
    try {
      const utf8Decoder = new TextDecoder('utf-8', { fatal: true });
      csvText = utf8Decoder.decode(buffer);
      encoding = "UTF-8";
      console.log("✅ Detected encoding: UTF-8");
    } catch (e) {
      try {
        // Try Windows-1252 (ANSI on Windows)
        const ansiDecoder = new TextDecoder('windows-1252');
        csvText = ansiDecoder.decode(buffer);
        encoding = "Windows-1252 (ANSI)";
        console.log("✅ Detected encoding: Windows-1252 (ANSI)");
      } catch (e2) {
        // Finally try TIS-620 (Thai encoding)
        const tis620Decoder = new TextDecoder('TIS-620');
        csvText = tis620Decoder.decode(buffer);
        encoding = "TIS-620";
        console.log("✅ Detected encoding: TIS-620");
      }
    }
    
    console.log(`🔄 Converting to UTF-8 from ${encoding}`);

    // บันทึก encoding information
    this.template1Encoding = {
      detected: encoding,
      original: encoding,
      converted: encoding === 'UTF-8' ? null : 'UTF-8',
    };
    
    // ใช้ Papa.parse ในการแปลง CSV text
    Papa.parse(csvText, {
      header: false,
      skipEmptyLines: true,
      complete: (results) => {
        this.importFile = results;
        console.log(`📊 Parsed ${results.data.length} rows from CSV`);
        this.alert = {
          text: `อ่านไฟล์สำเร็จ: ${file.name} (${fileSizeFormatted}, ${encoding})`,
          type: "success",
          show: true,
          showOnDialog: true,
        };
      },
      error: (error) => {
        console.error("❌ Parse error:", error);
        this.alert = {
          text: `เกิดข้อผิดพลาดในการแปลง CSV: ${error.message}`,
          type: "error",
          show: true,
          showOnDialog: true,
        };
      }
    });
  };

  reader.onerror = () => {
    this.alert = {
      text: "เกิดข้อผิดพลาดในการอ่านไฟล์",
      type: "error",
      show: true,
      showOnDialog: true,
    };
    this.$refs.importFileRef.reset();
  };

  reader.readAsArrayBuffer(file);
  },


  handleImportFileTemp2(type, file) {
  if (file.type !== "text/csv") {
    this.alert = {
      text: "ไม่สามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
      type: "error",
      show: true,
      showOnDialog: true,
    };

    this.$refs.importFileRefH.reset();
    this.$refs.importFileRefL.reset();
    return;
  }
  
  // ตรวจสอบขนาดไฟล์ (จำกัดที่ 10 MB)
  const maxFileSize = 10 * 1024 * 1024; // 10 MB
  const fileSizeFormatted = this.formatFileSize(file.size);
  
  console.log(`📁 File (${type}): ${file.name}`);
  console.log(`📦 Size: ${fileSizeFormatted} (${file.size} bytes)`);
  
  if (file.size > maxFileSize) {
    this.alert = {
      text: `ขนาดไฟล์ ${fileSizeFormatted} ใหญ่เกินไป (จำกัด 10 MB)\nกรุณาแบ่งไฟล์ออกเป็นหลายส่วน`,
      type: "error",
      show: true,
      showOnDialog: true,
    };
    if (type === "head") {
      this.$refs.importFileRefH.reset();
    } else {
      this.$refs.importFileRefL.reset();
    }
    return;
  }
  
  if (file.size === 0) {
    this.alert = {
      text: `⚠️ ไฟล์${type === 'head' ? 'ส่วนหัว' : 'ส่วนเนื้อใน'}ว่างเปล่า (0 Bytes)\n\nกรุณาตรวจสอบ:\n1. ไฟล์ CSV มีข้อมูลภายใน\n2. ไม่ได้บันทึกไฟล์เป็นไฟล์เปล่า\n3. ไฟล์ไม่เสียหาย`,
      type: "error",
      show: true,
      showOnDialog: true,
    };
    if (type === "head") {
      this.$refs.importFileRefH.reset();
    } else {
      this.$refs.importFileRefL.reset();
    }
    return;
  }

  const reader = new FileReader();

  reader.onload = (event) => {
    const buffer = event.target.result;
    let csvText = "";
    let encoding = "unknown";

    // Auto-detect and convert encoding: UTF-8 → Windows-1252 → TIS-620
    try {
      const utf8Decoder = new TextDecoder("utf-8", { fatal: true });
      csvText = utf8Decoder.decode(buffer);
      encoding = "UTF-8";
      console.log(`✅ Detected encoding (${type}): UTF-8`);
    } catch (e) {
      try {
        // Try Windows-1252 (ANSI on Windows)
        const ansiDecoder = new TextDecoder("windows-1252");
        csvText = ansiDecoder.decode(buffer);
        encoding = "Windows-1252 (ANSI)";
        console.log(`✅ Detected encoding (${type}): Windows-1252 (ANSI)`);
      } catch (e2) {
        // Finally try TIS-620 (Thai encoding)
        const decoder = new TextDecoder("TIS-620");
        csvText = decoder.decode(buffer);
        encoding = "TIS-620";
        console.log(`✅ Detected encoding (${type}): TIS-620`);
      }
    }
    
    console.log(`🔄 Converting to UTF-8 from ${encoding}`);

    // บันทึก encoding information
    if (type === 'head') {
      this.template2HeadEncoding = {
        detected: encoding,
        original: encoding,
        converted: encoding === 'UTF-8' ? null : 'UTF-8',
      };
    } else if (type === 'line') {
      this.template2LineEncoding = {
        detected: encoding,
        original: encoding,
        converted: encoding === 'UTF-8' ? null : 'UTF-8',
      };
    }

    // Parse the CSV text with Papa Parse.
    Papa.parse(csvText, {
      header: false,
      skipEmptyLines: true,
      complete: (results) => {
        switch (type) {
          case "head":
            this.importFileTemp2Head = results;
            console.log(`📊 Parsed ${results.data.length} rows from HEAD CSV`);
            break;
          case "line":
            this.importFileTemp2Line = results;
            console.log(`📊 Parsed ${results.data.length} rows from LINE CSV`);
            break;
        }
        this.alert = {
          text: `อ่านไฟล์ ${type === 'head' ? 'ส่วนหัว' : 'ส่วนเนื้อใน'} สำเร็จ: ${file.name} (${fileSizeFormatted}, ${encoding})`,
          type: "success",
          show: true,
          showOnDialog: true,
        };
        setTimeout(() => {
          this.alert.show = false;
        }, 15000); 
      },
      error: (error) => {
        console.error(`❌ Parse error (${type}):`, error);
        this.alert = {
          text: `เกิดข้อผิดพลาดในการแปลง CSV (${type}): ${error.message}`,
          type: "error",
          show: true,
          showOnDialog: true,
        };
      }
    });
  };

  reader.onerror = () => {
    this.alert = {
      text: "เกิดข้อผิดพลาดในการอ่านไฟล์",
      type: "error",
      show: true,
      showOnDialog: true,
    };

    this.$refs.importFileRefH.reset();
    this.$refs.importFileRefL.reset();
  };

  // อ่านไฟล์ในรูปแบบ ArrayBuffer เพื่อให้สามารถ decode ได้อย่างถูกต้อง
  reader.readAsArrayBuffer(file);
}

,
    async importDocs() {
      let csvData = [];
      var ret = [];

      // ⛔ บริษัทถูกระงับ — ห้ามนำเข้าเอกสาร (กันกรณีถูกเรียกข้ามปุ่มที่ disable)
      if (this.isCompanySuspended) {
        this.alert = {
          text: "บริษัทถูกระงับการใช้งานชั่วคราว ไม่สามารถนำเข้าเอกสารได้ — กรุณาติดต่อฝ่ายบริการลูกค้า โทร. 066-110-5989",
          type: "error",
          show: true,
          showOnDialog: true,
        };
        return;
      }

      // ตรวจสอบการเชื่อมต่ออินเทอร์เน็ตก่อน
      if (!navigator.onLine) {
        console.error("❌ Device is offline");
        this.alert = {
          text: "ไม่มีการเชื่อมต่ออินเทอร์เน็ต กรุณาตรวจสอบการเชื่อมต่อของคุณ",
          type: "error",
          show: true,
          showOnDialog: true,
        };
        return;
      }
      
      // ตรวจสอบว่ามีข้อมูลในไฟล์ที่เลือกก่อนเริ่ม (กันกรณีกดนำเข้าโดยยังไม่เลือกไฟล์)
      // ทำก่อนสร้าง upload log เพื่อไม่ให้เกิด log ค้างเมื่อไม่มีไฟล์
      const csvIsEmpty = (parsed) =>
        !parsed || !Array.isArray(parsed.data) || parsed.data.length === 0;
      if (this.selectedTemp === "template-1") {
        if (csvIsEmpty(this.importFile)) {
          this.alert = {
            text: "กรุณาเลือกไฟล์ CSV",
            type: "error",
            show: true,
            showOnDialog: true,
          };
          return;
        }
      } else if (this.selectedTemp === "template-2") {
        if (csvIsEmpty(this.importFileTemp2Head)) {
          this.alert = {
            text: "กรุณาเลือกไฟล์ CSV ส่วนหัว",
            type: "error",
            show: true,
            showOnDialog: true,
          };
          return;
        }
        if (csvIsEmpty(this.importFileTemp2Line)) {
          this.alert = {
            text: "กรุณาเลือกไฟล์ CSV ส่วนเนื้อใน",
            type: "error",
            show: true,
            showOnDialog: true,
          };
          return;
        }
      }

      console.log("🚀 Starting CSV import process...");
      this.uploadingCSV = true;
      
      // สร้าง upload log
      let fileInfo;
      if (this.selectedTemp === 'template-1') {
        fileInfo = {
          name: this.template1?.name || 'data.csv',
          size: this.template1?.size || 0,
          type: 'text/csv',
          encoding: this.template1Encoding?.detected || 'UTF-8',
          originalEncoding: this.template1Encoding?.original || 'UTF-8',
        };
      } else {
        fileInfo = {
          name: `${this.templateh?.name || 'head.csv'} + ${this.templatel?.name || 'line.csv'}`,
          headFileName: this.templateh?.name || 'head.csv',
          lineFileName: this.templatel?.name || 'line.csv',
          size: (this.templateh?.size || 0) + (this.templatel?.size || 0),
          headSize: this.templateh?.size || 0,
          lineSize: this.templatel?.size || 0,
          type: 'text/csv',
          encoding: this.template2HeadEncoding?.detected || 'UTF-8',
          originalEncoding: `Head: ${this.template2HeadEncoding?.original || 'UTF-8'}, Line: ${this.template2LineEncoding?.original || 'UTF-8'}`,
        };
      }
      
      const startTime = Date.now();
      
      try {
        await this.$store.dispatch('uploadLog/createUploadLog', {
          companyID: this.$route.params.companyId,
          fileInfo: fileInfo,
          templateType: this.selectedTemp,
        });
      } catch (error) {
        console.error('Failed to create upload log:', error);
      }
      
      try {
        switch (this.selectedTemp) {
          case "template-1":
            for (var i = 1; i < this.importFile.data.length; i++) {
              var temp = this.importFile.data[i];

              let Ldiscount = temp[42]
              Ldiscount = Math.abs(Ldiscount)


              var obj = {
                docType: temp[0],
                sellerName: temp[1],
                sellerAddress: temp[2],
                sellerTaxID: temp[3],
                sellerBranchID: temp[4],
                buyerID: temp[5],
                buyerName: temp[6],
                buyerTaxID: temp[7],
                buyerAddress: temp[8],
                buyerBranchID: temp[9],
                buyerEmail: temp[10],
                buyerOrderRefDoc: temp[11],
                issuerAssignedID: temp[12],
                FissueDate: temp[13],
                typeCode: temp[14],
                docID: temp[15],
                issueDate: temp[16],
                creationDate: temp[17],
                noteSubject: temp[18],
                reference: temp[19],
                additionalRefDocs: temp[20],
                LissuerAssignedID: temp[21],
                LissueDate: temp[22],
                LtypeCode: temp[23],
                currency: temp[24],
                vat: temp[25],
                line: temp[26],
                discount: temp[27],
                basis: temp[28],
                tax: temp[29],
                total: temp[30],
                originalinformationamount: temp[31],
                differenceInformationAmount: temp[32],
                purposeCode: temp[33],
                purpose: temp[34],
                items: temp[35],
                productID: temp[36],
                description: temp[37],
                price: temp[38],
                unit: temp[39],
                quantity: temp[40],
                Lvat: temp[41],
                Ldiscount: Ldiscount,
                Lbasis: temp[43],
                Ltax: temp[44],
                Ltotal: temp[45],
                baseInvoiceAmount: temp[46],
                docDueDate: temp[47],
                paymentTermsCode: temp[48],
                customerVendorRef: temp[49],
                downPaymentAmount: temp[50],
                tel1: temp[51],
                tel2: temp[52],
                fax1: temp[53],
                salesEmployeeName: temp[54],
                contactPersonName: temp[55],
                baseRefNo: temp[56],
                baseRefDate: temp[57],
                crReason1: temp[58],
                crReason2: temp[59],
                drReason1: temp[60],
                drReason2: temp[61],
                payBy: temp[62],
                domain: temp[63],
                allowancePercent: temp[64],
              };
              csvData.push(obj);
            }
            var tempCustomer = {};
            for (i = 0; i < csvData.length; i++) {
              var item = csvData[i];
              if (item.sellerName) {
                if (i > 0) {
                  ret.push(tempCustomer);
                }
                tempCustomer = item;
                tempCustomer.items = [];
              } else {
                tempCustomer.items.push(item);
              }
            }

            if (tempCustomer) {
              ret.push(tempCustomer);
            }
            break;
          case "template-2":
            var arrHead = [];
            var arrLine = [];
            for (i = 1; i < this.importFileTemp2Head.data.length; i++) {
              var tempHead = this.importFileTemp2Head.data[i];
              var objHead = {
                docType: tempHead[0],
                sellerName: tempHead[1],
                sellerAddress: tempHead[2],
                sellerTaxID: tempHead[3],
                sellerBranchID: tempHead[4],
                buyerID: tempHead[5],
                buyerName: tempHead[6],
                buyerTaxID: tempHead[7],
                buyerAddress: tempHead[8],
                buyerBranchID: tempHead[9],
                buyerEmail: tempHead[10],
                buyerOrderRefDoc: tempHead[11],
                issuerAssignedID: tempHead[12],
                FissueDate: tempHead[13],
                typeCode: tempHead[14],
                docID: tempHead[15],
                issueDate: tempHead[16],
                creationDate: tempHead[17],
                noteSubject: tempHead[18],
                reference: tempHead[19],
                additionalRefDocs: tempHead[20],
                LissuerAssignedID: tempHead[21],
                LissueDate: tempHead[22],
                LtypeCode: tempHead[23],
                currency: tempHead[24],
                vat: tempHead[25],
                line: tempHead[26],
                discount: tempHead[27],
                basis: tempHead[28],
                tax: tempHead[29],
                total: tempHead[30],
                originalinformationamount: tempHead[31],
                differenceInformationAmount: tempHead[32],
                purposeCode: tempHead[33],
                purpose: tempHead[34],
                //line
                items: "",
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: tempHead[35] || "",
                docDueDate: tempHead[36] || "",
                paymentTermsCode: tempHead[37] || "",
                customerVendorRef: tempHead[38] || "",
                downPaymentAmount: tempHead[39] || "",
                tel1: tempHead[40] || "",
                tel2: tempHead[41] || "",
                fax1: tempHead[42] || "",
                salesEmployeeName: tempHead[43] || "",
                contactPersonName: tempHead[44] || "",
                baseRefNo: tempHead[45] || "",
                baseRefDate: tempHead[46] || "",
                crReason1: tempHead[47] || "",
                crReason2: tempHead[48] || "",
                drReason1: tempHead[49] || "",
                drReason2: tempHead[50] || "",
                payBy: tempHead[51] || "",
                domain: tempHead[52] || "",
                allowancePercent: tempHead[53] || "",
              };
              arrHead.push(objHead);
            }

            for (i = 1; i < this.importFileTemp2Line.data.length; i++) {
              var tempLine = this.importFileTemp2Line.data[i];



              let Ldiscount = tempLine[8]
              Ldiscount = Math.abs(Ldiscount)

              var objLine = {
                docType: "",
                sellerName: "",
                sellerAddress: "",
                sellerTaxID: "",
                sellerBranchID: "",
                buyerID: "",
                buyerName: "",
                buyerTaxID: "",
                buyerAddress: "",
                buyerBranchID: "",
                buyerEmail: "",
                buyerOrderRefDoc: "",
                issuerAssignedID: "",
                FissueDate: "",
                typeCode: "",
                docID: tempLine[0],
                issueDate: "",
                creationDate: "",
                noteSubject: "",
                reference: "",
                additionalRefDocs: "",
                LissuerAssignedID: "",
                LissueDate: "",
                LtypeCode: "",
                currency: "",
                vat: "",
                line: "",
                discount: "",
                basis: "",
                tax: "",
                total: "",
                originalinformationamount: "",
                differenceInformationAmount: "",
                purposeCode: "",
                purpose: "",
                //line
                items: tempLine[1],
                productID: tempLine[2],
                description: tempLine[3],
                price: tempLine[4],
                unit: tempLine[5],
                quantity: tempLine[6],
                Lvat: tempLine[7],
                Ldiscount: Ldiscount,
                Lbasis: tempLine[9],
                Ltax: tempLine[10],
                Ltotal: tempLine[11],
                //
                baseInvoiceAmount: "",
                docDueDate: "",
                paymentTermsCode: "",
                customerVendorRef: "",
                downPaymentAmount: "",
                tel1: "",
                tel2: "",
                fax1: "",
                salesEmployeeName: "",
                contactPersonName: "",
                baseRefNo: "",
                baseRefDate: "",
                crReason1: "",
                crReason2: "",
                drReason1: "",
                drReason2: "",
                payBy: "",
                domain: "",
              };
              arrLine.push(objLine);
            }
            console.log("arrLine===>", arrLine);
            arrHead.forEach((listHead) => {
              var itemList = arrLine.filter(
                (arrLine) => arrLine.docID == listHead.docID
              );
              var obj2 = {
                docType: listHead.docType,
                sellerName: listHead.sellerName,
                sellerAddress: listHead.sellerAddress,
                sellerTaxID: listHead.sellerTaxID,
                sellerBranchID: listHead.sellerBranchID,
                buyerID: listHead.buyerID,
                buyerName: listHead.buyerName,
                buyerTaxID: listHead.buyerTaxID,
                buyerAddress: listHead.buyerAddress,
                buyerBranchID: listHead.buyerBranchID,
                buyerEmail: listHead.buyerEmail,
                buyerOrderRefDoc: listHead.buyerOrderRefDoc,
                issuerAssignedID: listHead.issuerAssignedID,
                FissueDate: listHead.FissueDate,
                typeCode: listHead.typeCode,
                docID: listHead.docID,
                issueDate: listHead.issueDate,
                creationDate: listHead.creationDate,
                noteSubject: listHead.noteSubject,
                reference: listHead.reference,
                additionalRefDocs: listHead.additionalRefDocs,
                LissuerAssignedID: listHead.LissuerAssignedID,
                LissueDate: listHead.LissueDate,
                LtypeCode: listHead.LtypeCode,
                currency: listHead.currency,
                vat: listHead.vat,
                line: listHead.line,
                discount: listHead.discount,
                basis: listHead.basis,
                tax: listHead.tax,
                total: listHead.total,
                originalinformationamount: listHead.originalinformationamount,
                differenceInformationAmount:
                  listHead.differenceInformationAmount,
                purposeCode: listHead.purposeCode,
                purpose: listHead.purpose,
                //line
                items: itemList,
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: listHead.baseInvoiceAmount,
                docDueDate: listHead.docDueDate,
                paymentTermsCode: listHead.paymentTermsCode,
                customerVendorRef: listHead.customerVendorRef,
                downPaymentAmount: listHead.downPaymentAmount,
                tel1: listHead.tel1,
                tel2: listHead.tel2,
                fax1: listHead.fax1,
                salesEmployeeName: listHead.salesEmployeeName,
                contactPersonName: listHead.contactPersonName,
                baseRefNo: listHead.baseRefNo,
                baseRefDate: listHead.baseRefDate,
                crReason1: listHead.crReason1,
                crReason2: listHead.crReason2,
                drReason1: listHead.drReason1,
                drReason2: listHead.drReason2,
                payBy: listHead.payBy,
                domain: listHead.domain,
              };
              ret.push(obj2);
            });
            break;
        }
        console.log("📊 Processed data ==>", ret);
        if (ret.length > 0) {
          let companyID = this.$route.params.companyId;
          
          console.log(`📤 Sending ${ret.length} records to server...`);
          console.log("🔐 Company ID:", companyID);
          console.log("🌐 Current network status:", navigator.onLine ? "Online" : "Offline");
          
          try {
            console.log("⏱️ Upload started at:", new Date(startTime).toISOString());
            
            const importResult = await this.$store.dispatch("importDocs/importDocs", {
              docs: ret,
              companyID,
            });
            
            const endTime = Date.now();
            const duration = ((endTime - startTime) / 1000).toFixed(2);
            console.log(`✅ Upload completed in ${duration} seconds`);
            console.log("📊 Import Result:", importResult);
            
            // อัพเดท upload log
            if (importResult) {
              console.log("🔄 Updating upload log with:", {
                totalRecords: importResult.totalRecords,
                successCount: importResult.successCount,
                failureCount: importResult.failureCount,
                failedRecords: importResult.failedRecords,
              });
              
              // อัปเดต log ด้วยผลลัพธ์
              this.$store.dispatch('uploadLog/updateUploadLog', {
                totalRecords: importResult.totalRecords,
                successCount: importResult.successCount,
                failureCount: importResult.failureCount,
                successRecords: importResult.successRecords || [],
                failedRecords: importResult.failedRecords || [],
                errors: importResult.errors || [],
                status: importResult.failureCount > 0 ? 'completed_with_errors' : 'completed',
                duration: parseFloat(duration),
              });
              
              console.log("✅ Updated currentUploadLog:", this.$store.state.uploadLog.currentUploadLog);
              
            } else {
              console.error("❌ No import result returned!");
            }
            
            this.uploadingCSV = false;
            
            // รอให้ Vue อัปเดต DOM
            await this.$nextTick();
            
            console.log("📊 Current upload log before showing dialog:", this.currentUploadLog);

            // แสดง Upload Log Dialog
            this.showUploadLogDialog = true;
            this.importDialog = false;

            // ล้างค่า file inputs
            this.template1 = null;
            this.templateh = null;
            this.templatel = null;
            this.importFile = [];

            // รีเฟรชรายการเอกสารในตาราง (ไม่ต้องรีโหลดหน้า)
            console.log("🔄 Refreshing document list...");
            this.query();
            
            // บันทึก log ลง Firestore แบบ background (ไม่ต้องรอ)
            if (importResult) {
              this.$store.dispatch('uploadLog/saveUploadLog', {
                companyID,
              }).catch(err => {
                console.error("Failed to save upload log:", err);
              });
            }
            
          } catch (apiError) {
            this.uploadingCSV = false;
            
            const endTime = Date.now();
            const duration = ((endTime - startTime) / 1000).toFixed(2);
            
            console.error("❌ ===============================================");
            console.error("❌ API IMPORT FAILED - Connection was blocked!");
            console.error("❌ ===============================================");
            console.error("❌ Error Type:", apiError.name);
            console.error("❌ Error Code:", apiError.code);
            console.error("❌ Error Message:", apiError.message);
            console.error("❌ Full Error Object:", apiError);
            console.error("❌ Network Status:", navigator.onLine ? "Online" : "Offline");
            console.error("❌ Timestamp:", new Date().toISOString());
            
            // อัพเดท upload log กรณีเกิด error
            try {
              await this.$store.dispatch('uploadLog/updateUploadLog', {
                status: 'failed',
                duration: parseFloat(duration),
                errors: [{
                  type: apiError.name,
                  code: apiError.code,
                  message: apiError.message,
                  timestamp: new Date().toISOString(),
                }]
              });
              
              await this.$store.dispatch('uploadLog/saveUploadLog', {
                companyID,
              });
            } catch (logError) {
              console.error('Failed to save error log:', logError);
            }
            
            let errorMessage = "นำเข้าข้อมูล ไม่สําเร็จ";
            let errorType = "unknown";
            
            // ตรวจสอบประเภทของ error
            if (apiError.code === 'auth/network-request-failed' || 
                apiError.message?.includes('network') ||
                apiError.message?.includes('Network')) {
              errorType = "network";
              errorMessage = "⚠️ เกิดปัญหาการเชื่อมต่อเครือข่าย\n\n" +
                           "กรุณาตรวจสอบ:\n" +
                           "1. การเชื่อมต่ออินเทอร์เน็ต\n" +
                           "2. Firewall หรือ Antivirus อาจบล็อคการเชื่อมต่อ\n" +
                           "3. VPN หรือ Proxy settings";
              console.error("🔥 DIAGNOSIS: Network connection issue detected!");
              console.error("🔥 Possible causes: Firewall, Antivirus, VPN, or Network restrictions");
            } else if (apiError.message?.includes('CORS') || 
                      apiError.message?.includes('blocked')) {
              errorType = "blocked";
              errorMessage = "🚫 การเข้าถึงถูกบล็อค\n\n" +
                           "อาจเกิดจาก:\n" +
                           "1. Browser extension หรือ Ad blocker\n" +
                           "2. Security software (Antivirus/Firewall)\n" +
                           "3. Network firewall";
              console.error("🔥 DIAGNOSIS: Request was blocked!");
              console.error("🔥 Possible causes: Browser extensions, Ad blockers, Security software");
            } else if (apiError.code === 'permission-denied' || 
                      apiError.message?.includes('permission')) {
              errorType = "permission";
              errorMessage = "🔒 ไม่มีสิทธิ์ในการนำเข้าข้อมูล กรุณาติดต่อผู้ดูแลระบบ";
              console.error("🔥 DIAGNOSIS: Permission denied!");
            } else if (apiError.message?.includes('timeout') || 
                      apiError.code === 'unavailable') {
              errorType = "timeout";
              errorMessage = "⏱️ การเชื่อมต่อหมดเวลา (Timeout)\n\n" +
                           "กรุณาลองใหม่อีกครั้ง หรือตรวจสอบ:\n" +
                           "1. ความเร็วอินเทอร์เน็ต\n" +
                           "2. ขนาดไฟล์ CSV (อาจใหญ่เกินไป)\n" +
                           "3. Security software ที่อาจบล็อค";
              console.error("🔥 DIAGNOSIS: Connection timeout!");
            } else if (apiError.message) {
              errorMessage = `❌ นำเข้าข้อมูล ไม่สําเร็จ:\n\n${apiError.message}`;
            }
            
            this.alert = {
              text: errorMessage,
              type: "error",
              show: true,
              showOnDialog: true,
            };
            
            // Log summary สำหรับการ debug
            console.error("📋 ERROR SUMMARY:");
            console.table({
              "Error Type": errorType,
              "Error Code": apiError.code || "N/A",
              "Error Name": apiError.name || "N/A",
              "Network Status": navigator.onLine ? "Online" : "Offline",
              "Records Count": ret.length,
              "Company ID": companyID
            });
            
            console.error("❌ ===============================================");
            
            // รีเฟรชรายการเอกสาร (ถ้ามีบางส่วนที่สำเร็จก่อนเกิด error)
            this.query();
          }
        } else {
          // กรณีไม่มีข้อมูลในไฟล์ CSV
          console.warn("⚠️ No valid data found in CSV file (ret.length === 0)");

          const endTime = Date.now();
          const duration = ((endTime - startTime) / 1000).toFixed(2);

          // อัปเดต upload log status เป็น failed
          this.$store.dispatch('uploadLog/updateUploadLog', {
            totalRecords: 0,
            successCount: 0,
            failureCount: 0,
            successRecords: [],
            failedRecords: [],
            errors: [{
              type: 'validation',
              message: 'ไม่พบข้อมูลที่ถูกต้องในไฟล์ CSV (ไฟล์อาจมีเฉพาะ header หรือข้อมูลไม่ถูกต้อง)',
              timestamp: new Date().toISOString(),
            }],
            status: 'failed',
            duration: parseFloat(duration),
          });

          this.uploadingCSV = false;

          // บันทึก log ลง Firestore
          const companyID = this.$route.params.companyId;
          await this.$store.dispatch('uploadLog/saveUploadLog', {
            companyID,
          }).catch(err => {
            console.error("Failed to save upload log:", err);
          });

          // ปิด import dialog
          this.importDialog = false;

          // ล้างค่า file inputs
          this.template1 = null;
          this.templateh = null;
          this.templatel = null;
          this.importFile = [];

          // แสดง error message
          this.alert = {
            text: "ไม่พบข้อมูลที่ถูกต้องในไฟล์ CSV\n\nกรุณาตรวจสอบ:\n- ไฟล์มีข้อมูลนอกจากแถว header\n- ข้อมูลมีรูปแบบที่ถูกต้อง\n- คอลัมน์ที่จำเป็นมีข้อมูลครบถ้วน",
            type: "error",
            show: true,
            showOnDialog: false,
          };
        }
      } catch (error) {
        this.uploadingCSV = false;
        
        console.error("❌ File processing error:", error);
        console.error("❌ Error stack:", error.stack);
        
        let errorMessage = "เกิดข้อผิดพลาดในการประมวลผลไฟล์ CSV";
        
        if (error.message?.includes('parse') || error.message?.includes('format')) {
          errorMessage = "รูปแบบไฟล์ CSV ไม่ถูกต้อง กรุณาตรวจสอบไฟล์";
        }
        
        this.alert = {
          text: errorMessage + "\n" + error.toString(),
          type: "error",
          show: true,
          showOnDialog: true,
        };
      }
    },
    goToUploadHistory() {
      this.$router.push({
        name: 'Company.UploadHistory',
        params: { companyId: this.$route.params.companyId }
      });
    },
    
    cancelImportDialog() {
      this.importDialog = false;
      this.importFile = [];
      this.template1 = null;
      this.templateh = null;
      this.templatel = null;
      this.alert = {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      };
      //this.$refs.importFileRef.value=null
    },
    clickSelectedAll: function (checked) {
      let selectedList = _.cloneDeep(this.selectedList);
      // เลือก/ยกเลิกเฉพาะแถวที่มองเห็น — ไม่แตะใบที่ถูกซ่อน (เกินโควต้า)
      if (checked) {
        this.visibleDocs.forEach((doc) => {
          if (!selectedList.some((x) => x["docID"] === doc.id)) {
            selectedList.push(this.buildTaxRisItem(doc));
          }
        });
      } else {
        this.visibleDocs.forEach((doc) => {
          let index = selectedList.findIndex((x) => x["docID"] === doc.id);
          if (index !== -1) {
            selectedList.splice(index, 1);
          }
        });
      }
      this.$store.dispatch("docs/setSelectedList", {
        selectedList: selectedList,
      });
    },
    clickSelected: function (doc) {
      let valueList = _.cloneDeep(this.selectedList);
      if (this.getCheckedSelect(doc.id)) {
        let index = valueList.findIndex((x) => x["docID"] === doc.id);
        valueList.splice(index, 1);
      } else {
        valueList.push(this.buildTaxRisItem(doc));
      }

      this.$store.dispatch("docs/setSelectedList", { selectedList: valueList });
      this.currentXmlUrl = doc["@SignedXmlUrl"];
    },
    checkSelectedAll: function () {
      let selectedAll = false;
      let checkCount = 0;
      // นับเทียบกับเฉพาะแถวที่มองเห็น (ไม่รวมใบที่ถูกซ่อน)
      const visible = this.visibleDocs;
      this.selectedList.forEach((select) => {
        if (visible.some((doc) => doc.id === select.docID)) {
          checkCount++;
        }
      });
      if (checkCount === visible.length && visible.length > 0) {
        selectedAll = true;
      }
      this.selectedAll = selectedAll;
    },
    debounceInput: _.debounce(function (keyword) {
      this.changeKeyword(keyword);
    }, 1000),
    changeKeyword: function (keyword) {
      this.clearValue();
      let companyId = this.$route.params.companyId;

      if (companyId) {
        this.$store.dispatch("docs/updateKeyword", {
          id: companyId,
          keyword: keyword,
        });

        this.query();
        this.handleResize();
      }
    },
    validateEmail: function () {
      if (this.$refs.form.validate()) {
        this.emailDialog = false;
        this.sendEmail();
      }
    },
    sendEmail: async function () {
      // ⛔ บริษัทถูกระงับ — ห้ามส่งอีเมล (backend sendemail บล็อกซ้ำอีกชั้น)
      if (this.isCompanySuspended) {
        this.emailDialog = false;
        this.alert = {
          text: "บริษัทถูกระงับการใช้งานชั่วคราว ไม่สามารถส่งอีเมลได้ — กรุณาติดต่อฝ่ายบริการลูกค้า โทร. 066-110-5989",
          type: "error",
          show: true,
        };
        return;
      }
      this.sendEmailLoading = true;

      try {
        const token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false);
        const headers = {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        };

        // Send one request per invoice in emailList. emailList only contains
        // docs that have an xmlUrl (see getEmailList), so its key count — not
        // selectedList.length — is the real number of attempts.
        const invoiceIDs = Object.keys(this.emailList);
        let successCount = 0;
        const failedIDs = [];

        await Promise.all(
          invoiceIDs.map(async (k) => {
            const data = {
              company_id: this.$route.params.companyId,
              invoice_id: k,
              email: this.emailList[k].join(","),
            };
            if (this.mEmailTemplateID != "Default Template") {
              data.emailTemplateID = this.mEmailTemplateID;
            }
            try {
              const response = await axios.post(
                fc.cloudFunctionUrl + "sendemail",
                data,
                { headers }
              );
              if (response.status === 200) successCount += 1;
              else failedIDs.push(k);
            } catch (error) {
              console.error("sendemail error:", k, error);
              failedIDs.push(k);
            }
          })
        );

        if (failedIDs.length === 0 && successCount > 0) {
          this.alert = {
            text: "ส่งอีเมลสำเร็จ " + successCount + " รายการ",
            type: "success",
            show: true,
          };
        } else if (successCount > 0) {
          this.alert = {
            text:
              "ส่งอีเมลสำเร็จ " +
              successCount +
              " รายการ, ไม่สำเร็จ " +
              failedIDs.length +
              " รายการ",
            type: "warning",
            show: true,
          };
        } else {
          this.alert = {
            text: "ส่งอีเมลไม่สำเร็จ กรุณาลองอีกครั้ง",
            type: "error",
            show: true,
          };
        }

        this.query();
      } finally {
        this.sendEmailLoading = false;
        this.emailDialog = false;
        this.email = "";
        this.emailList = {};
      }
    },
    changeOrderBy: function (order) {
      let orderBySelect = _.cloneDeep(this.orderBySelect);
      if (!(this.orderBySelect["key"] === order)) {
        orderBySelect = { key: order, value: "asc" };
      } else {
        if (_.get(orderBySelect, "value") === "asc") {
          _.set(orderBySelect, "value", "desc");
        } else {
          orderBySelect = {};
        }
      }
      this.$store.dispatch("docs/setOrderBySelect", {
        orderBySelect: orderBySelect,
      });
      this.$store.dispatch("docs/updatePage", { page: 1 });
      this.query();
    },
    downloadPDF: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "pdf", '@SignedPdfUrl', this.$store.dispatch)
      this.downloadZip("pdf", this.selectedList, "pdf", MAX_DOC_PER_ZIP["pdf"]);
    },
    downloadMonthly: async function ({ month, fileType, filter }) {
      let maxPerZip = MAX_DOC_PER_ZIP[fileType] || 0;

      try {
        this.loadingDownloadZip("monthly", "on");
        this.setDownloadProgress("monthly", "");
        const startDate = moment(month).startOf("day");
        const endDate = moment(month).endOf("month").endOf("day");
        const snapshot = await this.getDocsByRange(startDate, endDate);

        let selected = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          selected.push({
            docID: doc.id,
            pdfUrl: data["@SignedPdfUrl"],
            xmlUrl: data["@SignedXmlUrl"],
            downloadedXml: data["@DownloadedXml"],
            docStatus: data?.["@DocData"]?.docStatus,
          });
        });

        if (filter) {
          if (filter.downloadedXml === "Downloaded") {
            selected = selected.filter((doc) => doc.downloadedXml);
          } else if (filter.downloadedXml === "NotDownloaded") {
            selected = selected.filter((doc) => !doc.downloadedXml);
          }
        }

        // ดาวน์โหลดรายเดือนไม่รวมเอกสารที่ถูกยกเลิก (กรมสรรพากรไม่รับเอกสารที่ยกเลิก)
        // ตัดออกให้อัตโนมัติแทนการบล็อกทั้งเดือน เพราะผู้ใช้ไม่ได้เลือกเอกสารเองจึงแก้ไขรายการไม่ได้
        const cancelledCount = selected.filter(
          (doc) => doc.docStatus === "C"
        ).length;
        if (cancelledCount > 0) {
          selected = selected.filter((doc) => doc.docStatus !== "C");
          this.alert = {
            text: `ไม่รวมเอกสารที่ถูกยกเลิก ${cancelledCount} ฉบับ ในการดาวน์โหลดครั้งนี้`,
            type: "info",
            show: true,
          };
        }

        await this.downloadZip(fileType, selected, "monthly", maxPerZip);
      } catch (err) {
        this.loadingDownloadZip("monthly", "off");
      }
    },
    downloadXML: function () {
      this.downloadZip("xml", this.selectedList, "xml", MAX_DOC_PER_ZIP["xml"]);
    },
    loadingDownloadZip: function (type, onOff) {
      let boolean = onOff === "on";
      if (type === "xml")
        this.$store.dispatch("docsDownloaded/updateDownloadingXml", {
          downloadingXml: boolean,
        });
      else if (type === "pdf")
        this.$store.dispatch("docsDownloaded/updateDownloadingPdf", {
          downloadingPdf: boolean,
        });
      else
        this.$store.commit("docsDownloaded/setDownloading", {
          type: type,
          downloading: boolean,
        });
    },
    setDownloadProgress: function (type, progress) {
      this.$store.commit("docsDownloaded/setDownloadProgress", {
        type: type,
        progress: progress,
      });
    },
    downloadZip: async function (type, selected, loadingType, maxPerZip) {
      // ⛔ บริษัทถูกระงับ — ห้ามดาวน์โหลด (ฝั่ง server zipFiles ก็บล็อกซ้ำอีกชั้น)
      if (this.isCompanySuspended) {
        this.alert = {
          text: "บริษัทถูกระงับการใช้งานชั่วคราว ไม่สามารถดาวน์โหลดเอกสารได้ — กรุณาติดต่อฝ่ายบริการลูกค้า โทร. 066-110-5989",
          type: "error",
          show: true,
        };
        return;
      }
      // ⛔ บริษัทที่ใช้ "นำเข้าข้อมูล CSV" ห้ามดาวน์โหลด XML/PDF ของเอกสารที่ถูกยกเลิก
      // (กรมสรรพากรไม่รองรับเอกสารที่ถูกยกเลิก)
      if (this.isCsvImportCompany) {
        const cancelledCount = (selected || []).filter(
          (x) => x.docStatus === "C"
        ).length;
        if (cancelledCount > 0) {
          this.alert = {
            text: `มีเอกสารที่ถูกยกเลิกแล้ว ${cancelledCount} ฉบับ อยู่ในรายการที่เลือก ไม่สามารถดาวน์โหลดได้ กรุณายกเลิกการเลือกเอกสารดังกล่าว`,
            type: "error",
            show: true,
          };
          return;
        }
      }
      if (!loadingType) {
        loadingType = type;
      }

      this.loadingDownloadZip(loadingType, "on");
      let urlField = "pdfUrl";
      if (type === "xml") {
        urlField = "xmlUrl";
      }
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let docList = [];
      let timeStamp = new Date().getTime();

      // เอาเฉพาะแถวที่มี url
      selected.forEach((docSelect) => {
        if (docSelect[urlField]) {
          docList.push({ id: docSelect["docID"], url: docSelect[urlField] });
        }
      });

      if (docList.length === 0) {
        this.loadingDownloadZip(loadingType, "off");
        this.alert = {
          text: "ไม่พบเอกสารที่ต้องการ",
          type: "error",
          show: true,
        };
        return;
      }

      if (!maxPerZip) {
        maxPerZip = docList.length;
      }

      const companyId = this.$route.params.companyId;
      const zipChunk = async function (chunk, startNumber) {
        const result = await axios.post(
          fc.cloudFunctionUrl + "zipFiles",
          { data: chunk, type: type, companyID: companyId },
          { headers, responseType: "arraybuffer" }
        );
        if (result.data.byteLength !== 0) {
          let url = URL.createObjectURL(
            new Blob([result.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${timeStamp}_${startNumber}-${startNumber + chunk.length - 1}.zip`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
      };

      // split documents into smaller chunks
      // then zip and download each
      let startNumber = 1;
      const total = docList.length;
      while (docList.length > 0) {
        try {
          const chunk = docList.splice(0, maxPerZip);
          this.setDownloadProgress(
            loadingType,
            `กำลังโหลด...(${startNumber - 1}/${total})`
          );
          await zipChunk(chunk, startNumber);
          startNumber += chunk.length;
        } catch (err) {
          console.log("front end error: ", err);
          this.alert = {
            text: "เกิดข้อผิดพลาดขณะดาวน์โหลด กรุณาลองอีกครั้ง",
            type: "error",
            show: true,
          };
          this.loadingDownloadZip(loadingType, "off");
          return;
        }
      }

      this.loadingDownloadZip(loadingType, "off");
      this.clearSelectList();
    },
    clearDownloadedXml: async function () {
      this.clearingDownloadedXml = true;

      const companyID = this.$route.params.companyId;
      const list = this.selectedList.filter((doc) => doc.downloadedXml);
      const count = list.length;
      const batch = fc.db.batch();

      list.forEach((doc) => {
        const docRef = fc.db.doc(`Companies/${companyID}/Docs/${doc.docID}`);
        batch.update(docRef, {
          "@DownloadedXml": false,
        });
      });

      try {
        await batch.commit();
        this.alert = {
          text: "ยกเลิกค่าดาวน์โหลดสำเร็จ " + count + " รายการ",
          type: "success",
          show: true,
        };
      } catch (err) {
        console.error("clearDownloadedXml error: ", err);
        this.alert = {
          text: "เกิดข้อผิดพลาดขณะยกเลิกค่าดาวน์โหลด กรุณาลองอีกครั้ง",
          type: "error",
          show: true,
        };
      }

      this.clearSelectList();
      this.clearingDownloadedXml = false;
    },
    clearSignedFiles: async function () {
      this.clearingSignedFiles = true;

      const companyID = this.$route.params.companyId;
      const list = this.selectedList;
      const count = list.length;
      const batch = fc.db.batch();

      list.forEach((doc) => {
        const docRef = fc.db.doc(`Companies/${companyID}/Docs/${doc.docID}`);
        batch.update(docRef, {
          "@SignedPdfPath": "",
          "@SignedPdfUrl": "",
          "@SignedXmlPath": "",
          "@SignedXmlUrl": "",
        });
      });

      try {
        await batch.commit();
        this.alert = {
          text: "อัปเดทเอกสารสำเร็จ " + count + " รายการ",
          type: "success",
          show: true,
        };
      } catch (err) {
        console.error("clearSignedFiles error: ", err);
        this.alert = {
          text: "เกิดข้อผิดพลาดขณะอัปเดทเอกสาร กรุณาลองอีกครั้ง",
          type: "error",
          show: true,
        };
      }

      this.confirmClearSignedDialog = false;
      this.clearSelectList();
      this.clearingSignedFiles = false;
    },
    // ผู้ใช้ที่กำลังกดปุ่ม สำหรับบันทึกลง @CancelledBy — เอาอีเมลก่อนเพราะอ่านออก
    // ทันทีตอนสืบย้อนหลัง ถ้าไม่มีค่อยตกไปที่ uid ของ Firebase Auth
    actorIdentity: function () {
      const authUser = fc.auth.currentUser;
      return (
        this.user?.email || authUser?.email || authUser?.uid || "unknown"
      );
    },
    cancelDocs: async function () {
      this.cancelDocLoading = true;

      const companyID = this.$route.params.companyId;
      const list = this.selectedList;

      try {
        const refs = list.map((doc) =>
          fc.db.doc(`Companies/${companyID}/Docs/${doc.docID}`)
        );
        const snaps = await Promise.all(refs.map((r) => r.get()));

        const cancelledBy = this.actorIdentity();
        const batch = fc.db.batch();
        let updatedCount = 0;
        let skippedCount = 0;

        snaps.forEach((snap, i) => {
          if (!snap.exists) {
            skippedCount += 1;
            return;
          }
          const data = snap.data() || {};
          const currentDocType = data["@DocType"];
          if (currentDocType === 7) {
            skippedCount += 1;
            return;
          }
          const updates = {
            "@DocType": 7,
            "@DocData.docStatus": "C",
            // ร่องรอยว่าใครกดยกเลิกเมื่อไหร่ — ไม่มีที่อื่นในระบบบันทึกไว้เลย
            // (@TimeUpdated ถูกเขียนเฉพาะตอนนำเข้าเอกสาร ไม่ใช่ตอนแก้สถานะ)
            "@CancelledAt": firebase.firestore.FieldValue.serverTimestamp(),
            "@CancelledBy": cancelledBy,
          };
          if (currentDocType !== undefined && currentDocType !== null) {
            updates["@OriginalDocType"] = currentDocType;
          }
          batch.update(refs[i], updates);
          updatedCount += 1;
        });

        if (updatedCount > 0) {
          await batch.commit();
        }

        const parts = [`ยกเลิกเอกสารสำเร็จ ${updatedCount} รายการ`];
        if (skippedCount > 0) parts.push(`ข้าม ${skippedCount} รายการ`);
        this.alert = {
          text: parts.join(" — ") + " — ย้ายไปที่ใบแจ้งยกเลิก",
          type: updatedCount > 0 ? "success" : "warning",
          show: true,
        };

        // ดึงรายการใหม่เอง — ถ้ามีคำค้นหรือช่วงวันที่อยู่ getList จะใช้ .get()
        // รอบเดียวแล้ว return ก่อนถึง onSnapshot รายการจึงไม่รีเฟรชตัวเอง
        // แถวที่เพิ่งยกเลิกจะค้างอยู่จนกว่าผู้ใช้จะสลับแท็บเอง (เหมือน restoreDocs)
        if (updatedCount > 0) {
          this.query();
        }
      } catch (err) {
        console.error("cancelDocs error: ", err);
        this.alert = {
          text: "เกิดข้อผิดพลาดขณะยกเลิกเอกสาร กรุณาลองอีกครั้ง",
          type: "error",
          show: true,
        };
      }

      this.confirmCancelDocDialog = false;
      this.clearSelectList();
      this.cancelDocLoading = false;
    },
    // กู้คืนใบที่ถูกกด "ยกเลิกเอกสาร" ผิด ให้กลับไปเป็นประเภทเดิม
    //
    // @OriginalDocType ที่ cancelDocs บันทึกไว้คือแหล่งความจริงเพียงอย่างเดียว —
    // ใบแจ้งยกเลิก "ของจริง" ที่นำเข้ามาเป็น @DocType 7 ตั้งแต่ต้น (objectID ลงท้าย
    // _CL) จะไม่มีฟิลด์นี้ จึงต้องข้ามเสมอ ห้ามเดาประเภทเดิมเองเด็ดขาด
    //
    // และเอกสารปกติในคอลเลกชันนี้ไม่มีฟิลด์ @DocData.docStatus อยู่เลย การกู้คืน
    // จึงต้อง "ลบ" ฟิลด์ทิ้ง ไม่ใช่เซ็ตเป็นค่าว่าง เพื่อให้เอกสารกลับไปมีรูปร่าง
    // เหมือนก่อนถูกยกเลิกทุกประการ
    restoreDocs: async function () {
      this.restoreDocLoading = true;

      const companyID = this.$route.params.companyId;
      const list = this.selectedList;

      try {
        const refs = list.map((doc) =>
          fc.db.doc(`Companies/${companyID}/Docs/${doc.docID}`)
        );

        // อ่านทีละก้อน กัน selection ใหญ่ ๆ ยิง read พร้อมกันหลายพันครั้ง
        const snaps = [];
        for (let i = 0; i < refs.length; i += 200) {
          const chunk = refs.slice(i, i + 200);
          const chunkSnaps = await Promise.all(chunk.map((r) => r.get()));
          snaps.push(...chunkSnaps);
        }

        const targets = [];
        const skipped = { missing: 0, notCancelled: 0, noOriginal: 0 };

        snaps.forEach((snap, i) => {
          if (!snap.exists) {
            skipped.missing += 1;
            return;
          }
          const data = snap.data() || {};
          if (data["@DocType"] !== 7) {
            skipped.notCancelled += 1;
            return;
          }
          const original = data["@OriginalDocType"];
          // 1–6 = ประเภทเอกสารขายที่กู้คืนได้ (7 คือใบแจ้งยกเลิกเอง จึงกู้เป็น 7 ไม่ได้)
          if (!Number.isInteger(original) || original < 1 || original > 6) {
            skipped.noOriginal += 1;
            return;
          }
          targets.push({ ref: refs[i], original: original });
        });

        let restored = 0;
        for (let i = 0; i < targets.length; i += 450) {
          const chunk = targets.slice(i, i + 450);
          const batch = fc.db.batch();
          chunk.forEach((t) => {
            batch.update(t.ref, {
              "@DocType": t.original,
              "@DocData.docStatus": firebase.firestore.FieldValue.delete(),
              "@OriginalDocType": firebase.firestore.FieldValue.delete(),
              // ลบร่องรอยการยกเลิกด้วย เอกสารที่กู้คืนแล้วไม่ได้ถูกยกเลิกอีกต่อไป
              // การทิ้ง @CancelledAt ค้างไว้จะทำให้อ่านผิดว่ายังยกเลิกอยู่
              "@CancelledAt": firebase.firestore.FieldValue.delete(),
              "@CancelledBy": firebase.firestore.FieldValue.delete(),
            });
          });
          await batch.commit();
          restored += chunk.length;
        }

        const parts = [`กู้คืนเอกสารสำเร็จ ${restored} รายการ`];
        if (skipped.noOriginal > 0) {
          parts.push(
            `ข้าม ${skipped.noOriginal} รายการ (ไม่มีข้อมูลประเภทเดิม — เป็นใบแจ้งยกเลิกตั้งแต่ต้น)`
          );
        }
        if (skipped.notCancelled > 0) {
          parts.push(
            `ข้าม ${skipped.notCancelled} รายการ (ไม่ได้อยู่ในสถานะยกเลิก)`
          );
        }
        if (skipped.missing > 0) {
          parts.push(`ข้าม ${skipped.missing} รายการ (ไม่พบเอกสาร)`);
        }
        this.alert = {
          text: parts.join(" — "),
          type: restored > 0 ? "success" : "warning",
          show: true,
        };

        if (restored > 0) {
          this.query();
        }
      } catch (err) {
        console.error("restoreDocs error: ", err);
        this.alert = {
          text: "เกิดข้อผิดพลาดขณะกู้คืนเอกสาร กรุณาลองอีกครั้ง",
          type: "error",
          show: true,
        };
      }

      this.confirmRestoreDocDialog = false;
      this.clearSelectList();
      this.restoreDocLoading = false;
    },
    onClickDocId: async function (doc) {
      // ⛔ บริษัทถูกระงับ — ห้ามเปิด/ดาวน์โหลด PDF รายฉบับ
      if (this.isCompanySuspended) {
        this.alert = {
          text: "บริษัทถูกระงับการใช้งานชั่วคราว ไม่สามารถดาวน์โหลดเอกสารได้ — กรุณาติดต่อฝ่ายบริการลูกค้า โทร. 066-110-5989",
          type: "error",
          show: true,
        };
        return;
      }
      this.$store.dispatch("setGlobalLoading", true);
      this.downloadPdfLoading = true;

      // ทุกทางที่ออกจากตรงนี้ต้องผ่าน finally เสมอ ไม่งั้นธงโหลดค้าง
      // แล้วช่องวันที่ของทุกแถวจะค้าง disabled จนกว่าจะรีเฟรช
      try {
        let pdfLink = doc["@SignedPdfUrl"];
        // Lao eTax docs are rendered in-house for every DocType (no Signer), so a
        // missing @SignedPdfUrl is expected — skip the "Signer hasn't made a PDF"
        // alert and fall through to the unsigned PDF below.
        if (!pdfLink && !this.isLaoTaxRisActive) {
          this.alert = {
            text: "Signer ยังไม่ได้สร้าง Pdf ให้เอกสาร " + doc["objectID"],
            type: "error",
            show: true,
          };
        }
        let unsigedPdfLink = doc["@UnsignedPdfUrl"];

        let link = "";
        if (!pdfLink && !unsigedPdfLink) {
          link = await this.updateUnsignedPdf(doc["objectID"]);
        } else if (pdfLink) {
          link = pdfLink;
        } else if (unsigedPdfLink) {
          link = unsigedPdfLink;
        }

        if (!link) {
          throw new Error("ไม่พบไฟล์ PDF ของเอกสารนี้");
        }
        if (this.pdfDialog) {
          return;
        }

        const response = await axios.get(link, {
          responseType: "arraybuffer",
        });

        let url = URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );

        if (isMobile()) {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = "invoice_" + new Date().getTime() + ".pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          this.pdfSrc = url;
          this.pdfDialog = true;
        }
      } catch (error) {
        this.alert = {
          text:
            "เปิดเอกสาร " +
            doc["objectID"] +
            " ไม่สำเร็จ — " +
            (error && error.message
              ? error.message
              : "โหลดไฟล์ PDF ไม่ได้"),
          type: "error",
          show: true,
        };
      } finally {
        this.downloadPdfLoading = false;
        this.$store.dispatch("setGlobalLoading", false);
      }
    },
    updateUnsignedPdf: async function (docID) {
      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let data = {
        companyID: this.$route.params.companyId,
        docID: docID,
      };
      // axios โยน error เองเมื่อสถานะไม่ใช่ 2xx ส่วน 2xx อื่น ๆ ก็คืนลิงก์ตามปกติ
      // ห้ามห่อ Promise เองแล้ว resolve เฉพาะ 200 — สถานะ 2xx อื่นจะค้างตลอดกาล
      const response = await axios.post(
        fc.cloudFunctionUrl + "updateUnsignedPdf",
        data,
        { headers }
      );
      return response.data;
    },
    getDateWithFormat: function (date) {
      var parsedDate = moment(date);

      // Format the date as per the desired output format
      var formattedDate = parsedDate.format("Do MMM", "th");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");

      // Get the year in Thai Buddhist calendar
      var thaiYear = parseInt(parsedDate.format("YYYY")) + 543; // Add 543 to convert to Thai Buddhist calendar

      // Append the Thai Buddhist year to the formatted date
      formattedDate += " " + thaiYear.toString().substring(2, 4);

      return formattedDate;
    },
    onChangeValueFilterList(value) {
      this.clearValue();
      this.$store.dispatch("docs/setValueFilterList", {
        valueFilterList: value,
      });
    },
    onChangeValueDropdownHideColumn(value) {
      this.valueHideList = value;
    },
    onChangeValueSearchOption(value) {
      console.log("onChangeValueSearchOption Triggerrd:: ", value);
      this.defaultSearchOptionValue = value;
      this.$store.dispatch("docs/setSearchField", value);
      this.query();
    },
    showColumn(field) {
      return this.valueHideList.includes(field);
    },
    // Put the company's optional columns (Settings/laoEtax.extraColumns) into
    // the three lists that drive the table chrome: what "ซ่อน" can hide, what is
    // visible by default, and what "ตั้งค่าการค้นหา" can search on.
    //
    // Every known optional key is stripped first, so switching to a company
    // without the column — or to a non-Lao product — cannot leave a stale entry
    // behind in a dropdown. Insertion goes before รหัสผู้ซื้อ to match where the
    // column is rendered, right after เลขที่เอกสาร.
    applyLaoExtraColumns(columns) {
      const cols = Array.isArray(columns) ? columns : [];
      const isInjected = (key) => LAO_EXTRA_COLUMN_KEYS.indexOf(key) !== -1;

      this.laoExtraColumns = cols;
      this.optionHideList = this.optionHideList.filter((o) => !isInjected(o.key));
      this.searchOptionList = this.searchOptionList.filter(
        (o) => !isInjected(o.key)
      );
      this.valueHideList = this.valueHideList.filter((k) => !isInjected(k));
      this.defaultValueHideList = this.defaultValueHideList.filter(
        (k) => !isInjected(k)
      );

      const insertBefore = (list, key, item) => {
        const at = list.findIndex((o) => o.key === key);
        if (at === -1) list.push(item);
        else list.splice(at, 0, item);
      };

      cols.forEach((col) => {
        const item = { label: col.label, key: col.key };
        insertBefore(this.optionHideList, "SCTT.AHTA.BTP.ID", item);
        insertBefore(this.searchOptionList, "SCTT.AHTA.BTP.ID", item);
        this.valueHideList.push(col.key);
        this.defaultValueHideList.push(col.key);
      });

      // docs/searchField is module state shared with table.abb.vue and it
      // survives navigation. Leaving it pointed at a column that has just gone
      // away — switching to a company without it, or the setting being turned
      // off — would have the next page silently filter every document by a
      // field it does not offer and show nothing. Fall back to the default.
      const active = this.$store.state.docs.searchField;
      if (isInjected(active) && !cols.some((c) => c.key === active)) {
        this.defaultSearchOptionValue = "objectID";
        this.$store.dispatch("docs/setSearchField", "objectID");
      }
    },
    // Start LAO_DEFAULT_HIDDEN_COLUMNS hidden on a LAO-ONLY company and visible
    // for everyone else, the dual-product company included — see
    // isLaoOnlyCompany. valueHideList is the list of columns currently SHOWN
    // (showColumn() tests membership), so "hidden by default" means leaving the
    // key out of it. defaultValueHideList moves with it, or the "ซ่อน" menu's
    // reset would put the empty columns back.
    //
    // Both directions are handled because the same component serves the next
    // company the user switches to: without the restore, visiting a Lao-only
    // company and then a Thai one would leave the Thai company missing two
    // columns it has every right to see. Nothing is persisted (the menu's choice
    // lives in component data only), so this runs on every mount and is the whole
    // of the default.
    applyLaoDefaultHiddenColumns(isLaoOnly) {
      this.valueHideList = applyLaoHiddenDefaults(this.valueHideList, isLaoOnly);
      this.defaultValueHideList = applyLaoHiddenDefaults(
        this.defaultValueHideList,
        isLaoOnly
      );
    },
    // Read a column value off a document. Optional columns live inside the
    // @DocData map, so the dotted key has to be walked rather than used as a
    // literal property name the way "SCTT.AHTA.BTP.ID" is.
    docColumnValue(doc, key) {
      return _.get(doc, key.split("."));
    },
    clearValue: function () {
      this.$store.dispatch("docs/updatePage", { page: 1 });
    },
    clearSelectList: function () {
      this.$store.dispatch("docs/setSelectedList", { selectedList: [] });
    },
    errorsMessage: function (errors) {
      return getErrorMessage(errors);
    },
    clearAllSelectList: function () {
      this.selectAll = false;
      this.$store.dispatch("docs/setSelectedList", { selectedList: [] });
      this.clearSelectList();
    },
    holdDownloadAndSendEmail: function (status) {
      return companyStatus.holdDownloadAndSendEmail(status);
    },
    autocompleteAddEmail: function (k, value) {
      this.emailInput = "";
      if (value && !this.emailList[k].includes(value)) {
        Vue.observable(this.emailList[k].push(value));
      }
    },
    removeEmail: function (k) {
      this.emailList[k] = [...this.emailValues[k]];
      Vue.observable(this.emailList[k]);
    },
    resetDateSearch: function () {
      this.$store.dispatch("docs/setFromDate", "");
      this.$store.dispatch("docs/setToDate", "");
      this.$store.dispatch("docs/updateKeyword", "");
      this.fromDateVal = null;
      this.toDateVal = null;
      this.clearValue();
    },
  },
};
</script>

<style lang="scss">
#table-firebase {
  .filter-up {
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  th {
    img {
      width: 10px;
      height: 8px;
    }
  }

  .border-right {
    border-right: 1px solid #ffffff;
  }

  //add arrow to tooltip
  //.v-tooltip__content::before {
  //  content: '';
  //  position: absolute;
  //  display: block;
  //  width: 0px;
  //  left: 50%;
  //  bottom: 6px;
  //  border: 5px solid transparent;
  //  border-bottom: 0;
  //  border-top: 8px solid #191919;
  //  transform: translate(-50%, calc(100% + 5px));
  //}

  .v-text-field fieldset,
  .v-text-field .v-input__control,
  .v-text-field .v-input__slot {
    border-radius: 10px !important;
    border-color: #c4c4c4;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 270px;
  }

  .search-box {
    width: 250px;
  }

  .remove-checkbox-padding {
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }

  .doc-id {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-text-field__details {
    display: none !important;
  }

  .icon-sort {
    cursor: pointer;
  }

  .v-card__title .v-messages {
    min-height: 11px;
  }

  .order-by-row {
    cursor: pointer;
  }

  .icon-downloaded {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }

  th,
  td {
    white-space: nowrap;
  }

  .check-box-flex {
    display: flex;
    align-items: center;
  }

  tr {
    &.tr-data {
      cursor: pointer;
    }
  }

  .icon-button {
    height: -webkit-fill-available;
  }
}

.numberRow {
  min-width: 3rem !important;
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.disabled-btn {
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}

.v-btn {
  letter-spacing: unset !important;
}

.btn-choose {
  margin-right: 20px;
}

.btn-submit {
  margin-right: 20px;
}

/* Import Dialog Enhancements */
.import-dialog-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.import-dialog-header {
  border-radius: 0 !important;
}

/* Import Dialog Styles - Moved to inline styles for better maintainability */
</style>
